var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// ../internal/src/providers/attachment-provider/attachment-provider.tsx
import React4 from "react";

// ../internal/src/helpers/constants.tsx
var maxFileSizeinInteger = 25e6;
var excessCharactersThreshold = 20;
var VacServiceHeaders = {
  BusinessSegmentId: "Business-Segment-Id",
  ChannelOriginId: "Channel-Origin-Id",
  XCpAuthorization: "x-cp-authorization",
  IsCgpEnabled: "Is-Cgp-Enabled"
};
var AttachmentOperationTypes = {
  DOWNLOAD: "download",
  UPLOAD: "upload"
};
var LocalizationContentKeys = {
  ATTACHMENT: "attachment",
  DIALOG: "dialog",
  ACTIVITY_INDICATOR: "activityIndicator",
  ERROR: "error",
  MESSAGE: "message",
  PARTICIPANT: "participant"
};
var DebugIdToken = "_DEBUG_";

// ../internal/src/hooks/use-authentication-config.tsx
import React2 from "react";
import { useProvidedState } from "@shared-ui/provided-state-context";

// ../internal/src/helpers/query-utils.ts
function getConversationContext(conversationId, participantId, conversationType) {
  var _a;
  return {
    conversationId,
    participantId,
    conversationType,
    attributes: typeof window !== "undefined" && ((_a = window.location) == null ? void 0 : _a.href) ? {
      currentPageUrl: window.location.href
    } : null
  };
}
function getAuthenticationConfig(orchestratorState, chatInstance, channelOriginId) {
  var _a, _b;
  return {
    authToken: (_a = orchestratorState == null ? void 0 : orchestratorState.vacConfig) == null ? void 0 : _a.authToken,
    channelOriginId: ((_b = chatInstance == null ? void 0 : chatInstance.chatConfig) == null ? void 0 : _b.channelOriginId) || channelOriginId
  };
}
function getClientContext() {
  if (typeof Intl !== "undefined") {
    return {
      timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone
    };
  }
  return void 0;
}

// ../internal/src/providers/vac-id/vac-id-provider.tsx
import React, { useState } from "react";
import { v4 as uuid } from "uuid";
var VacIdContext = React.createContext(void 0);
var VacIdProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */React.createElement(VacIdContext.Provider, {
    value
  }, children);
};
VacIdProvider.displayName = "VacIdProvider";
var useVacId = () => {
  const vacId = React.useContext(VacIdContext);
  if (!vacId) {
    throw new Error("useVacId must be used with VacIdProvider");
  }
  return vacId;
};
var withVacId = WrappedComponent => {
  const Wrapper = props => {
    const {
      vacId: vacIdProp
    } = props;
    const [vacId] = useState(vacIdProp || uuid());
    const updatedProps = vacIdProp ? props : __spreadProps(__spreadValues({}, props), {
      vacId
    });
    return /* @__PURE__ */React.createElement(VacIdProvider, {
      value: vacId
    }, /* @__PURE__ */React.createElement(WrappedComponent, __spreadValues({}, updatedProps)));
  };
  Wrapper.displayName = "withVacId";
  return Wrapper;
};

// ../internal/src/hooks/use-authentication-config.tsx
function useAuthenticationConfig(channelOriginId) {
  var _a;
  const [state] = useProvidedState();
  const vacId = useVacId();
  const orchestratorState = state == null ? void 0 : state.orchestratorState;
  const chatInstance = (_a = state == null ? void 0 : state.chatInstancesState) == null ? void 0 : _a[vacId];
  const authenticationConfig = React2.useMemo(() => getAuthenticationConfig(orchestratorState, chatInstance, channelOriginId), [orchestratorState, chatInstance, channelOriginId]);
  return [authenticationConfig];
}

// ../internal/src/hooks/use-chat-instance-state.tsx
import React3 from "react";
import { useProvidedState as useProvidedState2 } from "@shared-ui/provided-state-context";
function useChatInstanceState() {
  var _a;
  const vacId = useVacId();
  const [state, dispatch] = useProvidedState2();
  const chatInstance = (_a = state == null ? void 0 : state.chatInstancesState) == null ? void 0 : _a[vacId];
  const chatInstanceDispatch = React3.useCallback(({
    type,
    payload: payload2
  }) => {
    const chatInstanceAction = {
      type,
      payload: __spreadProps(__spreadValues({}, payload2), {
        vacId
      })
    };
    dispatch(chatInstanceAction);
  }, [dispatch, vacId]);
  return [chatInstance, chatInstanceDispatch];
}

// ../internal/src/providers/attachment-provider/attachment-provider.tsx
var defaults = {
  attachmentConfig: {}
};
var AttachmentContext = React4.createContext(defaults);
var AttachmentProvider = props => {
  const {
    children,
    attachmentConfig
  } = props;
  return /* @__PURE__ */React4.createElement(AttachmentContext.Provider, {
    value: {
      attachmentConfig
    }
  }, children);
};
AttachmentProvider.displayName = "AttachmentProvider";
var useAttachment = () => {
  const {
    attachmentConfig
  } = React4.useContext(AttachmentContext);
  const [authenticationConfig] = useAuthenticationConfig();
  if (!attachmentConfig) {
    throw new Error("useAttachment requires and must be used within AttachmentProvider");
  }
  const uploadFile = async file => {
    const {
      partnerId,
      conversationId
    } = attachmentConfig;
    const requestHeaders = new Headers();
    requestHeaders.set(VacServiceHeaders.XCpAuthorization, `${authenticationConfig == null ? void 0 : authenticationConfig.authToken}`);
    const urlPrefix = window.location.host.includes("localhost") ? "https://wwwexpediacom.trunk.sb.karmalab.net" : "";
    const fileFormData = new FormData();
    fileFormData.append("upload", file, file.name);
    const response = await fetch(`${urlPrefix}/vacservice/api/v2/partners/${partnerId}/conversations/${conversationId}/files/upload`, {
      method: "POST",
      body: fileFormData,
      headers: requestHeaders
    });
    const result = await response.json();
    return result;
  };
  const downloadFile = async mediaUrl => {
    const requestHeaders = new Headers();
    requestHeaders.set(VacServiceHeaders.XCpAuthorization, `${authenticationConfig == null ? void 0 : authenticationConfig.authToken}`);
    const urlPrefix = window.location.host.includes("localhost") ? "https://wwwexpediacom.trunk.sb.karmalab.net" : "";
    const response = await fetch(`${urlPrefix}${mediaUrl}`, {
      method: "GET",
      headers: requestHeaders
    });
    const result = await response.json();
    return result;
  };
  return [uploadFile, downloadFile];
};
var withAttachment = WrappedComponent => {
  const Wrapper = props => {
    const [chatInstance] = useChatInstanceState();
    const {
      chatConfig
    } = chatInstance || {};
    const conversationId = chatInstance == null ? void 0 : chatInstance.activeConversationId;
    const {
      partnerGuid: partnerId
    } = chatConfig || {};
    return /* @__PURE__ */React4.createElement(AttachmentProvider, {
      attachmentConfig: {
        partnerId,
        conversationId
      }
    }, /* @__PURE__ */React4.createElement(WrappedComponent, __spreadValues({}, props)));
  };
  Wrapper.displayName = "withAttachment";
  return Wrapper;
};

// ../internal/src/providers/registered-operations/registered-operations-provider.tsx
import React5, { useMemo } from "react";
var DEFAULT = {
  registry: {},
  update: () => null
};
var RegisteredOperationsContext = React5.createContext(DEFAULT);
var RegisteredOperationsProvider = ({
  value,
  children
}) => {
  const [registry4, setRegistry] = React5.useState(value != null ? value : {});
  return /* @__PURE__ */React5.createElement(RegisteredOperationsContext.Provider, {
    value: useMemo(() => ({
      registry: registry4,
      update: setRegistry
    }), [registry4, setRegistry])
  }, children);
};
RegisteredOperationsProvider.displayName = "RegisteredOperationsProvider";
var useOperation = o => {
  var _a;
  const operations = React5.useContext(RegisteredOperationsContext);
  if (!operations) {
    throw new Error("useOperation requires and must be used within RegisteredOperationsProvider");
  }
  const {
    registry: registry4
  } = operations;
  return (_a = registry4[o]) != null ? _a : null;
};
var useOperationsRegistry = newRegistry => {
  const operations = React5.useContext(RegisteredOperationsContext);
  if (!operations) {
    throw new Error("useOperation requires and must be used within RegisteredOperationsProvider");
  }
  const {
    registry: registry4,
    update
  } = operations;
  update(Object.assign(registry4, newRegistry));
};
var withRegisteredOperations = WrappedComponent => {
  const Wrapper = props => {
    const {
      value
    } = props;
    const [registry4] = React5.useState(value || {});
    const updatedProps = value ? props : __spreadProps(__spreadValues({}, props), {
      registry: registry4
    });
    return /* @__PURE__ */React5.createElement(RegisteredOperationsProvider, {
      value: registry4
    }, /* @__PURE__ */React5.createElement(WrappedComponent, __spreadValues({}, updatedProps)));
  };
  Wrapper.displayName = "withRegisteredOperations";
  return Wrapper;
};

// src/components/chat/chat.tsx
import React94, { useState as useState5 } from "react";
import { v4 as uuidv49 } from "uuid";
import { EGDSLayoutFlex as EGDSLayoutFlex37 } from "@egds/react-core/layout-flex";
import { EGDSLoader as EGDSLoader4 } from "@egds/react-core/loader";
import { EGDSSkipLink } from "@egds/react-core/skip-link";
import { EGDSSpacing as EGDSSpacing25 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading9 } from "@egds/react-core/text";
import { EGDSToast } from "@egds/react-core/toast";
import { ChatContainer, ChatContainerContent, ChatContainerFooter, ChatContainerHeader, ScrollChatContentToBottomEvent as ScrollChatContentToBottomEvent2 } from "@egds/react-virtual-agent-control";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useSignalPublisher as useSignalPublisher9, useSignalSubscriber as useSignalSubscriber6 } from "@shared-ui/core-signal-manager/context";
import { DialogProvider } from "@shared-ui/dialog-context";
import { useLoggerEvents as useLoggerEvents3 } from "@shared-ui/logger-context";
import { useProvidedState as useProvidedState22 } from "@shared-ui/provided-state-context";
import { VacChatMessageSentSignal as VacChatMessageSentSignal2, VacChatWindowVisibleSignal, VacConnectedSignal as VacConnectedSignal2, VacConversationCreatedSignal as VacConversationCreatedSignal2, VacCreateConversationSignal, VirtualAgentControlMessageType } from "@shared-ui/retail-signals-virtual-agent";

// ../internal/src/components/errors/full-page-error-view.tsx
import React8, { useEffect } from "react";
import { EGDSButtonSize, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSText } from "@egds/react-core/text";
import { EGDSToolbar } from "@egds/react-core/toolbar";

// ../internal/src/helpers/clickstream-events-payload.ts
var VIRTUAL_AGENT_ICON_VIEWED = {
  event: {
    event_name: "virtual_agent_icon.viewed",
    event_type: "Impression",
    event_category: "virtual_agent.vac_sdui",
    event_version: "3.3.0"
  }
};
var VIRTUAL_AGENT_ICON_SELECTED = {
  event: {
    event_name: "virtual_agent_icon.selected",
    event_type: "Interaction",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0",
    action_location: "first_action_button_icon"
  }
};
var VIRTUAL_AGENT_OPENED = {
  event: {
    event_name: "virtual_agent.opened",
    event_type: "Outcome",
    event_category: "virtual_agent.vac_sdui",
    event_version: "5.1.0",
    action_location: "first_action_button_icon"
  }
};
var VIRTUAL_AGENT_OPENED_FAILED = {
  event: {
    event_name: "virtual_agent_opened.failed",
    event_type: "Outcome",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var VIRTUAL_AGENT_CLOSED = {
  event: {
    event_name: "virtual_agent.closed",
    event_type: "Interaction",
    event_category: "virtual_agent.vac_sdui",
    event_version: "5.7.0",
    action_location: "close_action_button"
  }
};
var VIRTUAL_AGENT_ERROR_BANNER_PRESENTED = {
  event: {
    event_name: "virtual_agent_error_banner.presented",
    event_type: "Impression",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var VIRTUAL_AGENT_RECONNECT_SELECTED = {
  event: {
    event_name: "virtual_agent_reconnect.selected",
    event_type: "Interaction",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var VIRTUAL_AGENT_ATTACHMENT_PRESETED = {
  event: {
    event_name: "virtual_agent_attachment.presented",
    event_type: "Impression",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var VIRTUAL_AGENT_ATTACHMENT_SELECTED = {
  event: {
    event_name: "virtual_agent_attachment.selected",
    event_type: "Interaction",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var ATTACHMENT_FILE_DOWNLOAD_SUBMITTED = {
  event: {
    event_name: "attachment_file_download.submitted",
    event_type: "Interaction",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var ATTACHMENT_FILE_DOWNLOAD_SUCCEEDED = {
  event: {
    event_name: "attachment_file_download.succeeded",
    event_type: "Outcome",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var ATTACHMENT_FILE_DOWNLOAD_FAILED = {
  event: {
    event_name: "attachment_file_download.failed",
    event_type: "Outcome",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var ATTACHMENT_FILE_PREVIEW_SELECTED = {
  event: {
    event_name: "attachment_file_preview.selected",
    event_type: "Intercation",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var ATTACHMENT_FILE_UPLOAD_SUCCEEDED = {
  event: {
    event_name: "attachment_file_upload.succeeded",
    event_type: "Outcome",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var ATTACHMENT_FILE_UPLOAD_FAILED = {
  event: {
    event_name: "attachment_file_upload.failed",
    event_type: "Outcome",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var VIRTUAL_AGENT_SETTINGS_MENU_PRESENTED = {
  event: {
    event_name: "virtual_agent_settings_menu.presented",
    event_type: "Impression",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var VIRTUAL_AGENT_SETTINGS_MENU_SELECTED = {
  event: {
    event_name: "virtual_agent_settings_menu.selected",
    event_type: "Interaction",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var VIRTUAL_AGENT_SETTINGS_MENU_ITEM_PRESENTED = {
  event: {
    event_name: "virtual_agent_settings_menu_item.presented",
    event_type: "Impression",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var VIRTUAL_AGENT_SETTINGS_MENU_ITEM_SELECTED = {
  event: {
    event_name: "virtual_agent_settings_menu_item.selected",
    event_type: "Interaction",
    event_category: "virtual_agent.vac_sdui",
    event_version: "1.0.0"
  }
};
var EVENT_MAPPER = {
  VIRTUAL_AGENT_ICON_VIEWED,
  VIRTUAL_AGENT_ICON_SELECTED,
  VIRTUAL_AGENT_OPENED,
  VIRTUAL_AGENT_OPENED_FAILED,
  VIRTUAL_AGENT_CLOSED,
  VIRTUAL_AGENT_ERROR_BANNER_PRESENTED,
  VIRTUAL_AGENT_RECONNECT_SELECTED,
  VIRTUAL_AGENT_ATTACHMENT_PRESETED,
  VIRTUAL_AGENT_ATTACHMENT_SELECTED,
  ATTACHMENT_FILE_DOWNLOAD_SUBMITTED,
  ATTACHMENT_FILE_DOWNLOAD_SUCCEEDED,
  ATTACHMENT_FILE_DOWNLOAD_FAILED,
  ATTACHMENT_FILE_PREVIEW_SELECTED,
  ATTACHMENT_FILE_UPLOAD_SUCCEEDED,
  ATTACHMENT_FILE_UPLOAD_FAILED,
  VIRTUAL_AGENT_SETTINGS_MENU_PRESENTED,
  VIRTUAL_AGENT_SETTINGS_MENU_SELECTED,
  VIRTUAL_AGENT_SETTINGS_MENU_ITEM_PRESENTED,
  VIRTUAL_AGENT_SETTINGS_MENU_ITEM_SELECTED
};

// ../internal/src/helpers/build-clickstream-data.ts
var buildClickstreamEventPaylaod = (eventKey, conversationId, conversationType) => {
  if (EVENT_MAPPER[eventKey]) {
    const data = __spreadProps(__spreadValues({}, EVENT_MAPPER[eventKey]), {
      virtual_agent: {
        conversationId,
        conversationType
      }
    });
    return data;
  }
};
var buildClickstreamAdditionalContextPayload = (eventKey, conversationId, conversationType, additionalContext) => {
  if (EVENT_MAPPER[eventKey]) {
    const data = __spreadProps(__spreadValues({}, EVENT_MAPPER[eventKey]), {
      virtual_agent: {
        conversationId,
        conversationType
      },
      additional_context: additionalContext
    });
    return data;
  }
};
var buildClickstreamErrorListPayload = (eventKey, conversationId, conversationType, errorPayload) => {
  const data = __spreadProps(__spreadValues({}, EVENT_MAPPER[eventKey]), {
    virtual_agent: {
      conversationId,
      conversationType
    },
    error_list: [{
      error: errorPayload
    }]
  });
  return data;
};
var buildClickstreamAdditionalContextErrorPayload = (eventKey, conversationId, conversationType, additionalContext, errorPayload) => {
  const data = __spreadProps(__spreadValues({}, EVENT_MAPPER[eventKey]), {
    virtual_agent: {
      conversationId,
      conversationType
    },
    additional_context: additionalContext,
    error_list: [{
      error: errorPayload
    }]
  });
  return data;
};

// ../internal/src/hooks/analytics/use-analytics.ts
import { useCallback } from "react";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var useAnalytics = () => {
  const track = useEgClickstream();
  const {
    context
  } = useBexApi();
  const trackEvent = useCallback(analyticsObject => {
    try {
      const eventPayload = analyticsObject;
      const analyticsTrackerPayload = __spreadValues({}, eventPayload);
      track(analyticsTrackerPayload);
    } catch (e) {
      console.log("e :>> ", e);
    }
  }, [context, track]);
  return {
    trackEvent
  };
};

// ../internal/src/hooks/use-conversation-state.tsx
import React6 from "react";
import { useProvidedState as useProvidedState3 } from "@shared-ui/provided-state-context";
function useConversationState() {
  const [chatInstance] = useChatInstanceState();
  const [state, dispatch] = useProvidedState3();
  const conversationId = chatInstance == null ? void 0 : chatInstance.activeConversationId;
  const conversation = conversationId ? state.conversationsState.conversationsById[conversationId] : void 0;
  const conversationDispatch = React6.useCallback(({
    type,
    payload: payload2
  }) => {
    const conversationAction = {
      type,
      payload: __spreadProps(__spreadValues({}, payload2), {
        conversationId
      })
    };
    dispatch(conversationAction);
  }, [dispatch, conversationId]);
  const conversationContext = React6.useMemo(() => getConversationContext(conversationId, conversation == null ? void 0 : conversation.participantId, conversation == null ? void 0 : conversation.type), [conversationId, conversation == null ? void 0 : conversation.participantId, conversation == null ? void 0 : conversation.type]);
  return [conversation, conversationDispatch, conversationContext];
}

// ../internal/src/hooks/use-error-state.tsx
import React7 from "react";
import { useProvidedState as useProvidedState4 } from "@shared-ui/provided-state-context";

// ../internal/src/store/errors/constants.tsx
var ORCHESTRATOR = "orchestrator";
var defaultErrorBanner = {
  header: "Something went wrong",
  text: "Please refresh the page or try again later",
  retryText: null
};
var defaultErrorFullPageView = __spreadProps(__spreadValues({}, defaultErrorBanner), {
  __typename: "VirtualAgentControlErrorFullPageView",
  icon: {
    __typename: "Icon",
    id: "error",
    description: "error icon",
    title: "error icon"
  }
});
var connectionLostErrorFullPageView = {
  __typename: "VirtualAgentControlErrorFullPageView",
  header: "We're having trouble loading",
  text: "Please refresh the page or try again later",
  retryText: null,
  icon: {
    __typename: "Icon",
    id: "error",
    description: "error icon",
    title: "error icon"
  }
};
var connectionLostErrorBanner = {
  __typename: "VirtualAgentControlErrorBanner",
  header: "We lost connection",
  text: "Try to reconnect or refresh the page later",
  retryText: null
};
var fetchCredentialsFailedErrorBanner = {
  __typename: "VirtualAgentControlErrorBanner",
  text: "Please refresh the page to continue",
  header: "Your session expired",
  retryText: null
};
var fetchCredentialsFailedErrorFullPageView = __spreadProps(__spreadValues({}, fetchCredentialsFailedErrorBanner), {
  __typename: "VirtualAgentControlErrorFullPageView",
  icon: {
    __typename: "Icon",
    description: "error",
    id: "error",
    title: "error"
  }
});
var errorBannerPlaceholders = {
  TRY_TO_RECONNECT: "{tryToReconnect}",
  RETRY: "{retryText}",
  DISMISS: "{dismissText}"
};
function getConnectionLostError(header) {
  if (header === connectionLostErrorFullPageView.header || header === connectionLostErrorBanner.header) {
    return connectionLostErrorBanner.header;
  }
}

// ../internal/src/hooks/use-error-state.tsx
function useChatInstanceError() {
  var _a, _b, _c, _d;
  const [state, dispatch] = useProvidedState4();
  const vacId = useVacId();
  const orchestratorError = (_a = state.errorsState) == null ? void 0 : _a[ORCHESTRATOR];
  const chatInstanceError = (_b = state.errorsState) == null ? void 0 : _b[vacId];
  const activeConversationId = (_d = (_c = state.chatInstancesState) == null ? void 0 : _c[vacId]) == null ? void 0 : _d.activeConversationId;
  let errorBanner;
  let fullPageView;
  if (orchestratorError == null ? void 0 : orchestratorError.active) {
    if (activeConversationId) {
      errorBanner = orchestratorError.errorComponent.errorBanner;
    } else {
      fullPageView = orchestratorError.errorComponent.fullPageView;
    }
  } else if (chatInstanceError == null ? void 0 : chatInstanceError.active) {
    errorBanner = chatInstanceError.errorComponent.errorBanner;
    fullPageView = chatInstanceError.errorComponent.fullPageView;
  }
  const chatInstanceErrorDispatch = React7.useCallback(({
    type,
    payload: payload2
  }) => {
    dispatch({
      type,
      payload: __spreadProps(__spreadValues({}, payload2), {
        source: vacId
      })
    });
  }, [dispatch, vacId]);
  return [errorBanner, fullPageView, chatInstanceErrorDispatch];
}

// ../internal/src/components/errors/full-page-error-view.tsx
var VirtualAgentControlFullPageErrorView = ({
  onClose,
  embedded
}) => {
  const [, fullPageView] = useChatInstanceError();
  const {
    trackEvent
  } = useAnalytics();
  const [conversation] = useConversationState();
  useEffect(() => {
    if (fullPageView) {
      const errorTracker = {};
      if (fullPageView == null ? void 0 : fullPageView.header) {
        errorTracker.error_name = getConnectionLostError(fullPageView.header) || header;
      } else {
        errorTracker.error_description = (fullPageView == null ? void 0 : fullPageView.text) || "Something went wrong";
      }
      trackEvent(buildClickstreamErrorListPayload("VIRTUAL_AGENT_OPENED_FAILED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, errorTracker));
    }
  }, [fullPageView]);
  if (!fullPageView) {
    return null;
  }
  const {
    header = "Something went wrong",
    text = "Please refresh the page or try again later",
    icon
  } = fullPageView || {};
  const {
    id = "error",
    description = "error icon"
  } = icon || {};
  return /* @__PURE__ */React8.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      top: "zero",
      left: "zero",
      right: "zero",
      bottom: "zero"
    }
  }, !embedded && /* @__PURE__ */React8.createElement(EGDSToolbar, null, /* @__PURE__ */React8.createElement(EGDSTertiaryButton, {
    size: EGDSButtonSize.LARGE,
    "aria-label": "close",
    onClick: onClose,
    "data-stid": "close"
  }, /* @__PURE__ */React8.createElement(EGDSIcon, {
    name: "remove",
    id: "remove"
  }))), /* @__PURE__ */React8.createElement(EGDSCard, null, /* @__PURE__ */React8.createElement(EGDSLayoutFlex, {
    space: "one",
    direction: "column",
    alignItems: "center",
    justifyContent: "center",
    blockSize: "full_size"
  }, /* @__PURE__ */React8.createElement("div", {
    "aria-hidden": "true"
  }, /* @__PURE__ */React8.createElement(EGDSIcon, {
    id: `vac-full-page-error-${id}`,
    name: id,
    description,
    size: EGDSIconSize.XLARGE
  })), /* @__PURE__ */React8.createElement(EGDSText, {
    align: "center",
    size: 500,
    weight: "bold"
  }, header), /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, {
    grow: 0
  }, /* @__PURE__ */React8.createElement(EGDSText, {
    size: 300,
    weight: "regular",
    inline: true
  }, text)))));
};

// ../internal/src/components/errors/error-banner.tsx
import React9, { useEffect as useEffect2 } from "react";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { useSignalPublisher } from "@shared-ui/core-signal-manager/context";
import { useProvidedState as useProvidedState5 } from "@shared-ui/provided-state-context";
import { VacReconnectSignal } from "@shared-ui/retail-signals-virtual-agent";
var VirtualAgentControlErrorBanner = () => {
  var _a, _b, _c, _d;
  const [errorBanner, fullPageView, chatInstanceErrorDispatch] = useChatInstanceError();
  const {
    publish
  } = useSignalPublisher();
  const [state] = useProvidedState5();
  const {
    trackEvent
  } = useAnalytics();
  const [conversation] = useConversationState();
  const errorStrings = (_b = (_a = state.errorsState) == null ? void 0 : _a.orchestrator) == null ? void 0 : _b.offlineLocalizedErrorStrings;
  useEffect2(() => {
    if (errorBanner && !fullPageView) {
      const errorTracker = {};
      if (errorBanner == null ? void 0 : errorBanner.header) {
        errorTracker.error_name = getConnectionLostError(errorBanner.header) || errorBanner.header;
      } else {
        errorTracker.error_description = (errorBanner == null ? void 0 : errorBanner.text) || "Something went wrong";
      }
      trackEvent(buildClickstreamErrorListPayload("VIRTUAL_AGENT_ERROR_BANNER_PRESENTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, errorTracker));
    }
  }, [errorBanner, fullPageView]);
  if (!errorBanner || fullPageView) {
    return null;
  }
  const {
    header = "Something went wrong",
    text = "Please refresh the page or try again later",
    retryText = "Try again",
    dismissText = "Dismiss",
    icon
  } = errorBanner || {};
  const handleRefreshClick = () => {
    trackEvent(buildClickstreamEventPaylaod("VIRTUAL_AGENT_RECONNECT_SELECTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type));
    publish(new VacReconnectSignal("VAC_RECONNECT" /* VAC_Reconnect */, null));
  };
  const handleRetryClick = () => {
    chatInstanceErrorDispatch({
      type: "CLEAR_ERRORS" /* CLEAR_ERRORS */
    });
  };
  const handleDismissClick = () => {
    chatInstanceErrorDispatch({
      type: "CLEAR_ERRORS" /* CLEAR_ERRORS */
    });
  };
  const renderLink = (linkText, onClick) => /* @__PURE__ */React9.createElement(EGDSLink, {
    inline: true,
    onClick,
    key: linkText
  }, /* @__PURE__ */React9.createElement("button", {
    type: "button"
  }, linkText));
  const renderTextWithLinks = () => {
    const parts = text.replaceAll("$", "").split(/(\{tryToReconnect\}|\{retryText\}|\{dismissText\})/);
    return /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, null, parts.map((part, index) => {
      switch (part) {
        case errorBannerPlaceholders.TRY_TO_RECONNECT:
          return renderLink((errorStrings == null ? void 0 : errorStrings.tryToReconnect) || "Reconnect", handleRefreshClick);
        case errorBannerPlaceholders.RETRY:
          return renderLink(retryText, handleRetryClick);
        case errorBannerPlaceholders.DISMISS:
          return renderLink(dismissText, handleDismissClick);
        default:
          return part.startsWith(" ") ? /* @__PURE__ */React9.createElement(EGDSSpacing, {
            margin: {
              inlinestart: "one"
            },
            key: `${part}-${index}`
          }, /* @__PURE__ */React9.createElement(EGDSText2, null, part)) : /* @__PURE__ */React9.createElement(EGDSText2, {
            key: `${part}-${index}`
          }, part);
      }
    }));
  };
  return /* @__PURE__ */React9.createElement(EGDSLayoutPosition2, {
    type: "absolute",
    position: {
      left: "two",
      right: "two",
      zindex: "layer1"
    }
  }, /* @__PURE__ */React9.createElement(EGDSSpacing, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React9.createElement("div", null, /* @__PURE__ */React9.createElement(EGDSBanner, {
    theme: "error"
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    alignItems: "center",
    space: "two"
  }, icon && /* @__PURE__ */React9.createElement(EGDSIcon2, {
    name: icon.id,
    id: icon.id,
    description: (_c = icon.description) != null ? _c : void 0,
    title: (_d = icon.title) != null ? _d : void 0,
    spotlight: {
      background: false,
      theme: "standard"
    }
  }), /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    direction: "column",
    space: "two"
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React9.createElement("div", null, /* @__PURE__ */React9.createElement(EGDSHeading, {
    size: 6,
    tag: "h2"
  }, header))), /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem2, null, renderTextWithLinks())))))));
};

// ../internal/src/components/footer/virtual-agent-control-chat-footer.tsx
import React26 from "react";
import { gql as gql14 } from "@apollo/client";
import { v4 as uuidv42 } from "uuid";
import { EGDSButtonSize as EGDSButtonSize3 } from "@egds/react-core/button";
import { EGDSChatTextArea } from "@egds/react-core/input";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { useProvidedState as useProvidedState8 } from "@shared-ui/provided-state-context";

// ../internal/src/helpers/date-utils.ts
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";

// ../internal/src/hooks/use-prefetch-localization-content.tsx
import { gql, useApolloClient } from "@apollo/client";
import Omit from "lodash.omit";
import { useProvidedState as useProvidedState6 } from "@shared-ui/provided-state-context";
var usePrefetchLocalizationContent = localiziedStringKey => {
  var _a, _b;
  const client = useApolloClient();
  const [state] = useProvidedState6();
  if (localiziedStringKey === LocalizationContentKeys.ERROR) {
    const errorStrings = (_b = (_a = state.errorsState) == null ? void 0 : _a.orchestrator) == null ? void 0 : _b.offlineLocalizedErrorStrings;
    return errorStrings;
  }
  const localizationFragment = gql`
    fragment VirtualAgentControlLocalizationContentFragment on VirtualAgentControlLocalizationContent {
      attachment {
        downloadError
        downloadProcessing
        downloadSuccess
        uploadError
        uploadFileSizeError
        uploadProcessing
        uploadSuccess
        outboundAttachmentAccessibilityLabelTemplate
      }
      dialog {
        closeWebviewWindow
      }
      activityIndicator {
        activityIndicatorMessage
        humanTyping
        multipleParticipantsTyping
        virtualAgentTyping
      }
      error {
        havingTroubleLoading
        lostConnection
        refreshOrReconnect
        refreshOrTryLater
        refreshToContinue
        sessionExpired
        somethingWentWrong
        tryToReconnect
        removeExcessCharacters
        removeSingleExcessCharacter
      }
      message {
        separatorToday
        separatorYesterday
        statusNotDelivered
        statusSending
        statusRetry
        statusDelivered
        dcfUnavailableLine1
        dcfUnavailableLine2
        timestampAccessibilityLabelTemplate
      }
      participant {
        typeHumanAgent
        eventJoined
        eventLeft
        typeSupplier
        typeTraveler
        typeVirtualAgent
        outboundMessageContextAccessibilityLabel
      }
    }
  `;
  const cachedLocalizedStringsData = client.readFragment({
    id: "VirtualAgentControlLocalizationContent:vac-localization",
    fragment: localizationFragment
  });
  if (!cachedLocalizedStringsData || !(localiziedStringKey.toUpperCase() in LocalizationContentKeys)) {
    return null;
  }
  return Omit(cachedLocalizedStringsData[localiziedStringKey], ["__typename"]);
};
var use_prefetch_localization_content_default = usePrefetchLocalizationContent;

// ../internal/src/helpers/date-utils.ts
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new argument.constructor(argument.getTime());
  }
  if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  }
  return /* @__PURE__ */new Date(NaN);
}
function addDays(date, amount) {
  const _date = toDate(date);
  if (!amount) {
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}
function startOfDay(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfDayUTC(date) {
  const _date = toDate(date);
  _date.setUTCHours(0, 0, 0, 0);
  return _date;
}
function isSameDay(dateLeft, dateRight) {
  const dateLeftStartOfDay = startOfDay(dateLeft);
  const dateRightStartOfDay = startOfDay(dateRight);
  return +dateLeftStartOfDay === +dateRightStartOfDay;
}
function subDays(date, amount) {
  return addDays(date, -amount);
}
function useLocale() {
  const {
    context: {
      locale
    }
  } = useBexApi2();
  const defaultLocale = "en-US";
  try {
    return locale.split("_").join("-");
  } catch (e) {
    return defaultLocale;
  }
}
function useSessionMarkerLabel(val) {
  const today = new Date(Date.now());
  const yesterday = subDays(today, 1);
  const locale = useLocale();
  const compareDate = new Date(val);
  const messageContent = use_prefetch_localization_content_default(LocalizationContentKeys.MESSAGE);
  if (Number.isNaN(compareDate.valueOf())) {
    return val;
  }
  if (isSameDay(today, compareDate)) {
    return (messageContent == null ? void 0 : messageContent.separatorToday) || "Today";
  }
  if (isSameDay(yesterday, compareDate)) {
    return (messageContent == null ? void 0 : messageContent.separatorYesterday) || "Yesterday";
  }
  return compareDate.toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
function useLocaleDateTimestamp(val) {
  const locale = useLocale();
  const date = new Date(val);
  if (Number.isNaN(date.valueOf())) {
    return val;
  }
  return date.toLocaleTimeString(locale, {
    hour: "numeric",
    minute: "2-digit"
  });
}

// ../internal/src/helpers/utils.tsx
var parseJson = json => {
  try {
    return JSON.parse(json);
  } catch (err) {
    return void 0;
  }
};
var sizeToByteDisplay = size => {
  const sizeAsNumber = Number.parseInt(size, 10);
  if (!Number.isNaN(sizeAsNumber)) {
    const sizeInBytes = Math.ceil(Math.max(0, sizeAsNumber));
    const kb = sizeInBytes / 1024;
    if (kb < 1) {
      return `${sizeInBytes} bytes`;
    }
    const mb = kb / 1024;
    if (mb < 1) {
      return `${Math.round(kb * 10) / 10} KB`;
    }
    return `${Math.round(mb * 10) / 10} MB`;
  }
  return void 0;
};
var decodeFileBytes = ({
  bytes,
  mediaType
}) => {
  const decodedBytes = window.atob(bytes);
  const arrayBuffer = new ArrayBuffer(decodedBytes.length);
  const byteArray = new Uint8Array(arrayBuffer);
  for (let i = 0; i < decodedBytes.length; i += 1) {
    byteArray[i] = decodedBytes.charCodeAt(i);
  }
  const fileToOpen = new Blob([byteArray], {
    type: mediaType
  });
  return window.URL.createObjectURL(fileToOpen);
};
var payload = obj => {
  return Object.entries(obj).reduce((result, event) => result.concat(" ", `${event[0]}="${event[1]}"`), "");
};
function localizeTemplateLiteral(localizationString, literal, value) {
  if (!localizationString) {
    return "";
  }
  return localizationString.replace(`\${${literal}}`, value);
}
function getEventPayloadAnalytics(analyticsPayload, eventName, version) {
  var _a, _b, _c;
  const parsedPayload = JSON.parse(analyticsPayload);
  const versionShorthand = `v${version.split(".")[0]}`;
  return (_c = (_b = (_a = parsedPayload == null ? void 0 : parsedPayload.events) == null ? void 0 : _a[eventName]) == null ? void 0 : _b[versionShorthand]) == null ? void 0 : _c.event_data;
}
function validateInputString(trimmedUserInput, chatInputLimit, charLimitExists, errorLocalizations) {
  const wordsOverLimit = trimmedUserInput.length - chatInputLimit;
  const showTextOverflowError = wordsOverLimit > 0 && charLimitExists;
  const inputLengthString = `${trimmedUserInput.length} / ${chatInputLimit}`;
  const removeExcessCharacters = localizeTemplateLiteral(errorLocalizations == null ? void 0 : errorLocalizations.removeExcessCharacters, "excessCharacters", `${wordsOverLimit}`);
  const primaryErrorText = wordsOverLimit === 1 ? errorLocalizations == null ? void 0 : errorLocalizations.removeSingleExcessCharacter : removeExcessCharacters;
  const validationProp = showTextOverflowError ? "invalid" : "instruction";
  return {
    wordLimitInfoProps: {
      [validationProp]: {
        primary: showTextOverflowError ? primaryErrorText : "",
        secondary: inputLengthString
      }
    },
    showTextOverflowError
  };
}
function isFakeIntent(messagePayload) {
  const parsedPayload = parseJson(messagePayload);
  return (parsedPayload == null ? void 0 : parsedPayload.intent) === "FAKE_INTENT" /* FAKE_INTENT */;
}
function getPartcipantDisplayName(participant) {
  var _a;
  const user = participant == null ? void 0 : participant.user;
  if (!user) {
    return void 0;
  }
  if ((_a = user.attributes) == null ? void 0 : _a.displayNameOverride) {
    return user.attributes.displayNameOverride;
  }
  if (participant.participantType === "Supplier" /* Supplier */) {
    return user.preferredName;
  }
  if (user.firstName) {
    return user.firstName;
  }
  if (user.preferredName) {
    return user.preferredName;
  }
  return user.userName;
}

// ../internal/src/helpers/acceptedTypes.ts
var acceptedMimeTypes = ["image/bmp", "image/gif", "image/jpeg", "image/png", "image/svg+xml", "image/tiff", "image/heic", "text/plain", "application/pdf"];
var acceptedMsOfficeMimeTypes = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.ms-excel", "application/excel", "application/x-excel", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/mspowerpoint", "application/powerpoint", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.oasis.opendocument.text", "application/vnd.oasis.opendocument.presentation", "application/vnd.oasis.opendocument.spreadsheet"];

// ../internal/src/hooks/analytics/impression-tracker.tsx
import React10 from "react";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
var ClicksteamImpressionTracker = ({
  fireImpression,
  children,
  eventData
}) => {
  if (fireImpression) {
    return /* @__PURE__ */React10.createElement(EgClickstreamImpressionTracker, {
      eventData
    }, children);
  }
  return children;
};

// ../internal/src/hooks/use-messages-state.tsx
import React11 from "react";
import { useProvidedState as useProvidedState7 } from "@shared-ui/provided-state-context";
function useMessagesState() {
  var _a;
  const [chatInstance] = useChatInstanceState();
  const [state, dispatch] = useProvidedState7();
  const conversationId = chatInstance == null ? void 0 : chatInstance.activeConversationId;
  const {
    messagesState
  } = state || {};
  const conversationMessages = (_a = messagesState == null ? void 0 : messagesState.messagesByConversationId) == null ? void 0 : _a[conversationId];
  const messagesDispatch = React11.useCallback(({
    type,
    payload: payload2
  }) => {
    const messagesAction = {
      type,
      payload: __spreadProps(__spreadValues({}, payload2), {
        conversationId
      })
    };
    dispatch(messagesAction);
  }, [dispatch, conversationId]);
  return [messagesState, conversationMessages, messagesDispatch];
}

// ../internal/src/hooks/use-send-file-message.tsx
import React12 from "react";
import { v4 as uuidv4 } from "uuid";

// ../internal/src/models/message-creator.tsx
function createOutboundFileMessage(attachmentLink, uniqueAttachmentId, mediaType, status, messageId, outboundMessageContextAccessibilityLabel, mappedFile) {
  return {
    __typename: "VirtualAgentControlOutboundFileMessage",
    status,
    attachmentLink,
    accessibilityLabel: null,
    attachmentMetadata: __spreadProps(__spreadValues({}, mappedFile), {
      uniqueAttachmentId,
      mediaType,
      __typename: "VirtualAgentControlAttachmentData"
    }),
    metadata: {
      __typename: "VirtualAgentControlMessageMetadata",
      messageId,
      timeStamp: null,
      messageContextAccessibilityLabel: outboundMessageContextAccessibilityLabel
    }
  };
}
function createOutboundTextMessage(messageText, status, messageId, outboundMessageContextAccessibilityLabel) {
  return {
    __typename: "VirtualAgentControlOutboundTextMessage",
    primary: messageText,
    status,
    metadata: {
      __typename: "VirtualAgentControlMessageMetadata",
      messageId,
      timeStamp: new Date(Date.now()).toUTCString(),
      messageContextAccessibilityLabel: outboundMessageContextAccessibilityLabel
    }
  };
}
function createOutboundMessageElementGroup(messages) {
  return {
    __typename: "VirtualAgentControlOutboundMessageElementGroup",
    messages,
    status: null
  };
}

// ../internal/src/hooks/use-send-file-message.tsx
function useSendFileMessage() {
  const [uploadFile] = useAttachment();
  const [,, messagesDispatch] = useMessagesState();
  const [conversation] = useConversationState();
  const {
    trackEvent
  } = useAnalytics();
  const messageContent = use_prefetch_localization_content_default(LocalizationContentKeys.MESSAGE);
  const {
    outboundAttachmentAccessibilityLabelTemplate
  } = use_prefetch_localization_content_default(LocalizationContentKeys.ATTACHMENT) || {};
  const {
    outboundMessageContextAccessibilityLabel
  } = use_prefetch_localization_content_default(LocalizationContentKeys.PARTICIPANT) || {};
  const sendFailureAnalytics = (fileType, errorName) => {
    trackEvent(buildClickstreamAdditionalContextErrorPayload("ATTACHMENT_FILE_UPLOAD_FAILED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, {
      user_interface: {
        component_element_name: fileType
      }
    }, {
      error_name: errorName
    }));
  };
  const getFileAttachmentAccessibilityLabel = file => {
    if (!outboundAttachmentAccessibilityLabelTemplate) {
      return "";
    }
    const replaceFileType = localizeTemplateLiteral(outboundAttachmentAccessibilityLabelTemplate, "filetype", file.mediaType);
    return localizeTemplateLiteral(replaceFileType, "filename", file.name);
  };
  const handleSendFileMessage = React12.useCallback((messages, formRef, sendMessage) => {
    var _a;
    messages.forEach(async ({
      file,
      uniqueAttachmentId
    }) => {
      const mappedFile = {
        name: file.name,
        mediaType: file.type,
        mediaUrl: URL.createObjectURL(file),
        size: `${file.size}`,
        uniqueAttachmentId
      };
      const attachmentLink = {
        text: `(${sizeToByteDisplay(mappedFile.size)}) ${mappedFile.name}`,
        disabled: false,
        size: "SMALL" /* SMALL */,
        action: {
          resource: {
            value: mappedFile.mediaUrl,
            __typename: "SelfReferencedURI"
          },
          accessibility: getFileAttachmentAccessibilityLabel(mappedFile),
          target: "EXTERNAL" /* EXTERNAL */,
          useRelativePath: true,
          __typename: "UILinkAction"
        },
        __typename: "EGDSStandardLink"
      };
      const umid = uuidv4();
      const outboundMessage = createOutboundFileMessage(attachmentLink, uniqueAttachmentId, mappedFile.mediaType, messageContent == null ? void 0 : messageContent.statusSending, umid, outboundMessageContextAccessibilityLabel, mappedFile);
      const outboundMessageGroup = createOutboundMessageElementGroup([outboundMessage]);
      messagesDispatch({
        type: "SET_QUICK_REPLIES" /* SET_QUICK_REPLIES */,
        payload: {
          message: []
        }
      });
      messagesDispatch({
        type: "UPLOAD_ATTACHMENT" /* UPLOAD_ATTACHMENT */,
        payload: {
          uniqueAttachmentId,
          message: outboundMessageGroup
        }
      });
      if (file.size > maxFileSizeinInteger) {
        const updatedMessage = {
          status: messageContent == null ? void 0 : messageContent.statusNotDelivered
        };
        sendFailureAnalytics(mappedFile.mediaType, "size_limit_exceeded");
        messagesDispatch({
          type: "UPLOAD_ATTACHMENT_FAILURE" /* UPLOAD_ATTACHMENT_FAILURE */,
          payload: {
            uniqueAttachmentId,
            loading: false,
            hasError: true,
            isSuccess: false
          }
        });
        messagesDispatch({
          type: "UPDATE_OUTBOUND_MESSAGE_ELEMENT" /* UPDATE_OUTBOUND_MESSAGE_ELEMENT */,
          payload: {
            umid,
            outboundMessageData: updatedMessage
          }
        });
      } else {
        try {
          const {
            file_data: {
              file_metadata: {
                id,
                media_url,
                content_type
              }
            }
          } = await uploadFile(file);
          if (id) {
            trackEvent(buildClickstreamAdditionalContextPayload("ATTACHMENT_FILE_UPLOAD_SUCCEEDED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, {
              user_interface: {
                component_element_name: content_type
              }
            }));
            messagesDispatch({
              type: "UPLOAD_ATTACHMENT_SUCCESS" /* UPLOAD_ATTACHMENT_SUCCESS */,
              payload: {
                uniqueAttachmentId,
                loading: false,
                isSuccess: true,
                attachmentMetadata: __spreadProps(__spreadValues({}, mappedFile), {
                  mediaUrl: media_url,
                  uniqueAttachmentId: id
                })
              }
            });
          }
          sendMessage == null ? void 0 : sendMessage({
            messageType: "FILE" /* FILE */,
            attachment: __spreadProps(__spreadValues({}, mappedFile), {
              mediaUrl: media_url,
              uniqueAttachmentId: id
            }),
            umid
          });
        } catch (e) {
          sendFailureAnalytics(mappedFile.mediaType, "network_error");
          messagesDispatch({
            type: "UPLOAD_ATTACHMENT_FAILURE" /* UPLOAD_ATTACHMENT_FAILURE */,
            payload: {
              uniqueAttachmentId,
              loading: false,
              hasError: true
            }
          });
        }
      }
    });
    (_a = formRef.current) == null ? void 0 : _a.reset();
  }, [messagesDispatch, uploadFile]);
  return [handleSendFileMessage];
}

// ../internal/src/components/common/avatar/avatar-group.tsx
import React13 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSAvatarGroup } from "@egds/react-core/avatar";
var fragment = gql2`
  fragment AvatarGroupFragment on AvatarGroup {
    items {
      ...AvatarFragment
    }
  }
  fragment AvatarFragment on Avatar {
    image {
      url
      description
    }
    text
    icon {
      id
    }
  }
`;
var AvatarGroup = ({
  data,
  size = "medium"
}) => {
  const {
    items
  } = data;
  if (items.length === 0) {
    return null;
  }
  const getProps = avatar => {
    const {
      image,
      icon,
      text
    } = avatar;
    if (image) {
      return {
        image: {
          alt: image.description,
          src: image.url
        }
      };
    }
    if (icon == null ? void 0 : icon.id) {
      return {
        icon: icon.id
      };
    }
    if (text) {
      return {
        text
      };
    }
    return {};
  };
  return /* @__PURE__ */React13.createElement(EGDSAvatarGroup, {
    items: items.map(getProps),
    size
  });
};
AvatarGroup.fragment = fragment;
AvatarGroup.displayName = "AvatarGroup";

// ../internal/src/components/common/egds-button/egds-button.tsx
import React14 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2, EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
var fragment2 = gql3`
  fragment EGDSButtonFragment on EGDSButton {
    accessibility
    disabled
    primary
    icon {
      description
      id
      title
    }
  }
`;
var VirtualAgentEGDSButton = ({
  data,
  onClick,
  fullWidth,
  target,
  size,
  href
}) => {
  const {
    disabled,
    primary,
    icon,
    accessibility
  } = data;
  const buttonContent = React14.useMemo(() => {
    var _a, _b, _c, _d;
    if (icon && primary) {
      return /* @__PURE__ */React14.createElement(React14.Fragment, null, /* @__PURE__ */React14.createElement(EGDSSpacing2, {
        margin: {
          inlineend: "two"
        }
      }, /* @__PURE__ */React14.createElement(EGDSIcon3, {
        name: icon.id,
        id: icon.id,
        title: (_a = icon.title) != null ? _a : void 0,
        description: (_b = icon.description) != null ? _b : void 0
      })), primary);
    }
    if (icon) {
      return /* @__PURE__ */React14.createElement(EGDSIcon3, {
        name: icon.id,
        id: icon.id,
        title: (_c = icon.title) != null ? _c : void 0,
        description: (_d = icon.description) != null ? _d : void 0
      });
    }
    if (primary) {
      return /* @__PURE__ */React14.createElement(React14.Fragment, null, primary);
    }
    return null;
  }, [icon, primary]);
  if (!buttonContent) {
    return null;
  }
  const buttonProps = {
    "aria-label": accessibility != null ? accessibility : void 0,
    disabled,
    onClick,
    size: size != null ? size : EGDSButtonSize2.SMALL,
    isFullWidth: fullWidth != null ? fullWidth : false,
    href,
    tag: href ? "a" : "button",
    target
  };
  switch (data.__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React14.createElement(EGDSPrimaryButton, __spreadValues({}, buttonProps), buttonContent);
    case "UISecondaryButton":
      return /* @__PURE__ */React14.createElement(EGDSSecondaryButton, __spreadValues({}, buttonProps), buttonContent);
    case "UITertiaryButton":
      return /* @__PURE__ */React14.createElement(EGDSTertiaryButton2, __spreadValues({}, buttonProps), buttonContent);
    default:
      return null;
  }
};
VirtualAgentEGDSButton.fragment = fragment2;
VirtualAgentEGDSButton.displayName = "VirtualAgentEGDSButton";

// ../internal/src/components/common/egds-standard-link/egds-standard-link.tsx
import React17 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex3 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";

// ../internal/src/components/common/ui-graphic/icon/icon.tsx
import React15 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSIcon as EGDSIcon4, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
var fragment3 = gql4`
  fragment IconFragment on Icon {
    id
    description
    size
    theme
    title
  }
`;
var Icon = ({
  data
}) => {
  const {
    id,
    description,
    size,
    theme,
    title
  } = data;
  const props = {
    name: id,
    id,
    description,
    size: size ? EGDSIconSize2[size] : EGDSIconSize2.SMALL,
    theme: theme != null ? theme : "emphasis" /* emphasis */,
    title: title != null ? title : void 0
  };
  return /* @__PURE__ */React15.createElement(EGDSIcon4, __spreadValues({}, props));
};
Icon.fragment = fragment3;
Icon.displayName = "Icon";

// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
import React16 from "react";
import { gql as gql5 } from "@apollo/client";
var fragment4 = gql5`
  fragment UIGraphicFragment on UIGraphic {
    ...IconFragment
  }
  ${Icon.fragment}
`;
var registry = {
  Icon
};
var UIGraphic = ({
  data
}) => {
  const {
    __typename
  } = data;
  const Component = registry[__typename];
  if (!Component) {
    return null;
  }
  return /* @__PURE__ */React16.createElement(Component, {
    data
  });
};
UIGraphic.fragment = fragment4;
UIGraphic.displayName = "UIGraphic";

// ../internal/src/components/common/egds-standard-link/egds-standard-link.tsx
var fragment5 = gql6`
  fragment EGDSStandardLinkFragment on EGDSStandardLink {
    text
    disabled
    action {
      resource {
        value
      }
    }
    icon {
      ...IconFragment
    }
    iconPosition
  }
  ${Icon.fragment}
`;
var EGDSStandardLink = ({
  data,
  target = "_blank",
  onClick,
  theme = "default",
  rel = ""
}) => {
  const {
    text,
    disabled,
    icon,
    iconPosition,
    action: {
      resource
    }
  } = data;
  const handleClick = React17.useCallback(event => {
    if (!disabled) {
      onClick == null ? void 0 : onClick(event);
    }
  }, [onClick, disabled]);
  return /* @__PURE__ */React17.createElement(EGDSLink2, {
    disabled,
    onClick: handleClick,
    theme
  }, /* @__PURE__ */React17.createElement("a", {
    href: resource.value,
    target,
    rel
  }, /* @__PURE__ */React17.createElement(EGDSLayoutFlex3, {
    direction: iconPosition === "TRAILING" /* TRAILING */ ? "row-reverse" : "row",
    alignItems: "center",
    space: "one"
  }, icon && /* @__PURE__ */React17.createElement(Icon, {
    data: icon
  }), text)));
};
EGDSStandardLink.fragment = fragment5;
EGDSStandardLink.displayName = "EGDSStandardLink";

// ../internal/src/components/common/egds-spannable-text/egds-spannable-text.tsx
import React24 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex5 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";

// ../internal/src/components/common/egds-spannable-text/egds-spannable-inline-content.tsx
import React23 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";

// ../internal/src/components/common/egds-graphic-text/egds-graphic-text.tsx
import React18 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex4 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
var fragment6 = gql7`
  fragment EGDSGraphicTextFragment on EGDSGraphicText {
    graphic {
      ...UIGraphicFragment
    }
    text
    trailingGraphics {
      ...UIGraphicFragment
    }
  }
  ${UIGraphic.fragment}
`;
var EGDSGraphicText = ({
  data
}) => {
  const {
    graphic,
    text,
    trailingGraphics
  } = data;
  return /* @__PURE__ */React18.createElement(EGDSLayoutFlex4, {
    alignItems: "center",
    space: "one"
  }, /* @__PURE__ */React18.createElement(UIGraphic, {
    data: graphic
  }), /* @__PURE__ */React18.createElement(EGDSText3, null, text), /* @__PURE__ */React18.createElement("div", null, (trailingGraphics == null ? void 0 : trailingGraphics.length) ? trailingGraphics.map((element, i) => /* @__PURE__ */React18.createElement(UIGraphic, {
    key: `trailing-graphic-${i}`,
    data: element
  })) : null));
};
EGDSGraphicText.fragment = fragment6;
EGDSGraphicText.displayName = "EGDSGraphicText";

// ../internal/src/components/common/egds-heading/egds-heading.tsx
import React19 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";

// ../internal/src/components/common/egds-heading/__private/heading-map.ts
var headingTagMapper = {
  ["H1" /* H1 */]: "h1",
  ["H2" /* H2 */]: "h2",
  ["H3" /* H3 */]: "h3",
  ["H4" /* H4 */]: "h4",
  ["H5" /* H5 */]: "h5",
  ["H6" /* H6 */]: "h6",
  ["H7" /* H7 */]: "h6",
  ["H8" /* H8 */]: "h6"
};

// ../internal/src/components/common/egds-heading/egds-heading.tsx
var fragment7 = gql8`
  fragment EGDSHeadingFragment on EGDSHeading {
    text
    headingType
  }
`;
var VirtualAgentEGDSHeading = ({
  data
}) => {
  const {
    headingType,
    text
  } = data;
  const headingTag = headingType ? headingTagMapper[headingType] : void 0;
  return /* @__PURE__ */React19.createElement(EGDSHeading2, {
    tag: headingTag
  }, text);
};
VirtualAgentEGDSHeading.fragment = fragment7;
VirtualAgentEGDSHeading.displayName = "VirtualAgentEGDSHeading";

// ../internal/src/components/common/egds-inline-link/egds-inline-link.tsx
import React20 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";

// ../internal/src/components/common/__private/link-map.ts
import { EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
var linkSizeMapper = {
  ["SMALL" /* SMALL */]: "small",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["LARGE" /* LARGE */]: "large"
};
var iconSizeMapper = {
  [EGDSIconSize3.SMALL]: "small",
  [EGDSIconSize3.MEDIUM]: "medium",
  [EGDSIconSize3.LARGE]: "large",
  [EGDSIconSize3.EXTRA_SMALL]: "xsmall",
  [EGDSIconSize3.XLARGE]: "xlarge"
};
var UILinkTargetMap = {
  ["EXTERNAL" /* EXTERNAL */]: "_blank",
  ["INTERNAL" /* INTERNAL */]: "_self"
};

// ../internal/src/components/common/egds-inline-link/egds-inline-link.tsx
var fragment8 = gql9`
  fragment EGDSInlineLinkFragment on EGDSInlineLink {
    text
    size
    action {
      resource {
        value
      }
      accessibility
      useRelativePath
      target
    }
    disabled
  }
`;
var EGDSInlineLink = ({
  data,
  onClick
}) => {
  const {
    text,
    disabled,
    action: {
      resource: {
        value
      },
      accessibility,
      useRelativePath,
      target
    },
    size
  } = data;
  const handleClick = React20.useCallback(event => {
    if (!disabled) {
      onClick == null ? void 0 : onClick(event);
    }
  }, [onClick, disabled]);
  return /* @__PURE__ */React20.createElement(EGDSLink3, {
    disabled,
    onClick: handleClick,
    inline: true,
    size: linkSizeMapper[size]
  }, /* @__PURE__ */React20.createElement("a", {
    href: value,
    target
  }, text));
};
EGDSInlineLink.fragment = fragment8;
EGDSInlineLink.displayName = "EGDSStandardLink";

// ../internal/src/components/common/egds-plain-text/egds-plain-text.tsx
import React21 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
var fragment9 = gql10`
  fragment EGDSPlainTextFragment on EGDSPlainText {
    text
  }
`;
var EGDSPlainText = ({
  inline,
  data
}) => {
  const {
    text
  } = data;
  return /* @__PURE__ */React21.createElement(EGDSText4, {
    inline
  }, text);
};
EGDSPlainText.fragment = fragment9;
EGDSPlainText.displayName = "EGDSPlainText";

// ../internal/src/components/common/egds-spannable-text/egds-stylized-text.tsx
import React22 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";

// ../internal/src/components/common/egds-spannable-text/__private/text-theme.ts
var textThemeMapper = {
  ["LOYALTY" /* LOYALTY */]: "loyalty",
  ["INVERSE" /* INVERSE */]: "inverse",
  ["NEGATIVE" /* NEGATIVE */]: "negative",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["PRIMARY" /* PRIMARY */]: "emphasis",
  ["SECONDARY" /* SECONDARY */]: "default",
  ["EMPHASIS" /* EMPHASIS */]: "emphasis"
};

// ../internal/src/components/common/egds-spannable-text/__private/text-weight.ts
var textWeightMapper = {
  ["BOLD" /* BOLD */]: "bold",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["REGULAR" /* REGULAR */]: "regular"
};

// ../internal/src/components/common/egds-spannable-text/egds-stylized-text.tsx
var fragment10 = gql11`
  fragment EGDSStylizedTextFragment on EGDSStylizedText {
    text
    theme
    weight
  }
`;
var EGDSStylizedText = ({
  className,
  inline = false,
  data
}) => {
  const {
    text,
    theme,
    weight
  } = data;
  const themeProps = theme ? textThemeMapper[theme] : void 0;
  const weightProps = weight ? textWeightMapper[weight] : void 0;
  return /* @__PURE__ */React22.createElement(EGDSText5, {
    className,
    inline,
    theme: themeProps,
    weight: weightProps
  }, text);
};
EGDSStylizedText.fragment = fragment10;
EGDSStylizedText.displayName = "EGDSStylizedText";

// ../internal/src/components/common/egds-spannable-text/egds-spannable-inline-content.tsx
var fragment11 = gql12`
  fragment EGDSSpannableInlineContentFragment on EGDSSpannableTextItem {
    ... on EGDSStylizedText {
      ...EGDSStylizedTextFragment
    }
    ... on EGDSGraphicText {
      ...EGDSGraphicTextFragment
    }
    ... on EGDSStandardLink {
      ...EGDSStandardLinkFragment
    }
    ... on EGDSHeading {
      ...EGDSHeadingFragment
    }
    ... on EGDSPlainText {
      ...EGDSPlainTextFragment
    }
    ... on EGDSInlineLink {
      ...EGDSInlineLinkFragment
    }
  }
  ${EGDSStylizedText.fragment}
  ${EGDSGraphicText.fragment}
  ${EGDSStandardLink.fragment}
  ${VirtualAgentEGDSHeading.fragment}
  ${EGDSPlainText.fragment}
  ${EGDSInlineLink.fragment}
`;
var registry2 = {
  EGDSStylizedText,
  EGDSGraphicText,
  EGDSStandardLink,
  VirtualAgentEGDSHeading,
  EGDSPlainText,
  EGDSInlineLink
};
var EGDSSpannableInlineContent = _a => {
  var _b = _a,
    {
      data
    } = _b,
    props = __objRest(_b, ["data"]);
  const Component = registry2[data.__typename];
  if (!Component) {
    return null;
  }
  return /* @__PURE__ */React23.createElement(EGDSSpacing3, __spreadProps(__spreadValues({}, props), {
    margin: {
      inlineend: "one"
    }
  }), /* @__PURE__ */React23.createElement(Component, {
    data,
    inline: true,
    onClick: props == null ? void 0 : props.onClick
  }));
};
EGDSSpannableInlineContent.fragment = fragment11;
EGDSSpannableInlineContent.displayName = "EGDSSpannableInlineContent";

// ../internal/src/components/common/egds-spannable-text/egds-spannable-text.tsx
var fragment12 = gql13`
  fragment EGDSSpannableTextFragment on EGDSSpannableText {
    text
    inlineContent {
      ...EGDSSpannableInlineContentFragment
    }
  }
  ${EGDSSpannableInlineContent.fragment}
`;
var EGDSSpannableText = ({
  data,
  onClick
}) => {
  const {
    inlineContent,
    text
  } = data;
  if (!inlineContent.length && !text) {
    return null;
  }
  return /* @__PURE__ */React24.createElement("div", null, text && /* @__PURE__ */React24.createElement(EGDSText6, null, text), /* @__PURE__ */React24.createElement(EGDSLayoutFlex5, {
    alignItems: "center",
    space: "one"
  }, inlineContent.map((item, index) => /* @__PURE__ */React24.createElement(EGDSSpannableInlineContent, {
    data: item,
    key: `inline-item-${index}`,
    onClick
  }))));
};
EGDSSpannableText.fragment = fragment12;
EGDSSpannableText.displayName = "EGDSSpannableText";

// ../internal/src/components/footer/virtual-agent-debug-dialog.tsx
import React25 from "react";
import { EGDSSecondaryButton as EGDSSecondaryButton2 } from "@egds/react-core/button";
import { EGDSDialog, EGDSDialogContent } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText7 } from "@egds/react-core/text";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useDialog } from "@shared-ui/dialog-context";
var DebugDialog = () => {
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog("va-debug-dialog");
  const [chatInstance] = useChatInstanceState();
  const [,, conversationContext] = useConversationState();
  const showToast = useOperation("SHOW_TOAST" /* SHOW_TOAST */);
  const {
    context
  } = useBexApi3();
  const {
    channelOriginId,
    partnerGuid
  } = (chatInstance == null ? void 0 : chatInstance.chatConfig) || {};
  const {
    conversationId,
    participantId,
    conversationType
  } = conversationContext || {};
  const {
    duaid
  } = (context == null ? void 0 : context.identity) || {};
  const copyToClipboard = () => {
    if (navigator.clipboard) {
      const debugPayload = {
        channelOriginId,
        conversationId,
        conversationType,
        partnerGuid,
        participantId,
        duaid
      };
      navigator.clipboard.writeText(JSON.stringify(debugPayload)).then(() => {
        showToast == null ? void 0 : showToast("Payload copied to clipboard!");
      });
    }
  };
  const closeDialog = () => {
    dialogActions.closeDialog();
  };
  return /* @__PURE__ */React25.createElement(DialogComponent, null, /* @__PURE__ */React25.createElement(EGDSDialog, {
    dialogShow: isDialogOpen
  }, /* @__PURE__ */React25.createElement(EGDSDialogContent, null, /* @__PURE__ */React25.createElement(EGDSHeading3, {
    "data-test-id": "debug-info",
    size: 5
  }, "Debug Info"), /* @__PURE__ */React25.createElement(EGDSSpacing4, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React25.createElement("div", null, /* @__PURE__ */React25.createElement(EGDSText7, {
    "data-test-id": "channel-origin-id"
  }, "Channel Origin ID:"), /* @__PURE__ */React25.createElement(EGDSText7, null, channelOriginId))), /* @__PURE__ */React25.createElement(EGDSSpacing4, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React25.createElement("div", null, /* @__PURE__ */React25.createElement(EGDSText7, {
    "data-test-id": "conversation-id"
  }, "Conversation ID:"), /* @__PURE__ */React25.createElement(EGDSText7, null, conversationId))), /* @__PURE__ */React25.createElement(EGDSSpacing4, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React25.createElement("div", null, /* @__PURE__ */React25.createElement(EGDSText7, {
    "data-test-id": "conversation-type"
  }, "Conversation Type:"), /* @__PURE__ */React25.createElement(EGDSText7, null, conversationType))), /* @__PURE__ */React25.createElement(EGDSSpacing4, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React25.createElement("div", null, /* @__PURE__ */React25.createElement(EGDSText7, {
    "data-test-id": "partner-guid"
  }, "Partner GUID:"), /* @__PURE__ */React25.createElement(EGDSText7, null, partnerGuid))), /* @__PURE__ */React25.createElement(EGDSSpacing4, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React25.createElement("div", null, /* @__PURE__ */React25.createElement(EGDSText7, {
    "data-test-id": "participant-id"
  }, "Participant ID:"), /* @__PURE__ */React25.createElement(EGDSText7, null, participantId))), /* @__PURE__ */React25.createElement(EGDSSpacing4, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React25.createElement("div", null, /* @__PURE__ */React25.createElement(EGDSText7, {
    "data-test-id": "duaid"
  }, "DUAID:"), /* @__PURE__ */React25.createElement(EGDSText7, null, duaid))), /* @__PURE__ */React25.createElement(EGDSLayoutFlex6, {
    space: "two"
  }, /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem3, {
    grow: 1
  }, /* @__PURE__ */React25.createElement(EGDSSecondaryButton2, {
    onClick: copyToClipboard
  }, "Copy")), /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem3, {
    grow: 1
  }, /* @__PURE__ */React25.createElement(EGDSSecondaryButton2, {
    onClick: closeDialog
  }, "Done"))))));
};

// ../internal/src/components/footer/virtual-agent-control-chat-footer.tsx
import { validateMessage as creditCardMasking } from "@gco-vnext/data-protection-library/distribution/src/manager/data-protection-manager";
var fragment13 = gql14`
  fragment VirtualAgentControlChatFooterFragment on VirtualAgentControlChatFooter {
    send {
      ...EGDSButtonFragment
    }
    input {
      ... on EGDSTypeaheadInputField {
        label
        placeholder
        readOnly
      }
      ... on EGDSTextInputField {
        label
        placeholder
        readOnly
        validations {
          ... on EGDSMaxLengthInputValidation {
            maxLength
          }
        }
      }
    }
    attach {
      ...EGDSButtonFragment
      accessibility
    }
    disabledInputPlaceholder
    landmarkFooterAccessibilityLabel
  }
  ${VirtualAgentEGDSButton.fragment}
`;
var VirtualAgentControlChatFooter = ({
  data,
  onSendCallback,
  onAttachCallback
}) => {
  var _a, _b;
  const [state, dispatch] = useProvidedState8();
  const [conversation] = useConversationState();
  const [chatInstance] = useChatInstanceState();
  const [, conversationMessages, messagesDispatch] = useMessagesState();
  const [, dialogActions] = useDialog2("va-debug-dialog");
  const {
    send,
    input,
    attach,
    disabledInputPlaceholder
  } = data;
  const [userInput, setUserInput] = React26.useState("");
  const [isTyping, setIsTyping] = React26.useState(false);
  const [chatInputLimit, setChatInputLimit] = React26.useState(0);
  const charLimitExists = React26.useRef(false);
  const [timer, setTimer] = React26.useState(null);
  const sendMessage = useOperation("SEND_MESSAGE" /* SEND_MESSAGE */);
  const sendEvent = useOperation("TYPING_EVENT" /* TYPING_EVENT */);
  const fileRef = React26.useRef(null);
  const formRef = React26.useRef(null);
  const {
    trackEvent
  } = useAnalytics();
  const [handleSendFileMessage] = useSendFileMessage();
  const errorLocalizations = use_prefetch_localization_content_default(LocalizationContentKeys.ERROR);
  const {
    chatFooterState: {
      chatInputEnable = false
    } = {}
  } = conversation || {};
  const trimmedUserInput = userInput.trim();
  React26.useEffect(() => {
    var _a2;
    if (input.__typename === "EGDSTextInputField" && ((_a2 = input.validations) == null ? void 0 : _a2.length)) {
      const maxLengthValidation = input.validations.find(validation => validation.__typename === "EGDSMaxLengthInputValidation");
      setChatInputLimit((maxLengthValidation == null ? void 0 : maxLengthValidation.maxLength) || 0);
      charLimitExists.current = true;
    }
  }, []);
  const {
    wordLimitInfoProps,
    showTextOverflowError
  } = validateInputString(trimmedUserInput, chatInputLimit, charLimitExists.current, errorLocalizations);
  const showChatInputLength = trimmedUserInput.length >= chatInputLimit - excessCharactersThreshold && charLimitExists;
  if (!send.icon && !send.primary) {
    return null;
  }
  const shouldShowDebugDialog = chatInputValue => {
    var _a2;
    return ((_a2 = chatInputValue.trim()) == null ? void 0 : _a2.toUpperCase()) === DebugIdToken.toUpperCase();
  };
  const sendEventData = start => {
    return {
      eventType: "TYPING_INDICATOR",
      content: {
        typingIndicatorEventContent: {
          start
        }
      }
    };
  };
  const checkIfNewSeperatorMessageIsRequired = () => {
    const currentMessages = (conversationMessages == null ? void 0 : conversationMessages.messages) || [];
    const lastReceivedMessageTimeStamp = conversationMessages == null ? void 0 : conversationMessages.lastReceivedMessageTimeStamp;
    if (currentMessages.length && lastReceivedMessageTimeStamp) {
      const timeStamp = new Date(conversationMessages.lastReceivedMessageTimeStamp);
      const today = new Date(Date.now());
      return !isSameDay(timeStamp, today);
    }
  };
  const handleAttach = () => {
    var _a2;
    (_a2 = fileRef.current) == null ? void 0 : _a2.click();
    trackEvent(buildClickstreamEventPaylaod("VIRTUAL_AGENT_ATTACHMENT_SELECTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type));
    onAttachCallback == null ? void 0 : onAttachCallback();
  };
  const handleSend = () => {
    if (checkIfNewSeperatorMessageIsRequired()) {
      const todayTimeStamp = startOfDayUTC(/* @__PURE__ */new Date()).toISOString();
      messagesDispatch({
        type: "ADD_SEPERATOR_MESSAGE" /* ADD_SEPERATOR_MESSAGE */,
        payload: {
          primary: todayTimeStamp,
          timeStamp: todayTimeStamp
        }
      });
    }
    if (trimmedUserInput !== "") {
      if (shouldShowDebugDialog(trimmedUserInput)) {
        dialogActions.openDialog();
        setUserInput("");
        return;
      }
      sendMessage == null ? void 0 : sendMessage({
        message: creditCardMasking(trimmedUserInput)
      });
      onSendCallback == null ? void 0 : onSendCallback();
    }
    setUserInput("");
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimeout(() => {
      setIsTyping(false);
      sendEvent == null ? void 0 : sendEvent(sendEventData(false));
    }, 100);
  };
  const handleChange = ({
    target
  }) => {
    setUserInput(target.value);
    if (!isTyping) {
      sendEvent == null ? void 0 : sendEvent(sendEventData(true));
    }
    setIsTyping(true);
    if (timer) {
      clearTimeout(timer);
    }
    const reset = setTimeout(() => {
      setIsTyping(false);
      sendEvent == null ? void 0 : sendEvent(sendEventData(false));
    }, 3e3);
    setTimer(reset);
  };
  const handleKeyDown = event => {
    if (!event.shiftKey && event.code === "Enter" && !showTextOverflowError) {
      event.preventDefault();
      event.stopPropagation();
      handleSend();
    }
  };
  const handleFileChange = event => {
    const {
      target: {
        files = new FileList()
      }
    } = event;
    event.preventDefault();
    const messages = Array.from(files).map(file => ({
      file,
      uniqueAttachmentId: uuidv42()
    }));
    handleSendFileMessage(messages, formRef, sendMessage);
  };
  return /* @__PURE__ */React26.createElement(EGDSLayoutFlex7, {
    space: "two"
  }, attach && /* @__PURE__ */React26.createElement(ClicksteamImpressionTracker, {
    fireImpression: conversation == null ? void 0 : conversation.conversationId,
    eventData: buildClickstreamEventPaylaod("VIRTUAL_AGENT_ATTACHMENT_PRESETED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type)
  }, /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem4, {
    grow: 0,
    alignSelf: "start"
  }, /* @__PURE__ */React26.createElement("form", {
    ref: formRef
  }, /* @__PURE__ */React26.createElement(VirtualAgentEGDSButton, {
    data: __spreadProps(__spreadValues({}, attach), {
      disabled: !chatInputEnable
    }),
    onClick: handleAttach,
    size: EGDSButtonSize3.LARGE
  }), /* @__PURE__ */React26.createElement("input", {
    tabIndex: -1,
    type: "file",
    "data-stid": "file-upload",
    id: "file-upload",
    ref: fileRef,
    "aria-hidden": "true",
    hidden: true,
    multiple: true,
    accept: [...acceptedMimeTypes, ...acceptedMsOfficeMimeTypes].join(","),
    onChange: handleFileChange,
    "aria-label": attach.accessibility || "",
    disabled: !chatInputEnable
  })))), /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem4, {
    grow: 1
  }, /* @__PURE__ */React26.createElement("div", null, /* @__PURE__ */React26.createElement(EGDSChatTextArea, __spreadValues({
    label: (_a = input.label) != null ? _a : void 0,
    placeholder: chatInputEnable ? (_b = input.placeholder) != null ? _b : void 0 : disabledInputPlaceholder,
    readOnly: input.readOnly,
    minRows: 1,
    maxRows: 2,
    value: userInput,
    id: "vac-input-field",
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    disabled: !chatInputEnable
  }, showChatInputLength && wordLimitInfoProps)))), /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem4, {
    alignSelf: "start",
    grow: 0
  }, /* @__PURE__ */React26.createElement("div", null, /* @__PURE__ */React26.createElement(VirtualAgentEGDSButton, {
    data: __spreadProps(__spreadValues({}, send), {
      disabled: !chatInputEnable || !trimmedUserInput.length || showTextOverflowError
    }),
    onClick: handleSend,
    size: EGDSButtonSize3.LARGE
  }))), /* @__PURE__ */React26.createElement(DebugDialog, null));
};
VirtualAgentControlChatFooter.fragment = fragment13;
VirtualAgentControlChatFooter.displayName = "VirtualAgentControlChatFooter";

// ../internal/src/components/header/virtual-agent-control-chat-header.tsx
import React29, { useCallback as useCallback2, useEffect as useEffect3, useState as useState2 } from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize5 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex8 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition4 } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4 } from "@egds/react-core/text";

// ../internal/src/hooks/use-participant-state.tsx
import React27 from "react";
import { useProvidedState as useProvidedState9 } from "@shared-ui/provided-state-context";
function useParticipantState() {
  const [state] = useProvidedState9();
  const [chatInstance] = useChatInstanceState();
  const participantState = state == null ? void 0 : state.participantState;
  const activeConversationId = chatInstance == null ? void 0 : chatInstance.activeConversationId;
  const conversationParticipantState = React27.useMemo(() => {
    var _a;
    const filteredParticipants = (participantState == null ? void 0 : participantState.participants) ? Object.keys(participantState.participants).reduce((acc, participantId) => {
      if (participantState.participants[participantId].conversationId === activeConversationId) {
        acc[participantId] = participantState.participants[participantId];
      }
      return acc;
    }, {}) : {};
    const filteredActivityIndicators = ((_a = participantState == null ? void 0 : participantState.activityIndicatorParticipantList) == null ? void 0 : _a.filter(participant => participant.conversationId === activeConversationId)) || [];
    return [filteredParticipants, filteredActivityIndicators];
  }, [participantState, activeConversationId]);
  return conversationParticipantState;
}

// ../internal/src/components/header/virtual-agent-control-header-close-button.tsx
import React28 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize4 } from "@egds/react-core/button";
import { EGDSLayoutPosition as EGDSLayoutPosition3 } from "@egds/react-core/layout-position";
var fragment14 = gql15`
  fragment VirtualAgentControlHeaderCloseButtonFragment on VirtualAgentControlEGDSButton {
    analytics {
      ... on VirtualAgentControlInteractionAnalyticEvent {
        eventName
        eventVersion
        payload
      }
      ... on VirtualAgentControlOutcomeAnalyticEvent {
        eventName
        eventVersion
        payload
      }
      ... on VirtualAgentControlPageViewAnalyticEvent {
        eventName
        eventVersion
        payload
      }
      ... on VirtualAgentControlImpressionAnalyticEvent {
        eventName
        eventVersion
        payload
      }
    }
    button {
      ...EGDSButtonFragment
    }
  }
`;
var VirtualAgentControlHeaderCloseButton = ({
  onClick,
  data
}) => {
  const handleClose = React28.useCallback(() => {
    onClick == null ? void 0 : onClick();
  }, [onClick]);
  if (!(data == null ? void 0 : data.button)) {
    return null;
  }
  return /* @__PURE__ */React28.createElement(EGDSLayoutPosition3, {
    type: "absolute",
    position: {
      top: "four",
      left: "one"
    }
  }, /* @__PURE__ */React28.createElement(VirtualAgentEGDSButton, {
    data: data.button,
    onClick: handleClose,
    size: EGDSButtonSize4.LARGE
  }));
};
VirtualAgentControlHeaderCloseButton.fragment = fragment14;
VirtualAgentControlHeaderCloseButton.displayName = "VirtualAgentControlHeaderCloseButton";

// ../internal/src/components/header/virtual-agent-control-chat-header.tsx
var fragment15 = gql16`
  fragment VirtualAgentControlChatHeaderFragment on VirtualAgentControlChatHeader {
    avatar {
      ...AvatarGroupFragment
    }
    close {
      ...VirtualAgentControlHeaderCloseButtonFragment
    }
    settingsMenuTrigger {
      analytics {
        ... on VirtualAgentControlInteractionAnalyticEvent {
          eventName
          eventVersion
          payload
        }
        ... on VirtualAgentControlOutcomeAnalyticEvent {
          eventName
          eventVersion
          payload
        }
        ... on VirtualAgentControlPageViewAnalyticEvent {
          eventName
          eventVersion
          payload
        }
        ... on VirtualAgentControlImpressionAnalyticEvent {
          eventName
          eventVersion
          payload
        }
      }
      button {
        ...EGDSButtonFragment
      }
    }
    text
    visuallyHiddenHeaderAccessibilityLabel
    landmarkHeaderAccessibilityLabel
  }
  ${VirtualAgentControlHeaderCloseButton.fragment}
  ${AvatarGroup.fragment}
  ${VirtualAgentEGDSButton.fragment}
`;
var getChatHeaderAvatar = participantDisplayName => {
  const participantInitials = participantDisplayName[0].toUpperCase();
  return {
    __typename: "AvatarGroup",
    items: [{
      text: participantInitials,
      __typename: "Avatar",
      image: null,
      icon: null
    }]
  };
};
function getSettingsMenuAnalytics(settingsMenuAnalytics) {
  let menuPresentedImpression;
  let menuItemPresentedImpression;
  let menuClick;
  for (let ind = 0; ind < settingsMenuAnalytics.length; ind += 1) {
    const analytic = settingsMenuAnalytics[ind];
    const analyticsPayload = getEventPayloadAnalytics(analytic.payload, analytic.eventName, analytic.eventVersion);
    switch (analytic.eventName) {
      case "virtual_agent_settings_menu.presented" /* SETTINGS_MENU_PRESENTED */:
        {
          menuPresentedImpression = analyticsPayload;
          break;
        }
      case "virtual_agent_settings_menu.selected" /* SETTINGS_MENU_SELECTED */:
        {
          menuClick = analyticsPayload;
          break;
        }
      case "virtual_agent_settings_menu_item.presented" /* SETTINGS_MENU_ITEM_PRESENTED */:
        {
          menuItemPresentedImpression = analyticsPayload;
          break;
        }
    }
  }
  return {
    menuPresentedImpression,
    menuItemPresentedImpression,
    menuClick
  };
}
var VirtualAgentControlChatHeader = ({
  onMinimize,
  embedded,
  onOpenSettings,
  data
}) => {
  const {
    avatar,
    text,
    close,
    settingsMenuTrigger
  } = data;
  const [chatHeader, setChatHeader] = useState2(text);
  const [chatHeaderAvatar, setChatHeaderAvatar] = useState2(avatar);
  const {
    typeHumanAgent
  } = use_prefetch_localization_content_default(LocalizationContentKeys.PARTICIPANT) || {};
  const [conversation] = useConversationState();
  const {
    analytics: settingsMenuAnalytics
  } = settingsMenuTrigger != null ? settingsMenuTrigger : {};
  const {
    menuItemPresentedImpression = {},
    menuClick = {},
    menuPresentedImpression = {}
  } = (settingsMenuAnalytics == null ? void 0 : settingsMenuAnalytics.length) ? getSettingsMenuAnalytics(settingsMenuAnalytics) : {};
  const {
    trackEvent
  } = useAnalytics();
  const [participantState] = useParticipantState();
  const getParticipantHeader = useCallback2(() => {
    const participant = Object.keys(participantState).reduce((acc, participantId) => {
      const currentParticipant = participantState[participantId];
      if (currentParticipant.participantType === "HumanAgent" && currentParticipant.participantState === "JOINED" /* JOINED */) {
        return participantState[participantId];
      }
      return acc;
    }, {});
    if (!Object.keys(participant).length) {
      setChatHeader(text);
      setChatHeaderAvatar(avatar);
      return;
    }
    const participantDisplayName = getPartcipantDisplayName(participant);
    setChatHeader(participantDisplayName || typeHumanAgent);
    setChatHeaderAvatar(getChatHeaderAvatar(participantDisplayName || typeHumanAgent));
  }, [participantState]);
  useEffect3(() => {
    getParticipantHeader();
  }, [getParticipantHeader]);
  const handleMinimize = React29.useCallback(() => {
    trackEvent(buildClickstreamEventPaylaod("VIRTUAL_AGENT_CLOSED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type));
    onMinimize == null ? void 0 : onMinimize();
  }, [onMinimize]);
  const handleOpenSettings = React29.useCallback(() => {
    trackEvent(buildClickstreamAdditionalContextPayload("VIRTUAL_AGENT_SETTINGS_MENU_SELECTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, menuClick == null ? void 0 : menuClick.additionalContext));
    trackEvent(buildClickstreamAdditionalContextPayload("VIRTUAL_AGENT_SETTINGS_MENU_ITEM_PRESENTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, menuItemPresentedImpression == null ? void 0 : menuItemPresentedImpression.additionalContext));
    onOpenSettings == null ? void 0 : onOpenSettings();
  }, [onOpenSettings]);
  return /* @__PURE__ */React29.createElement(EGDSSpacing5, {
    padding: {
      blockstart: "six",
      blockend: "two"
    }
  }, /* @__PURE__ */React29.createElement("div", null, !embedded && close && /* @__PURE__ */React29.createElement(VirtualAgentControlHeaderCloseButton, {
    data: close,
    onClick: handleMinimize
  }), /* @__PURE__ */React29.createElement(EGDSLayoutFlex8, {
    tag: "header",
    direction: "column",
    alignItems: "center",
    space: "one"
  }, /* @__PURE__ */React29.createElement("div", {
    "aria-hidden": "true"
  }, /* @__PURE__ */React29.createElement(AvatarGroup, {
    data: chatHeaderAvatar
  })), /* @__PURE__ */React29.createElement(EGDSHeading4, {
    tag: "h2",
    size: 7,
    overflow: "truncate"
  }, chatHeader)), (settingsMenuTrigger == null ? void 0 : settingsMenuTrigger.button) && /* @__PURE__ */React29.createElement(ClicksteamImpressionTracker, {
    fireImpression: conversation == null ? void 0 : conversation.conversationId,
    eventData: buildClickstreamAdditionalContextPayload("VIRTUAL_AGENT_SETTINGS_MENU_PRESENTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, menuPresentedImpression == null ? void 0 : menuPresentedImpression.additionalContext)
  }, /* @__PURE__ */React29.createElement(EGDSLayoutPosition4, {
    type: "absolute",
    position: {
      top: "four",
      right: "one"
    }
  }, /* @__PURE__ */React29.createElement(VirtualAgentEGDSButton, {
    data: settingsMenuTrigger.button,
    onClick: handleOpenSettings,
    size: EGDSButtonSize5.LARGE
  })))));
};
VirtualAgentControlChatHeader.fragment = fragment15;
VirtualAgentControlChatHeader.displayName = "VirtualAgentControlChatHeader";

// ../internal/src/components/header/virtual-agent-control-toolbar.tsx
import React30 from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize6 } from "@egds/react-core/button";
import { EGDSToolbar as EGDSToolbar2 } from "@egds/react-core/toolbar";
var fragment16 = gql17`
  fragment VirtualAgentControlToolbarFragment on VirtualAgentControlToolbar {
    closeButton {
      ...EGDSButtonFragment
    }
  }
  ${VirtualAgentEGDSButton.fragment}
`;
var VirtualAgentControlToolbar = ({
  onClose,
  data
}) => {
  const {
    closeButton
  } = data;
  const handleClose = React30.useCallback(() => {
    onClose == null ? void 0 : onClose();
  }, [onClose]);
  if (!closeButton) {
    return null;
  }
  return /* @__PURE__ */React30.createElement(EGDSToolbar2, null, /* @__PURE__ */React30.createElement(VirtualAgentEGDSButton, {
    data: closeButton,
    onClick: handleClose,
    size: EGDSButtonSize6.LARGE
  }));
};
VirtualAgentControlToolbar.fragment = fragment16;
VirtualAgentControlToolbar.displayName = "VirtualAgentControlToolbar";

// ../internal/src/components/menuItem/virtual-agent-control-menu-settings.tsx
import React38, { useEffect as useEffect4 } from "react";
import { useProvidedState as useProvidedState11 } from "@shared-ui/provided-state-context";

// ../internal/src/store/chat-instances-state/reducers.ts
import isEqual from "lodash.isequal";

// ../internal/src/components/menuItem/virtual-agent-control-menu-bottomsheet-view.tsx
import React36 from "react";
import { gql as gql22 } from "@apollo/client";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";

// ../internal/src/components/menuItem/virtual-agent-control-menu-list.tsx
import React34 from "react";
import { EGDSActionList } from "@egds/react-core/action-list-item";
import { useProvidedState as useProvidedState10 } from "@shared-ui/provided-state-context";

// ../internal/src/components/menuItem/virtual-agent-control-menu-list-item.tsx
import React33 from "react";
import { gql as gql20 } from "@apollo/client";

// ../internal/src/components/menuItem/virtual-agent-control-button-menu-list-item.tsx
import React31 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSActionListItem } from "@egds/react-core/action-list-item";
import { EGDSIcon as EGDSIcon5 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText8 } from "@egds/react-core/text";
var fragment17 = gql18`
  fragment VirtualAgentControlButtonMenuListItemFragment on VirtualAgentControlButtonMenuListItem {
    id
    icon {
      ...IconFragment
    }
    label
  }
  ${Icon.fragment}
`;
var VirtualAgentControlButtonMenuListItem = ({
  data,
  onCloseSettings
}) => {
  var _a;
  const {
    icon,
    label
  } = data;
  const handleOnItemClick = () => {
    if (onCloseSettings) {
      onCloseSettings();
    }
  };
  return /* @__PURE__ */React31.createElement(EGDSActionListItem, {
    key: `menu-item-${data.id}`
  }, /* @__PURE__ */React31.createElement(EGDSLayoutFlex9, {
    space: "three",
    onClick: handleOnItemClick
  }, /* @__PURE__ */React31.createElement(EGDSLayoutFlexItem5, {
    shrink: 0,
    alignSelf: "center"
  }, /* @__PURE__ */React31.createElement("div", {
    "aria-hidden": "true"
  }, /* @__PURE__ */React31.createElement(EGDSIcon5, {
    name: icon.id,
    id: icon.id,
    description: (_a = icon.description) != null ? _a : void 0
  }))), /* @__PURE__ */React31.createElement(EGDSLayoutFlexItem5, {
    grow: 1
  }, /* @__PURE__ */React31.createElement("section", null, /* @__PURE__ */React31.createElement(EGDSText8, {
    size: 300,
    theme: "emphasis"
  }, label)))));
};
VirtualAgentControlButtonMenuListItem.fragment = fragment17;
VirtualAgentControlButtonMenuListItem.displayName = "VirtualAgentControlButtonMenuListItem";

// ../internal/src/components/menuItem/virtual-agent-control-toggle-menu-list-item.tsx
import React32 from "react";
import { gql as gql19 } from "@apollo/client";
import { EGDSActionListItem as EGDSActionListItem2 } from "@egds/react-core/action-list-item";
import { EGDSIcon as EGDSIcon6 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText9 } from "@egds/react-core/text";
function getSettingsMenuInteractionAnalytics(checkedAnalytics) {
  if (checkedAnalytics == null ? void 0 : checkedAnalytics.length) {
    const menuItemClickedAnalytic = checkedAnalytics.find(analytics => analytics.eventName === "virtual_agent_settings_menu_item.selected");
    if (menuItemClickedAnalytic) {
      return getEventPayloadAnalytics(menuItemClickedAnalytic.payload, menuItemClickedAnalytic.eventName, menuItemClickedAnalytic.eventVersion);
    }
  }
  return null;
}
var fragment18 = gql19`
  fragment VirtualAgentControlToggleMenuListItemFragment on VirtualAgentControlToggleMenuListItem {
    checked
    checkedAccessibilityLabel
    checkedDescription
    checkedIcon {
      ...IconFragment
    }
    checkedLabel
    checkedToast {
      text
    }
    uncheckedToast {
      text
    }
    checkedAnalytics {
      ... on VirtualAgentControlImpressionAnalyticEvent {
        eventName
        eventVersion
        payload
      }

      ... on VirtualAgentControlInteractionAnalyticEvent {
        eventName
        eventVersion
        payload
      }
      ... on VirtualAgentControlOutcomeAnalyticEvent {
        eventName
        eventVersion
        payload
      }
      ... on VirtualAgentControlPageViewAnalyticEvent {
        eventName
        eventVersion
        payload
      }
    }
    id
    uncheckedAccessibilityLabel
    uncheckedDescription
    uncheckedIcon {
      ...IconFragment
    }
    uncheckedLabel
  }
  ${Icon.fragment}
`;
var VirtualAgentControlToggleMenuListItem = ({
  onCloseSettings,
  onToggle,
  isChecked,
  data
}) => {
  var _a, _b, _c, _d;
  const {
    id,
    checkedAnalytics,
    checkedIcon,
    checkedLabel,
    uncheckedIcon,
    uncheckedLabel,
    checkedToast,
    uncheckedToast
  } = data;
  const interactionAnalytics = getSettingsMenuInteractionAnalytics(checkedAnalytics);
  const {
    trackEvent
  } = useAnalytics();
  const [conversation] = useConversationState();
  const showToast = useOperation("SHOW_TOAST" /* SHOW_TOAST */);
  const handleCheckboxChange = () => {
    trackEvent(buildClickstreamAdditionalContextPayload("VIRTUAL_AGENT_SETTINGS_MENU_ITEM_SELECTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, interactionAnalytics == null ? void 0 : interactionAnalytics.additionalContext));
    if (onCloseSettings) {
      onCloseSettings();
    }
    if (onToggle) {
      onToggle(id);
    }
    if (showToast) {
      showToast(isChecked ? checkedToast == null ? void 0 : checkedToast.text : uncheckedToast == null ? void 0 : uncheckedToast.text);
    }
  };
  return /* @__PURE__ */React32.createElement(EGDSActionListItem2, {
    key: `menu-item-${id}`
  }, /* @__PURE__ */React32.createElement(EGDSLayoutFlex10, {
    alignContent: "center",
    dataTestId: "uitk-flex-toggle",
    space: "three",
    alignItems: "center",
    onClick: handleCheckboxChange
  }, /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem6, {
    shrink: 0,
    alignSelf: "center"
  }, /* @__PURE__ */React32.createElement("div", {
    "aria-hidden": "true"
  }, isChecked ? /* @__PURE__ */React32.createElement(EGDSIcon6, {
    name: checkedIcon.id,
    id: checkedIcon.id,
    description: (_a = checkedIcon.description) != null ? _a : void 0,
    title: (_b = checkedIcon.title) != null ? _b : void 0
  }) : /* @__PURE__ */React32.createElement(EGDSIcon6, {
    name: uncheckedIcon.id,
    id: uncheckedIcon.id,
    description: (_c = uncheckedIcon.description) != null ? _c : void 0,
    title: (_d = checkedIcon.title) != null ? _d : void 0
  }))), /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem6, {
    grow: 1
  }, /* @__PURE__ */React32.createElement("section", null, /* @__PURE__ */React32.createElement(EGDSText9, {
    size: 300,
    theme: "emphasis"
  }, isChecked ? checkedLabel : uncheckedLabel)))));
};
VirtualAgentControlToggleMenuListItem.fragment = fragment18;
VirtualAgentControlToggleMenuListItem.displayName = "VirtualAgentControlToggleMenuListItem";

// ../internal/src/components/menuItem/virtual-agent-control-menu-list-item.tsx
var fragment19 = gql20`
  fragment VirtualAgentControlMenuListItemFragment on VirtualAgentControlMenuListItem {
    ...VirtualAgentControlButtonMenuListItemFragment
    ...VirtualAgentControlToggleMenuListItemFragment
  }
  ${VirtualAgentControlButtonMenuListItem.fragment}
  ${VirtualAgentControlToggleMenuListItem.fragment}
`;
var VirtualAgentControlMenuListItem = ({
  onCloseSettings,
  onToggle,
  isChecked,
  data
}) => {
  switch (data.__typename) {
    case "VirtualAgentControlButtonMenuListItem":
      return /* @__PURE__ */React33.createElement(VirtualAgentControlButtonMenuListItem, {
        data,
        onCloseSettings
      });
    case "VirtualAgentControlToggleMenuListItem":
      return /* @__PURE__ */React33.createElement(VirtualAgentControlToggleMenuListItem, {
        data,
        onCloseSettings,
        onToggle,
        isChecked
      });
    default:
      return null;
  }
};
VirtualAgentControlMenuListItem.fragment = fragment19;
VirtualAgentControlMenuListItem.displayName = "VirtualAgentControlMenuListItem";

// ../internal/src/components/menuItem/virtual-agent-control-menu-list.tsx
var VirtualAgentControlMenuList = ({
  elements,
  onCloseSettings
}) => {
  var _a;
  const vacId = useVacId();
  const [state, dispatch] = useProvidedState10();
  const {
    settingMenuItemState
  } = ((_a = state.chatInstancesState) == null ? void 0 : _a[vacId]) || {};
  function handleItemToggle(id) {
    dispatch({
      type: "SET_SETTINGS_MENU_STATE" /* SET_SETTINGS_MENU_STATE */,
      payload: {
        vacId,
        menuItemId: id,
        menuItemState: !settingMenuItemState[id]
      }
    });
  }
  if (!(elements == null ? void 0 : elements.length)) {
    return null;
  }
  return /* @__PURE__ */React34.createElement(EGDSActionList, null, elements.map((item, index) => /* @__PURE__ */React34.createElement(VirtualAgentControlMenuListItem, {
    data: item,
    key: `menu-item-${item.id}`,
    onCloseSettings,
    onToggle: () => handleItemToggle(item.id),
    isChecked: settingMenuItemState[item.id]
  })));
};

// ../internal/src/components/menuItem/virtual-agent-control-menu-toolbar.tsx
import React35 from "react";
import { gql as gql21 } from "@apollo/client";
import { EGDSToolbar as EGDSToolbar3 } from "@egds/react-core/toolbar";
var fragment20 = gql21`
  fragment VirtualAgentControlMenuToolbarFragment on VirtualAgentControlMenuToolbar {
    title
    navigationButton {
      ...EGDSButtonFragment
    }
  }
  ${VirtualAgentEGDSButton.fragment}
`;
var VirtualAgentControlMenuToolbar = ({
  onCloseSettings,
  data
}) => {
  var _a;
  const {
    title,
    navigationButton
  } = data;
  const handleNavigationClick = () => {
    if (onCloseSettings) {
      onCloseSettings();
    }
  };
  return /* @__PURE__ */React35.createElement(EGDSToolbar3, {
    id: "menu-toolbar",
    navigationContent: {
      onClick: handleNavigationClick,
      navType: "back",
      navIconLabel: (_a = navigationButton == null ? void 0 : navigationButton.accessibility) != null ? _a : ""
    },
    toolbarTitle: title || ""
  });
};
VirtualAgentControlMenuToolbar.fragment = fragment20;
VirtualAgentControlMenuToolbar.displayName = "VirtualAgentControlMenuToolbar";

// ../internal/src/components/menuItem/virtual-agent-control-menu-bottomsheet-view.tsx
var fragment21 = gql22`
  fragment VirtualAgentControlMenuBottomSheetViewFragment on VirtualAgentControlMenuBottomSheetView {
    element {
      ...VirtualAgentControlMenuListItemFragment
    }
    toolbar {
      ...VirtualAgentControlMenuToolbarFragment
    }
  }
  ${VirtualAgentControlMenuListItem.fragment}
  ${VirtualAgentControlMenuToolbar.fragment}
`;
var VirtualAgentControlMenuBottomSheetView = ({
  open,
  onCloseSettings,
  data
}) => {
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog3("va-settings-menu");
  const {
    element,
    toolbar
  } = data;
  React36.useEffect(() => {
    if (open && !isDialogOpen) {
      dialogActions.openDialog();
    } else if (!open && isDialogOpen) {
      dialogActions.closeDialog();
    }
  }, [open]);
  if (!(element == null ? void 0 : element.length) || !(toolbar == null ? void 0 : toolbar.title)) {
    return null;
  }
  const handleDismiss = () => {
    onCloseSettings == null ? void 0 : onCloseSettings();
    dialogActions.closeDialog();
  };
  return /* @__PURE__ */React36.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React36.createElement(DialogComponent, null, /* @__PURE__ */React36.createElement(EGDSSheet, {
    type: "bottom",
    isVisible: isDialogOpen,
    triggerRef: null,
    onDismiss: handleDismiss,
    ariaLabel: toolbar.title
  }, /* @__PURE__ */React36.createElement(EGDSSheetContent, {
    padded: false
  }, toolbar && /* @__PURE__ */React36.createElement(VirtualAgentControlMenuToolbar, {
    data: toolbar,
    onCloseSettings
  }), /* @__PURE__ */React36.createElement(VirtualAgentControlMenuList, {
    onCloseSettings,
    elements: [...element]
  })))));
};
VirtualAgentControlMenuBottomSheetView.fragment = fragment21;
VirtualAgentControlMenuBottomSheetView.displayName = "VirtualAgentControlMenuBottomSheetView";

// ../internal/src/components/menuItem/virtual-agent-control-menu-popover-view.tsx
import React37 from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSMenu, EGDSMenuContainer, PositionType } from "@egds/react-core/menu";
var fragment22 = gql23`
  fragment VirtualAgentControlMenuPopoverViewFragment on VirtualAgentControlMenuPopoverView {
    element {
      ...VirtualAgentControlMenuListItemFragment
    }
  }
  ${VirtualAgentControlMenuListItem.fragment}
`;
var VirtualAgentControlMenuPopoverView = ({
  open,
  onCloseSettings,
  data
}) => {
  const {
    element
  } = data;
  if (!(element == null ? void 0 : element.length)) {
    return null;
  }
  return /* @__PURE__ */React37.createElement(EGDSMenu, {
    id: "uitk-menu-item",
    isOpen: open
  }, /* @__PURE__ */React37.createElement(EGDSMenuContainer, {
    position: PositionType.RIGHT,
    showOverTrigger: true,
    width: 170
  }, /* @__PURE__ */React37.createElement(VirtualAgentControlMenuList, {
    onCloseSettings,
    elements: [...element]
  })));
};
VirtualAgentControlMenuPopoverView.fragment = fragment22;
VirtualAgentControlMenuPopoverView.displayName = "VirtualAgentControlMenuPopoverView";

// ../internal/src/components/menuItem/virtual-agent-control-menu-settings.tsx
var VirtualAgentControlMenuSettings = ({
  settingsMenu,
  handleMenuCloseSettings,
  isSettingsVisible
}) => {
  const vacId = useVacId();
  const [, dispatch] = useProvidedState11();
  function setToggleMenuItemState() {
    const {
      element
    } = settingsMenu;
    element.forEach(item => {
      if (item.__typename === "VirtualAgentControlToggleMenuListItem") {
        dispatch({
          type: "SET_SETTINGS_MENU_STATE" /* SET_SETTINGS_MENU_STATE */,
          payload: {
            vacId,
            menuItemId: item.id,
            menuItemState: item.checked
          }
        });
      }
    });
  }
  useEffect4(() => {
    if (settingsMenu) {
      setToggleMenuItemState();
    }
  }, [settingsMenu]);
  if ((settingsMenu == null ? void 0 : settingsMenu.__typename) === "VirtualAgentControlMenuPopoverView") {
    return /* @__PURE__ */React38.createElement(VirtualAgentControlMenuPopoverView, {
      data: settingsMenu,
      onCloseSettings: handleMenuCloseSettings,
      open: isSettingsVisible
    });
  }
  return settingsMenu && /* @__PURE__ */React38.createElement(VirtualAgentControlMenuBottomSheetView, {
    data: settingsMenu,
    onCloseSettings: handleMenuCloseSettings,
    open: isSettingsVisible
  });
};

// ../internal/src/components/quick-replies/virtual-agent-control-quick-replies.tsx
import React48, { useEffect as useEffect5, useState as useState4 } from "react";
import omit from "lodash.omit";
import { EGDSLayoutFlex as EGDSLayoutFlex14 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";

// ../internal/src/components/quick-replies/virtual-agent-control-end-chat-dialog.tsx
import React46 from "react";
import { gql as gql29 } from "@apollo/client";
import { EGDSDialog as EGDSDialog3, EGDSDialogContent as EGDSDialogContent3 } from "@egds/react-core/dialog";
import { EGDSSpacingHr as EGDSSpacingHr2 } from "@egds/react-core/spacing";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";

// ../internal/src/components/declarative-cards/components/dynamic-card-action.tsx
import React41 from "react";
import { gql as gql25 } from "@apollo/client";
import { v4 as uuidv43 } from "uuid";
import { EGDSButtonSize as EGDSButtonSize7, EGDSPrimaryButton as EGDSPrimaryButton2, EGDSSecondaryButton as EGDSSecondaryButton3, EGDSTertiaryButton as EGDSTertiaryButton4 } from "@egds/react-core/button";
import { EGDSDialog as EGDSDialog2, EGDSDialogContent as EGDSDialogContent2 } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex11 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
import { EGDSSpacingHr } from "@egds/react-core/spacing";
import { useSignalPublisher as useSignalPublisher2 } from "@shared-ui/core-signal-manager/context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { VacDynamicCardSignal } from "@shared-ui/retail-signals-virtual-agent";

// ../internal/src/components/declarative-cards/providers/dynamic-card-context-provider.tsx
import React39, { createContext, useContext } from "react";
var DefaultWebview = ({
  webview,
  isVisible
}) => {
  var _a;
  const webviewContent = ((_a = webview == null ? void 0 : webview.url) == null ? void 0 : _a.value) || (webview == null ? void 0 : webview.srcDoc) || "webview";
  return isVisible && /* @__PURE__ */React39.createElement("div", null, "Please override the default webview component in the DynamicCardContextProvider to render ", webviewContent, ".");
};
function useDefaultWebview(webview) {
  const [isWebviewVisible, setWebviewVisible] = React39.useState(false);
  return {
    WebviewComponent: /* @__PURE__ */React39.createElement(DefaultWebview, {
      webview,
      isVisible: isWebviewVisible
    }),
    openWebview: () => {
      setWebviewVisible(true);
    }
  };
}
var initialContext = {
  useWebview: useDefaultWebview
};
var DynamicCardContext = createContext(initialContext);
var useDynamicCardContext = () => {
  return useContext(DynamicCardContext);
};
var DynamicCardContextProvider = ({
  children,
  value
}) => {
  const context = React39.useMemo(() => ({
    useWebview: value.useWebview || useDefaultWebview
  }), [value]);
  return /* @__PURE__ */React39.createElement(DynamicCardContext.Provider, {
    value: context
  }, children);
};

// ../internal/src/components/declarative-cards/components/dynamic-card-text.tsx
import React40 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSText as EGDSText10 } from "@egds/react-core/text";
import { EGDSUnformattedHtml } from "@egds/react-core/unformatted-html";

// ../internal/src/components/declarative-cards/helpers/apply-text-styles.ts
var applyTextStyles = (text, bold, italic, strikethrough) => {
  let result = text;
  const applyStyle = (str, substrings, tag) => {
    if ((substrings == null ? void 0 : substrings.length) === 0) {
      return `<${tag}>${str}</${tag}>`;
    }
    let output = str;
    const openTag = `<${tag}>`;
    const closeTag = `</${tag}>`;
    [...substrings].reverse().forEach(substr => {
      let pos = output.lastIndexOf(substr);
      while (pos !== -1) {
        output = output.slice(0, pos) + openTag + substr + closeTag + output.slice(pos + substr.length);
        pos = output.lastIndexOf(substr, pos - 1);
      }
    });
    return output;
  };
  if ((strikethrough == null ? void 0 : strikethrough.length) || (strikethrough == null ? void 0 : strikethrough.length) === 0) {
    result = applyStyle(result, strikethrough, "s");
  }
  if ((italic == null ? void 0 : italic.length) || (italic == null ? void 0 : italic.length) === 0) {
    result = applyStyle(result, italic, "i");
  }
  if ((bold == null ? void 0 : bold.length) || (bold == null ? void 0 : bold.length) === 0) {
    result = applyStyle(result, bold, "b");
  }
  return result;
};

// ../internal/src/components/declarative-cards/components/dynamic-card-text.tsx
var fragment23 = gql24`
  fragment DynamicCardTextFragment on DynamicCardText {
    value
    bold
    size
    theme
    overflow
    subscript
    superscript
    italic
    strikethrough
  }
`;
var DynamicCardText = ({
  data
}) => {
  var _a, _b;
  const {
    value,
    size,
    bold,
    theme,
    overflow,
    subscript,
    superscript,
    italic,
    strikethrough
  } = data;
  const useBoldFontWeight = (bold == null ? void 0 : bold.length) === 0 || (bold == null ? void 0 : bold.length) === 1 && bold[0] === value;
  const props = {
    size: size != null ? size : 300,
    weight: useBoldFontWeight ? "bold" : "regular",
    theme: (_a = theme == null ? void 0 : theme.toLowerCase()) != null ? _a : "default"
  };
  if (overflow) {
    props.overflow = (_b = overflow == null ? void 0 : overflow.toLowerCase()) != null ? _b : "truncate";
  }
  let textContent = value;
  if ((bold == null ? void 0 : bold.length) && !useBoldFontWeight || italic || strikethrough) {
    const result = applyTextStyles(textContent, bold, italic, strikethrough);
    textContent = /* @__PURE__ */React40.createElement(EGDSUnformattedHtml, {
      htmlToParse: result
    });
  }
  if (subscript || superscript) {
    const adjustedProps = __spreadProps(__spreadValues({}, props), {
      size: 100
    });
    return /* @__PURE__ */React40.createElement(React40.Fragment, null, /* @__PURE__ */React40.createElement(EGDSText10, __spreadProps(__spreadValues({}, props), {
      inline: true
    }), textContent), subscript && /* @__PURE__ */React40.createElement(EGDSText10, __spreadProps(__spreadValues({}, adjustedProps), {
      inline: "sub"
    }), subscript), superscript && /* @__PURE__ */React40.createElement(EGDSText10, __spreadProps(__spreadValues({}, adjustedProps), {
      inline: "sup"
    }), superscript));
  }
  return /* @__PURE__ */React40.createElement(EGDSText10, __spreadValues({}, props), textContent);
};
DynamicCardText.fragment = fragment23;
DynamicCardText.displayName = "DynamicCardText";

// ../internal/src/components/declarative-cards/components/dynamic-card-action.tsx
var fragment24 = gql25`
  fragment DynamicCardActionFragment on DynamicCardAction {
    link {
      ... on HttpURI {
        value
      }
    }
    event {
      eventId
      payload
    }
    dialog {
      close {
        ...EGDSButtonFragment
      }
      text {
        ...DynamicCardTextFragment
      }
    }
    properties {
      buttonType
      target
    }
    webview {
      close {
        ...EGDSButtonFragment
      }
      srcDoc
      url {
        relativePath
        value
      }
    }
  }
  ${VirtualAgentEGDSButton.fragment}
  ${DynamicCardText.fragment}
`;
var DynamicCardAction = ({
  text,
  icon,
  data
}) => {
  var _a;
  const {
    link,
    event,
    dialog,
    properties,
    webview
  } = data;
  const {
    publish
  } = useSignalPublisher2();
  const dialogTriggerRef = React41.useRef(null);
  const uniqueDialogId = React41.useMemo(() => `vac-declarative-cards-dialog-${uuidv43()}`, []);
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog4(uniqueDialogId);
  const {
    useWebview
  } = useDynamicCardContext();
  const {
    WebviewComponent,
    openWebview
  } = useWebview(webview);
  const {
    buttonType
  } = properties != null ? properties : {};
  const href = (link == null ? void 0 : link.__typename) === "HttpURI" && link.value.length > 0 ? link.value : void 0;
  const target = UILinkTargetMap[(_a = properties == null ? void 0 : properties.target) != null ? _a : "INTERNAL" /* INTERNAL */];
  const getContent = () => {
    if (text && icon) {
      return /* @__PURE__ */React41.createElement(EGDSLayoutFlex11, {
        space: "one",
        alignItems: "center"
      }, icon && /* @__PURE__ */React41.createElement(Icon, {
        data: icon
      }), text == null ? void 0 : text.value);
    }
    if (text) {
      return text == null ? void 0 : text.value;
    }
    if (icon) {
      return /* @__PURE__ */React41.createElement(Icon, {
        data: icon
      });
    }
  };
  const getDialog = React41.useCallback(() => {
    var _a2;
    if (!(dialog == null ? void 0 : dialog.close) && !(dialog == null ? void 0 : dialog.text)) {
      return null;
    }
    return /* @__PURE__ */React41.createElement(DialogComponent, null, /* @__PURE__ */React41.createElement(EGDSDialog2, {
      dialogShow: isDialogOpen,
      triggerRef: dialogTriggerRef
    }, /* @__PURE__ */React41.createElement(EGDSDialogContent2, null, (_a2 = dialog == null ? void 0 : dialog.text) == null ? void 0 : _a2.map((dialogText, index) => /* @__PURE__ */React41.createElement(DynamicCardText, {
      key: index,
      data: dialogText
    })), /* @__PURE__ */React41.createElement(EGDSSpacingHr, null), (dialog == null ? void 0 : dialog.close) && /* @__PURE__ */React41.createElement(VirtualAgentEGDSButton, {
      data: dialog.close,
      onClick: () => dialogActions.closeDialog(),
      fullWidth: true
    }))));
  }, [isDialogOpen, dialog, dialogActions, DialogComponent]);
  const onClick = React41.useCallback(() => {
    var _a2, _b;
    if (event) {
      publish(new VacDynamicCardSignal("VAC_DYNAMIC_CARD_EVENT" /* Vac_DynamicCardEvent */, {
        eventId: (_a2 = event == null ? void 0 : event.eventId) != null ? _a2 : "",
        payload: (_b = event == null ? void 0 : event.payload) != null ? _b : "",
        message: text == null ? void 0 : text.value
      }));
    }
    if (dialog) {
      dialogActions.openDialog();
    }
    if (webview) {
      openWebview();
    }
  }, [event, dialog, webview, publish, text == null ? void 0 : text.value, dialogActions, openWebview]);
  if (!data || !(text || icon)) {
    return null;
  }
  if (buttonType) {
    const isDialogOrWebview = dialog || webview;
    const props = __spreadProps(__spreadValues({
      href
    }, href && {
      target
    }), {
      domRef: dialogTriggerRef,
      isFullWidth: true,
      onClick: event || isDialogOrWebview ? onClick : void 0,
      size: EGDSButtonSize7.SMALL
      // ElementProperties can be used to control button size if necessary
    });
    const buttonMap = {
      ["PRIMARY" /* PRIMARY */]: EGDSPrimaryButton2,
      ["SECONDARY" /* SECONDARY */]: EGDSSecondaryButton3,
      ["TERTIARY" /* TERTIARY */]: EGDSTertiaryButton4
    };
    return /* @__PURE__ */React41.createElement(React41.Fragment, null, React41.createElement(buttonMap[buttonType], __spreadValues({}, props), [getContent()]), getDialog(), WebviewComponent);
  }
  if (href) {
    return /* @__PURE__ */React41.createElement(EGDSLink4, null, /* @__PURE__ */React41.createElement("a", {
      href,
      target,
      ref: dialogTriggerRef
    }, getContent()));
  }
  if (dialog || webview || event) {
    return /* @__PURE__ */React41.createElement(React41.Fragment, null, /* @__PURE__ */React41.createElement("a", {
      href: "#",
      onClick,
      ref: dialogTriggerRef
    }, /* @__PURE__ */React41.createElement(EGDSLayoutFlex11, {
      space: "one",
      alignItems: "center"
    }, text && /* @__PURE__ */React41.createElement(DynamicCardText, {
      data: text
    }), icon && /* @__PURE__ */React41.createElement(Icon, {
      data: icon
    }))), getDialog(), WebviewComponent);
  }
  return null;
};
DynamicCardAction.displayName = "DynamicCardAction";
DynamicCardAction.fragment = fragment24;

// ../internal/src/components/declarative-cards/components/dynamic-card-cover-image.tsx
import React44 from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex12 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition5 } from "@egds/react-core/layout-position";

// ../internal/src/components/declarative-cards/components/dynamic-card-overlay-text.tsx
import React42 from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSText as EGDSText11 } from "@egds/react-core/text";
var fragment25 = gql26`
  fragment DynamicCardOverlayTextFragment on DynamicCardOverlayText {
    position
    title
  }
`;
var DynamicCardOverlayText = ({
  data
}) => {
  const {
    title
  } = data;
  if (title.length === 0) {
    return null;
  }
  const props = {
    theme: "inverse",
    size: 600,
    weight: "bold"
  };
  return /* @__PURE__ */React42.createElement(EGDSText11, __spreadValues({}, props), title);
};
DynamicCardOverlayText.fragment = fragment25;
DynamicCardOverlayText.displayName = "DynamicCardOverlayText";

// ../internal/src/components/declarative-cards/components/dynamic-card-overlay-toggle.tsx
import React43 from "react";
import { gql as gql27 } from "@apollo/client";
import { EGDSFavoriteSwitch } from "@egds/react-core/switch";
import { useSignalPublisher as useSignalPublisher3 } from "@shared-ui/core-signal-manager/context";
import { VacDynamicCardSignal as VacDynamicCardSignal2 } from "@shared-ui/retail-signals-virtual-agent";
var fragment26 = gql27`
  fragment DynamicCardOverlayToggleFragment on DynamicCardOverlayToggle {
    position
    selected
    action {
      event {
        eventId
        payload
      }
      properties {
        accessibility
      }
    }
  }
`;
var DynamicCardOverlayToggle = ({
  data
}) => {
  var _a, _b;
  const {
    action
  } = data;
  const [selected, setSelected] = React43.useState((_a = data.selected) != null ? _a : false);
  const {
    publish
  } = useSignalPublisher3();
  const {
    event
  } = action != null ? action : {};
  const fireEvent = React43.useCallback(() => {
    if (event) {
      const {
        eventId,
        payload: payload2
      } = event;
      publish(new VacDynamicCardSignal2("VAC_DYNAMIC_CARD_EVENT" /* Vac_DynamicCardEvent */, {
        eventId,
        payload: payload2
      }));
    }
  }, [event, publish]);
  const onClick = () => {
    setSelected(current => !current);
    fireEvent();
  };
  const {
    properties
  } = action != null ? action : {};
  return /* @__PURE__ */React43.createElement(EGDSFavoriteSwitch, {
    checked: selected,
    onChange: onClick,
    label: (_b = properties == null ? void 0 : properties.accessibility) != null ? _b : void 0
  });
};
DynamicCardOverlayToggle.fragment = fragment26;
DynamicCardOverlayToggle.displayName = "DynamicCardOverlayToggle";

// ../internal/src/components/declarative-cards/components/dynamic-card-cover-image.tsx
var fragment27 = gql28`
  fragment DynamicCardCoverImageFragment on Image {
    url
    description
  }
`;
var supportedOverlays = {
  DynamicCardOverlayText,
  DynamicCardOverlayToggle
};
var DynamicCardCoverImage = ({
  data,
  roundedAll,
  overlays
}) => {
  const {
    url,
    description
  } = data;
  const overlayContent = React44.useMemo(() => {
    if (!(overlays == null ? void 0 : overlays.length)) {
      return null;
    }
    const topRight = overlays.filter(({
      position
    }) => position === "TOP_RIGHT" /* TOP_RIGHT */);
    const bottomLeft = overlays.filter(({
      position
    }) => position === "BOTTOM_LEFT" /* BOTTOM_LEFT */);
    return /* @__PURE__ */React44.createElement(React44.Fragment, null, topRight.length ? /* @__PURE__ */React44.createElement(EGDSLayoutPosition5, {
      type: "absolute",
      position: {
        top: "one",
        right: "one",
        zindex: "layer1"
      }
    }, /* @__PURE__ */React44.createElement(EGDSLayoutFlex12, {
      alignItems: "center"
    }, topRight.map((element, i) => React44.createElement(supportedOverlays[element.__typename], {
      key: i,
      data: element
    })))) : null, bottomLeft.length ? /* @__PURE__ */React44.createElement(EGDSLayoutPosition5, {
      type: "absolute",
      position: {
        bottom: "three",
        left: "four",
        zindex: "layer1"
      }
    }, /* @__PURE__ */React44.createElement(EGDSLayoutFlex12, {
      alignItems: "center"
    }, bottomLeft.map((element, i) => React44.createElement(supportedOverlays[element.__typename], {
      key: i,
      data: element
    })))) : null);
  }, [overlays]);
  if (!(url == null ? void 0 : url.length)) {
    return null;
  }
  return /* @__PURE__ */React44.createElement(EGDSFigure, {
    ratio: EGDSFigureAspectRatioType.R16_9,
    className: roundedAll ? "uitk-card-roundcorner-all" : ""
  }, overlayContent, /* @__PURE__ */React44.createElement(EGDSImage, {
    src: url,
    placeholderImage: true,
    alt: description
  }));
};
DynamicCardCoverImage.displayName = "DynamicCardCoverImage";
DynamicCardCoverImage.fragment = fragment27;

// ../internal/src/components/declarative-cards/components/dynamic-card-webview.tsx
import React45 from "react";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar4 } from "@egds/react-core/toolbar";

// ../internal/src/components/quick-replies/virtual-agent-control-end-chat-dialog.tsx
var fragment28 = gql29`
  fragment VirtualAgentControlDialogFragment on VirtualAgentControlDialog {
    close {
      ...EGDSButtonFragment
    }
    open {
      button {
        ...EGDSButtonFragment
      }
      sendMessage {
        attributes {
          incomingEndChatMessageId
          travelerEndChat
        }
        flags {
          actionType
          disableUserInput
          sourceMessageId
        }
        intent
        messageType
        payload
        text
        umid
      }
    }
    text {
      ...DynamicCardTextFragment
    }
  }
  ${DynamicCardText.fragment}
`;
var VirtualAgentControlEndChatDialog = props => {
  const {
    data,
    handleEndChatSend
  } = props;
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog5("va-end-chat-dialog");
  if (!data) {
    return null;
  }
  const {
    open,
    close,
    text
  } = data;
  return /* @__PURE__ */React46.createElement(DialogComponent, null, /* @__PURE__ */React46.createElement(EGDSDialog3, {
    dialogShow: isDialogOpen
  }, /* @__PURE__ */React46.createElement(EGDSDialogContent3, null, text == null ? void 0 : text.map((dialogText, index) => /* @__PURE__ */React46.createElement(DynamicCardText, {
    key: index,
    data: dialogText
  })), /* @__PURE__ */React46.createElement(EGDSSpacingHr2, null), /* @__PURE__ */React46.createElement(VirtualAgentEGDSButton, {
    data: open.button,
    onClick: handleEndChatSend,
    fullWidth: true
  }), /* @__PURE__ */React46.createElement(EGDSSpacingHr2, null), /* @__PURE__ */React46.createElement(VirtualAgentEGDSButton, {
    data: close,
    onClick: () => {
      dialogActions.closeDialog();
    },
    fullWidth: true
  }))));
};
VirtualAgentControlEndChatDialog.fragment = fragment28;
VirtualAgentControlEndChatDialog.displayName = "VirtualAgentControlEndChatDialog";

// ../internal/src/components/quick-replies/virtual-agent-control-quick-reply-item.tsx
import React47 from "react";
import { gql as gql30 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex13, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
var fragment29 = gql30`
  fragment VirtualAgentControlQuickReplyItemFragment on VirtualAgentControlQuickReplyItem {
    button {
      ...EGDSButtonFragment
    }
    payload
    outboundMessage
    isEndChat
    isSticky
    dialog {
      ...VirtualAgentControlDialogFragment
    }
  }
  ${VirtualAgentControlEndChatDialog.fragment}
  ${VirtualAgentEGDSButton.fragment}
`;
var VirtualAgentControlQuickReplyItem = ({
  data,
  handleEndChatQRClick
}) => {
  const {
    button,
    payload: payload2,
    outboundMessage,
    isEndChat
  } = data;
  const [conversation] = useConversationState();
  const handleSend = useOperation("SEND_MESSAGE" /* SEND_MESSAGE */);
  const handleCreateConversation = useOperation("CREATE_CONVERSATION" /* CREATE_CONVERSATION */);
  function handleOnclick() {
    const message = outboundMessage != null ? outboundMessage : "";
    const messageData = {
      message,
      payload: payload2,
      messageType: "POSTBACK" /* POSTBACK */
    };
    if (isEndChat) {
      return handleEndChatQRClick == null ? void 0 : handleEndChatQRClick();
    }
    if (isFakeIntent(payload2) && conversation.state === "CLOSED" /* CLOSED */) {
      return handleCreateConversation == null ? void 0 : handleCreateConversation();
    }
    handleSend == null ? void 0 : handleSend(messageData);
  }
  return /* @__PURE__ */React47.createElement(EGDSLayoutFlex13, {
    direction: "column"
  }, /* @__PURE__ */React47.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "start",
    maxWidth: "seventy_two"
  }, /* @__PURE__ */React47.createElement(EGDSSpacing7, {
    margin: {
      blockstart: "half"
    }
  }, /* @__PURE__ */React47.createElement(VirtualAgentEGDSButton, {
    data: button,
    onClick: () => handleOnclick()
  }))));
};
VirtualAgentControlQuickReplyItem.fragment = fragment29;
VirtualAgentControlQuickReplyItem.displayName = "VirtualAgentControlQuickReplyItem";

// ../internal/src/components/quick-replies/virtual-agent-control-quick-replies.tsx
function parseFlagsAndAttributes(sendMessagePayload) {
  const flags = omit(sendMessagePayload.flags, "__typename");
  const attributes = omit(sendMessagePayload.attributes, "__typename");
  return __spreadProps(__spreadValues({}, sendMessagePayload), {
    message: sendMessagePayload.text,
    attributes,
    flags
  });
}
var VirtualAgentControlQuickReplies = () => {
  const [, conversationMessages] = useMessagesState();
  const [endChatQuickReply, setEndChatQuickReply] = useState4();
  const [, dialogActions] = useDialog6("va-end-chat-dialog");
  const handleSend = useOperation("SEND_MESSAGE" /* SEND_MESSAGE */);
  const handleEndChatSend = () => {
    var _a, _b;
    if (!((_b = (_a = endChatQuickReply == null ? void 0 : endChatQuickReply.dialog) == null ? void 0 : _a.open) == null ? void 0 : _b.sendMessage)) {
      return;
    }
    const actionWithFallback = parseFlagsAndAttributes(endChatQuickReply.dialog.open.sendMessage);
    handleSend == null ? void 0 : handleSend(actionWithFallback);
    dialogActions.closeDialog();
    setEndChatQuickReply(null);
  };
  const handleEndChatQRClick = () => {
    dialogActions.openDialog();
  };
  useEffect5(() => {
    var _a;
    if ((_a = conversationMessages == null ? void 0 : conversationMessages.quickReplies) == null ? void 0 : _a.length) {
      for (let index = 0; index < conversationMessages.quickReplies.length; index += 1) {
        const quickReply = conversationMessages.quickReplies[index];
        if (quickReply.isEndChat) {
          setEndChatQuickReply(quickReply);
          break;
        }
      }
    }
  }, [conversationMessages == null ? void 0 : conversationMessages.quickReplies]);
  const quickReplies = conversationMessages == null ? void 0 : conversationMessages.quickReplies.filter(quckRply => !quckRply.isSticky);
  if (endChatQuickReply) {
    quickReplies.unshift(endChatQuickReply);
  }
  if (!(quickReplies == null ? void 0 : quickReplies.length)) {
    return null;
  }
  const toQuickReply = (quickReply, index) => /* @__PURE__ */React48.createElement(VirtualAgentControlQuickReplyItem, __spreadValues({
    data: quickReply,
    key: `quick_reply_${index}`
  }, quickReply.isEndChat && {
    handleEndChatQRClick
  }));
  return /* @__PURE__ */React48.createElement(React48.Fragment, null, /* @__PURE__ */React48.createElement(EGDSSpacing8, {
    padding: {
      blockend: "three",
      inline: "two"
    }
  }, /* @__PURE__ */React48.createElement(EGDSLayoutFlex14, {
    direction: "row",
    space: "two",
    wrap: "wrap"
  }, quickReplies.map(toQuickReply))), (endChatQuickReply == null ? void 0 : endChatQuickReply.dialog) && /* @__PURE__ */React48.createElement(VirtualAgentControlEndChatDialog, {
    data: endChatQuickReply.dialog,
    handleEndChatSend
  }));
};

// ../internal/src/components/trigger/virtual-agent-control-trigger.tsx
import React50, { useEffect as useEffect6 } from "react";
import { gql as gql32 } from "@apollo/client";

// ../internal/src/components/trigger/__private/__fragments/floating-action-button.tsx
import React49 from "react";
import { gql as gql31 } from "@apollo/client";
import { EGDSBadgeNotification } from "@egds/react-core/badge";
import { EGDSSecondaryButton as EGDSSecondaryButton4 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon7, EGDSIconSize as EGDSIconSize4 } from "@egds/react-core/icons";
import { EGDSLayoutPosition as EGDSLayoutPosition6 } from "@egds/react-core/layout-position";
import { EGDSText as EGDSText12 } from "@egds/react-core/text";
import { useProvidedState as useProvidedState12 } from "@shared-ui/provided-state-context";
var fragment30 = gql31`
  fragment FloatingActionButtonFragment on UIFloatingActionButton {
    disabled
    primary
    icon {
      description
      id
      title
    }
  }
`;
var FloatingActionButton = ({
  onClick,
  unreadMessageCount,
  data
}) => {
  var _a, _b;
  const {
    disabled,
    icon,
    primary
  } = data;
  const [state] = useProvidedState12();
  const count = unreadMessageCount ? unreadMessageCount.toString() : "0";
  if (!icon && !primary) {
    return null;
  }
  return /* @__PURE__ */React49.createElement(EGDSLayoutPosition6, {
    type: "fixed",
    position: {
      bottom: "four",
      right: "four"
    },
    onClick
  }, /* @__PURE__ */React49.createElement(EGDSLayoutPosition6, {
    type: "absolute",
    position: {
      top: "minus-three",
      left: "minus-one"
    }
  }, /* @__PURE__ */React49.createElement(EGDSBadgeNotification, {
    count,
    theme: "action",
    visible: !!unreadMessageCount
  })), /* @__PURE__ */React49.createElement(EGDSSecondaryButton4, {
    type: "button",
    disabled
  }, icon && /* @__PURE__ */React49.createElement(EGDSIcon7, {
    name: icon.id,
    id: icon.id,
    title: (_a = icon.title) != null ? _a : void 0,
    description: (_b = icon.description) != null ? _b : void 0,
    size: EGDSIconSize4.MEDIUM
  }), primary && /* @__PURE__ */React49.createElement(EGDSText12, {
    whiteSpace: "nowrap"
  }, primary)));
};
FloatingActionButton.fragment = fragment30;
FloatingActionButton.displayName = "VirtualAgentControlTrigger";

// ../internal/src/components/trigger/virtual-agent-control-trigger.tsx
var fragment31 = gql32`
  fragment VirtualAgentControlTriggerFragment on VirtualAgentControlTrigger {
    analytics {
      ... on VirtualAgentControlImpressionAnalyticEvent {
        eventName
        eventVersion
        payload
      }
      ... on VirtualAgentControlInteractionAnalyticEvent {
        eventName
        eventVersion
        payload
      }
      ... on VirtualAgentControlOutcomeAnalyticEvent {
        eventName
        eventVersion
        payload
      }
      ... on VirtualAgentControlPageViewAnalyticEvent {
        eventName
        eventVersion
        payload
      }
    }
    button {
      ...EGDSButtonFragment
      ...FloatingActionButtonFragment
    }
  }
  ${VirtualAgentEGDSButton.fragment}
  ${FloatingActionButton.fragment}
`;
var VirtualAgentControlTrigger = ({
  onClick,
  data
}) => {
  const {
    button
  } = data;
  const [conversation] = useConversationState();
  const [, conversationMessages] = useMessagesState();
  const {
    trackEvent
  } = useAnalytics();
  useEffect6(() => {
    trackEvent(buildClickstreamEventPaylaod("VIRTUAL_AGENT_ICON_VIEWED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type));
  }, [conversation == null ? void 0 : conversation.conversationId]);
  if (!button) {
    return null;
  }
  const handleClick = () => {
    trackEvent(buildClickstreamEventPaylaod("VIRTUAL_AGENT_ICON_SELECTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type));
    onClick == null ? void 0 : onClick();
  };
  switch (button.__typename) {
    case "UIPrimaryFloatingActionButton":
    case "UISecondaryFloatingActionButton":
      return /* @__PURE__ */React50.createElement(FloatingActionButton, {
        data: button,
        onClick: handleClick,
        unreadMessageCount: conversationMessages == null ? void 0 : conversationMessages.unreadMessageCount
      });
    case "UIPrimaryButton":
    case "UISecondaryButton":
    case "UITertiaryButton":
      return /* @__PURE__ */React50.createElement(VirtualAgentEGDSButton, {
        data: button,
        onClick: handleClick
      });
    default:
      return null;
  }
};
VirtualAgentControlTrigger.fragment = fragment31;
VirtualAgentControlTrigger.displayName = "VirtualAgentControlTrigger";

// ../internal/src/components/typing-indicator/typing-indicator.tsx
import React51 from "react";
import { EGDSCard as EGDSCard2 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex15, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText13 } from "@egds/react-core/text";
import { LoadingDots } from "@egds/react-virtual-agent-control";
var VirtualAgentControlTypingIndicator = () => {
  var _a;
  const [, activityIndicators] = useParticipantState();
  const {
    typeVirtualAgent
  } = (_a = use_prefetch_localization_content_default(LocalizationContentKeys.PARTICIPANT)) != null ? _a : {};
  if (!activityIndicators.length) {
    return null;
  }
  let activityIndicatorMessage = null;
  if (activityIndicators.length > 0 && activityIndicators[0].activeIndicatorMessage) {
    activityIndicatorMessage = activityIndicators[0].activeIndicatorMessage;
  }
  let activityIndicatorEyebrow = null;
  if (activityIndicators.length > 0 && activityIndicators[0].eyebrow) {
    activityIndicatorEyebrow = activityIndicators[0].eyebrow;
  }
  return (
    // TO DO: change author once participant call is added
    /* @__PURE__ */
    React51.createElement(EGDSLayoutFlex15, {
      direction: "column"
    }, /* @__PURE__ */React51.createElement(EGDSLayoutFlexItem8, {
      alignSelf: "start"
    }, /* @__PURE__ */React51.createElement(EGDSText13, {
      size: 200,
      spacing: "half",
      theme: "standard"
    }, activityIndicatorEyebrow || typeVirtualAgent)), /* @__PURE__ */React51.createElement(EGDSLayoutFlex15, {
      "data-test-id": "text-dots-align",
      role: "status",
      "aria-live": "polite"
    }, /* @__PURE__ */React51.createElement(EGDSCard2, {
      padded: true,
      backgroundTheme: "secondary"
    }, /* @__PURE__ */React51.createElement(EGDSLayoutFlex15, {
      direction: "row",
      space: "two",
      alignItems: "center"
    }, activityIndicatorMessage && /* @__PURE__ */React51.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React51.createElement(EGDSText13, {
      size: 300,
      weight: "regular",
      "data-test-id": "display-message",
      className: "activity-indicator-text"
    }, activityIndicatorMessage)), /* @__PURE__ */React51.createElement(EGDSLayoutFlexItem8, {
      alignSelf: "start",
      maxWidth: "seventy_two"
    }, /* @__PURE__ */React51.createElement(EGDSSpacing9, {
      margin: {
        blockstart: "half"
      }
    }, /* @__PURE__ */React51.createElement("span", null, /* @__PURE__ */React51.createElement(LoadingDots, null))))))))
  );
};

// ../internal/src/hooks/participant-event-markers/use-participant-event-markers.tsx
import { useSignalSubscriber } from "@shared-ui/core-signal-manager/context";
import { useProvidedState as useProvidedState13 } from "@shared-ui/provided-state-context";
import { VacParticipantEventsSignal } from "@shared-ui/retail-signals-virtual-agent";
var useParticipantEventMarkers = () => {
  const [, dispatch] = useProvidedState13();
  const [chatInstance] = useChatInstanceState();
  const {
    participantTypesForEventMarkers,
    showParticipantEventMarker
  } = (chatInstance == null ? void 0 : chatInstance.chatConfig) || {};
  useSignalSubscriber("VAC_PARTICIPANT_EVENTS" /* VAC_Participant_Event */, VacParticipantEventsSignal, {
    onSuccess: ({
      payload: payload2
    }) => {
      const {
        participantType,
        conversationId,
        markerString,
        timeStamp,
        participantId
      } = payload2;
      if (participantTypesForEventMarkers.includes(participantType) && showParticipantEventMarker) {
        dispatch({
          type: "ADD_SEPERATOR_MESSAGE" /* ADD_SEPERATOR_MESSAGE */,
          payload: {
            primary: markerString,
            conversationId,
            timeStamp,
            participantId
          }
        });
      }
    }
  });
};

// ../internal/src/hooks/use-heartbeat.tsx
import React52 from "react";
import { useSignalPublisher as useSignalPublisher4 } from "@shared-ui/core-signal-manager/context";
import { VacStartHeartbeatSignal } from "@shared-ui/retail-signals-virtual-agent";
function useHeartbeat() {
  var _a, _b;
  const [chatInstanceState] = useChatInstanceState();
  const [conversation,, conversationContext] = useConversationState();
  const {
    publish
  } = useSignalPublisher4();
  const presenceConfig = (_a = chatInstanceState == null ? void 0 : chatInstanceState.chatConfig) == null ? void 0 : _a.presenceConfig;
  React52.useEffect(() => {
    var _a2;
    if ((presenceConfig == null ? void 0 : presenceConfig.mode) === "HEARTBEAT" /* HEARTBEAT */ && (conversation == null ? void 0 : conversation.state) === "ACTIVE" /* ACTIVE */) {
      const heartbeatPayload = {
        conversationContext,
        interval: presenceConfig.heartbeatIntervalInMillis,
        channelOriginId: (_a2 = chatInstanceState == null ? void 0 : chatInstanceState.chatConfig) == null ? void 0 : _a2.channelOriginId
      };
      publish(new VacStartHeartbeatSignal("VAC_START_HEARTBEAT" /* VAC_StartHeartbeat */, heartbeatPayload));
    }
  }, [conversation == null ? void 0 : conversation.state, conversationContext, presenceConfig, publish, (_b = chatInstanceState == null ? void 0 : chatInstanceState.chatConfig) == null ? void 0 : _b.channelOriginId]);
  return [];
}

// ../internal/src/hooks/use-notification-sound.tsx
import { useEffect as useEffect7, useRef } from "react";
import { useSignalSubscriber as useSignalSubscriber2 } from "@shared-ui/core-signal-manager/context";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { useProvidedState as useProvidedState14 } from "@shared-ui/provided-state-context";
import { VacNotificationSoundSignal } from "@shared-ui/retail-signals-virtual-agent";

// ../internal/src/helpers/events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var PREFIX = "VacLogging";
var COMPONENT_NAME = "TRAVELLER_VA";
var EVENTS = {
  ERROR: new SystemEvent(SystemEventLevel.ERROR, `${PREFIX}.${COMPONENT_NAME}.error.message`)
};

// ../internal/src/hooks/use-notification-sound.tsx
var useAudioNotification = vacId => {
  var _a, _b, _c, _d;
  const [state] = useProvidedState14();
  const ref = useRef();
  const logging = useLoggerEvents(EVENTS);
  const playSoundRef = useRef(true);
  const playSound = async audioUrl => {
    try {
      const audio = new Audio(audioUrl);
      await audio.play();
    } catch (error) {
      logging.ERROR.log(error.message);
    }
  };
  useEffect7(() => {
    var _a2, _b2, _c2, _d2;
    const chatConfig = (_b2 = (_a2 = state.chatInstancesState) == null ? void 0 : _a2[vacId]) == null ? void 0 : _b2.chatConfig;
    const settingMenuItemState = (_d2 = (_c2 = state.chatInstancesState) == null ? void 0 : _c2[vacId]) == null ? void 0 : _d2.settingMenuItemState;
    ref.current = {
      chatConfig,
      settingMenuItemState
    };
  }, [(_b = (_a = state.chatInstancesState) == null ? void 0 : _a[vacId]) == null ? void 0 : _b.chatConfig, (_d = (_c = state.chatInstancesState) == null ? void 0 : _c[vacId]) == null ? void 0 : _d.settingMenuItemState]);
  const handleNewMessage = (audioUrl, enableSound, isSoundMuted) => {
    if (!enableSound || isSoundMuted) {
      return;
    }
    if (audioUrl && playSoundRef.current) {
      playSound(audioUrl);
      playSoundRef.current = false;
      setTimeout(() => {
        playSoundRef.current = true;
      }, 1e3);
    }
  };
  useSignalSubscriber2("VAC_NOTIFICATION_SOUND" /* VAC_NotificationSound */, VacNotificationSoundSignal, {
    onSuccess: () => {
      var _a2, _b2, _c2, _d2;
      const {
        audioUrl,
        enableSound
      } = ((_b2 = (_a2 = ref.current) == null ? void 0 : _a2.chatConfig) == null ? void 0 : _b2.notificationConfig) || {};
      const isSoundMuted = (_d2 = (_c2 = ref.current) == null ? void 0 : _c2.settingMenuItemState) == null ? void 0 : _d2.toggleSound;
      handleNewMessage(audioUrl, enableSound, isSoundMuted);
    }
  });
  return {
    ref,
    handleNewMessage
  };
};
var use_notification_sound_default = useAudioNotification;

// ../internal/src/providers/dialog-provider/dialog-provider-config.tsx
import React53 from "react";
import * as ReactDOM from "react-dom";
var CustomLayer = props => {
  const {
    id,
    isOpen,
    children,
    rootRef
  } = props;
  if (!isOpen) {
    return null;
  }
  if (!rootRef.current) {
    return null;
  }
  const layer = /* @__PURE__ */React53.createElement("div", {
    role: "dialog",
    className: "uitk-dialog-layer uitk-dialog-layer-responsive layer-overlay-active",
    id
  }, children || null);
  return ReactDOM.createPortal(layer, rootRef.current, `layer-${id}`);
};
function getDialogProviderConfig(rootRef) {
  return {
    useDialogControl: (id, dialogQueryKey, isOpen, setIsOpen) => {
      const actions = {
        openDialog: () => setIsOpen(true),
        closeDialog: () => setIsOpen(false),
        toggleDialog: () => setIsOpen(!isOpen)
      };
      return {
        ComponentFactory: props => {
          const {
            children
          } = props;
          return /* @__PURE__ */React53.createElement(CustomLayer, {
            id,
            isOpen,
            rootRef
          }, children);
        },
        actions
      };
    }
  };
}

// ../internal/src/providers/timer/timer-provider.tsx
import React54 from "react";

// ../internal/src/providers/timer/constants.ts
var constants_exports = {};
__export(constants_exports, {
  CHAT_MOUNTED: () => CHAT_MOUNTED,
  CREATE_CONVERSATION: () => CREATE_CONVERSATION,
  DEFAULT: () => DEFAULT2,
  INIT: () => INIT,
  TRIGGER_CLICKED: () => TRIGGER_CLICKED,
  TRIGGER_MOUNTED: () => TRIGGER_MOUNTED
});
var INIT = "orchestrator-init";
var CHAT_MOUNTED = "chat-mounted";
var TRIGGER_MOUNTED = "trigger-mounted";
var TRIGGER_CLICKED = "trigger-clicked";
var CREATE_CONVERSATION = "create-conversation";
var DEFAULT2 = {
  startTimer: id => null,
  getTime: id => -1
};

// ../internal/src/providers/timer/timer-provider.tsx
var Context = React54.createContext(DEFAULT2);
var TimerProvider = ({
  children
}) => {
  const [timers, setTimers] = React54.useState({});
  const startTimer = id => {
    if (timers[id]) {
      return;
    }
    setTimers(prev => __spreadProps(__spreadValues({}, prev), {
      [id]: Date.now()
    }));
  };
  const getTime = id => {
    if (!timers[id]) {
      return -1;
    }
    return Date.now() - timers[id];
  };
  const value = React54.useMemo(() => ({
    startTimer,
    getTime
  }), [startTimer, getTime, timers, setTimers]);
  return /* @__PURE__ */React54.createElement(Context.Provider, {
    value
  }, children);
};
TimerProvider.displayName = "TimerProvider";
var useTimers = () => {
  const timers = React54.useContext(Context);
  return timers;
};

// ../internal/src/store/orchestrator-state/reducers.ts
import isEqual2 from "lodash.isequal";

// ../internal/src/store/orchestrator-state/orchestrator-state.ts
var initOrchestratorState = {
  vacConfig: {
    authToken: "",
    websocket: null
  },
  initializationStatus: "RUNNING" /* RUNNING */,
  lastWebsocketDisconnectTime: null
};

// src/utils/signals/subscriber.tsx
import { useSignalSubscriber as useSignalSubscriber3 } from "@shared-ui/core-signal-manager/context";
import { VacDynamicCardSignal as VacDynamicCardSignal3, VacSendMessageSignal } from "@shared-ui/retail-signals-virtual-agent";

// src/hooks/use-send-message.tsx
import React55 from "react";
import { useMutation } from "@apollo/client";
import { v4 as uuidv44 } from "uuid";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useSignalPublisher as useSignalPublisher5 } from "@shared-ui/core-signal-manager/context";
import { VacChatMessageSendFailedSignal, VacChatMessageSentSignal } from "@shared-ui/retail-signals-virtual-agent";

// src/service/send-message/send-message.tsx
import { gql as gql33 } from "@apollo/client";
var __SendMessageMutation = gql33`
  mutation VirtualAgentSendMessageMutation(
    $authenticationConfig: AuthenticationConfigInput
    $context: ContextInput!
    $message: VirtualAgentControlMessageInput!
    $conversationContext: ConversationContextInput!
  ) {
    sendMessage(authenticationConfig: $authenticationConfig, context: $context, messageInput: $message, conversationContext: $conversationContext) {
      deliveryStatus
      umid
      messageId
    }
  }
`;

// src/hooks/use-send-message.tsx
function dispatchEventByMessageType(messageType, umid, updatedMessage, dispatch) {
  switch (messageType) {
    case "FILE" /* FILE */:
      dispatch({
        type: "UPDATE_OUTBOUND_MESSAGE_ELEMENT" /* UPDATE_OUTBOUND_MESSAGE_ELEMENT */,
        payload: {
          umid,
          outboundMessageData: updatedMessage
        }
      });
      break;
    default:
      dispatch({
        type: "UPDATE_OUTBOUND_MESSAGE" /* UPDATE_OUTBOUND_MESSAGE */,
        payload: {
          umid,
          outboundMessageData: updatedMessage
        }
      });
  }
}
function doSendMessage(sendMessageMutation, mutationParams, dispatch, publishSendMessage, messageType, messageContent, isRetry = false) {
  sendMessageMutation({
    variables: mutationParams
  }).then(result => {
    const {
      sendMessage
    } = result.data;
    if (!sendMessage) {
      return;
    }
    const {
      deliveryStatus,
      umid,
      messageId
    } = sendMessage;
    const updatedMessage = {
      messageId,
      status: deliveryStatus,
      deliveryFailed: isRetry,
      messageContent
    };
    dispatchEventByMessageType(messageType, umid, updatedMessage, dispatch);
    publishSendMessage(messageId, isRetry);
  }, /* istanbul ignore next -- @preserve */
  error => {
    const {
      umid
    } = mutationParams.message;
    const updatedMessage = {
      status: messageContent == null ? void 0 : messageContent.statusNotDelivered,
      messageContent
    };
    dispatchEventByMessageType(messageType, umid, updatedMessage, dispatch);
    publishSendMessage();
  });
}
function useSendMessage() {
  const {
    context
  } = useBexApi4();
  const sendCreateConversationRequest = useOperation("CREATE_CONVERSATION" /* CREATE_CONVERSATION */);
  const [conversation,, conversationContext] = useConversationState();
  const [,, messagesDispatch] = useMessagesState();
  const [authenticationConfig] = useAuthenticationConfig();
  const {
    publish
  } = useSignalPublisher5();
  const [sendMessage] = useMutation(__SendMessageMutation);
  const messageContent = use_prefetch_localization_content_default(LocalizationContentKeys.MESSAGE);
  const {
    outboundMessageContextAccessibilityLabel
  } = use_prefetch_localization_content_default(LocalizationContentKeys.PARTICIPANT) || {};
  const publishSendMessage = React55.useCallback((messageId, isRetry = false) => {
    let event;
    if (messageId) {
      event = new VacChatMessageSentSignal("VAC_CHAT_MESSAGE_SENT" /* VAC_ChatMsgSent */, {
        messageId,
        isRetry
      });
    } else {
      event = new VacChatMessageSendFailedSignal("VAC_CHAT_MESSAGE_SEND_FAILED" /* VAC_ChatMsgSendFailed */, null);
    }
    publish(event);
  }, [publish]);
  const handleSend = React55.useCallback(async messageData => {
    if (conversation.state === "CLOSED" /* CLOSED */) {
      await (sendCreateConversationRequest == null ? void 0 : sendCreateConversationRequest());
    }
    const umid =
    // eslint-disable-next-line no-nested-ternary
    (messageData == null ? void 0 : messageData.messageType) === "FILE" /* FILE */ ? messageData.umid : messageData.operation === "retry" ? messageData.umid : uuidv44();
    const mutationParams = __spreadProps(__spreadValues({}, (authenticationConfig == null ? void 0 : authenticationConfig.channelOriginId) && {
      authenticationConfig
    }), {
      context,
      message: __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({
        text: messageData == null ? void 0 : messageData.message
      }, (messageData == null ? void 0 : messageData.attachment) && {
        attachments: messageData.attachment
      }), (messageData == null ? void 0 : messageData.payload) && {
        payload: messageData.payload
      }), (messageData == null ? void 0 : messageData.intent) && {
        intent: messageData.intent
      }), (messageData == null ? void 0 : messageData.messageType) && {
        messageType: messageData.messageType
      }), (messageData == null ? void 0 : messageData.messageTriggerLocation) && {
        messageTriggerLocation: messageData.messageTriggerLocation
      }), (messageData == null ? void 0 : messageData.flags) && {
        flags: messageData.flags
      }), (messageData == null ? void 0 : messageData.attributes) && {
        attributes: messageData.attributes
      }), {
        umid
      }),
      conversationContext
    });
    if (messageData.messageType === "FILE" /* FILE */) {
      if (messageData.operation === "retry") {
        dispatchEventByMessageType("FILE" /* FILE */, umid, {
          messageId: umid,
          status: messageContent == null ? void 0 : messageContent.statusSending,
          deliveryFailed: true,
          messageContent
        }, messagesDispatch);
        messagesDispatch({
          type: "SET_QUICK_REPLIES" /* SET_QUICK_REPLIES */,
          payload: {
            message: []
          }
        });
        doSendMessage(sendMessage, mutationParams, messagesDispatch, publishSendMessage, "FILE" /* FILE */, messageContent, true);
      } else {
        doSendMessage(sendMessage, mutationParams, messagesDispatch, publishSendMessage, "FILE" /* FILE */, messageContent);
      }
    } else if (mutationParams.message.text) {
      if (messageData.operation === "retry") {
        dispatchEventByMessageType("TEXT" /* TEXT */, umid, {
          messageId: umid,
          status: messageContent == null ? void 0 : messageContent.statusSending,
          deliveryFailed: true,
          messageContent
        }, messagesDispatch);
        messagesDispatch({
          type: "SET_QUICK_REPLIES" /* SET_QUICK_REPLIES */,
          payload: {
            message: []
          }
        });
        doSendMessage(sendMessage, mutationParams, messagesDispatch, publishSendMessage, "", messageContent, true);
      } else {
        const outboundMessage = createOutboundTextMessage(messageData == null ? void 0 : messageData.message, messageContent == null ? void 0 : messageContent.statusSending, umid, outboundMessageContextAccessibilityLabel);
        const outboundMessageGroup = createOutboundMessageElementGroup([outboundMessage]);
        messagesDispatch({
          type: "ADD_MESSAGE" /* ADD_MESSAGE */,
          payload: {
            message: outboundMessageGroup,
            messageContent
          }
        });
        messagesDispatch({
          type: "SET_QUICK_REPLIES" /* SET_QUICK_REPLIES */,
          payload: {
            message: []
          }
        });
        doSendMessage(sendMessage, mutationParams, messagesDispatch, publishSendMessage, "", messageContent);
      }
    }
  }, [authenticationConfig, context, conversationContext, sendMessage, messagesDispatch, publishSendMessage]);
  return [handleSend];
}

// src/utils/signals/subscriber.tsx
var VacSignalSubscriber = () => {
  const [handleSend] = useSendMessage();
  useSignalSubscriber3("VAC_SEND_MESSAGE", VacSendMessageSignal, {
    onSuccess: signal => {
      const {
        messageData
      } = signal.payload;
      handleSend == null ? void 0 : handleSend(messageData);
    }
  });
  useSignalSubscriber3("VAC_DYNAMIC_CARD_EVENT", VacDynamicCardSignal3, {
    onSuccess: signal => {
      const {
        eventId,
        payload: payload2,
        message
      } = signal.payload;
      if (eventId === "VAC_DCF_POSTBACK") {
        const messageData = {
          message,
          payload: payload2,
          messageType: "POSTBACK"
        };
        handleSend == null ? void 0 : handleSend(messageData);
      }
    }
  });
  return null;
};

// src/events.ts
import { SystemEvent as SystemEvent2, SystemEventLevel as SystemEventLevel2 } from "@shared-ui/logger-context";
var PREFIX2 = "VacLogging";
var COMPONENT_NAME2 = "GENERIC_CHAT";
var EVENTS2 = {
  INITIALIZATION_OVERALL: new SystemEvent2(SystemEventLevel2.INFO, `${PREFIX2}.${COMPONENT_NAME2}.initialization.overall`),
  INITIALIZATION_TRIGGER: new SystemEvent2(SystemEventLevel2.INFO, `${PREFIX2}.${COMPONENT_NAME2}.initialization.trigger`),
  INITIALIZATION_CHAT: new SystemEvent2(SystemEventLevel2.INFO, `${PREFIX2}.${COMPONENT_NAME2}.initialization.chat`),
  INITIALIZATION_CONNECTED: new SystemEvent2(SystemEventLevel2.INFO, `${PREFIX2}.${COMPONENT_NAME2}.initialization.connected`),
  INITIALIZATION_MESSAGE: new SystemEvent2(SystemEventLevel2.INFO, `${PREFIX2}.${COMPONENT_NAME2}.initialization.message`)
};

// src/hooks/use-chat.tsx
import { useQuery } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";

// src/service/chat/chat.tsx
import { gql as gql65 } from "@apollo/client";

// ../internal/src/components/messages/inbound-message-group/inbound-message-group.tsx
import React84 from "react";
import { gql as gql58 } from "@apollo/client";
import { v4 as uuidv47 } from "uuid";
import { EGDSLayoutFlex as EGDSLayoutFlex30, EGDSLayoutFlexItem as EGDSLayoutFlexItem18 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing21 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText22 } from "@egds/react-core/text";

// ../internal/src/components/messages/inbound-message/inbound-message.tsx
import React83 from "react";
import { gql as gql57 } from "@apollo/client";

// ../internal/src/components/messages/inbound-message/components/inbound-card-message.tsx
import React56 from "react";
import { gql as gql34 } from "@apollo/client";
import { EGDSCard as EGDSCard3 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex16, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5, EGDSText as EGDSText14 } from "@egds/react-core/text";
var fragment32 = gql34`
  fragment VirtualAgentControlInboundCardMessageFragment on VirtualAgentControlInboundCardMessage {
    eyebrow
    metadata {
      ... on VirtualAgentControlMessageMetadata {
        timeStamp
        messageId
        messageContextAccessibilityLabel
      }
    }
    stateUpdates {
      chatInput {
        interactionMode
        chatInputStatus
      }
    }
    header
    primary
  }
`;
var VirtualAgentControlInboundCardMessage = ({
  data
}) => {
  const {
    primary,
    header
  } = data;
  return /* @__PURE__ */React56.createElement(EGDSLayoutFlex16, {
    direction: "column"
  }, /* @__PURE__ */React56.createElement(EGDSLayoutFlexItem9, {
    alignSelf: "start"
  }, /* @__PURE__ */React56.createElement(EGDSSpacing10, {
    margin: {
      blockstart: "half"
    }
  }, /* @__PURE__ */React56.createElement(EGDSCard3, {
    padded: true,
    border: true
  }, header && /* @__PURE__ */React56.createElement(EGDSHeading5, {
    size: 6,
    tag: "h2"
  }, header), /* @__PURE__ */React56.createElement(EGDSText14, {
    size: 300,
    spacing: "two"
  }, primary)))));
};
VirtualAgentControlInboundCardMessage.fragment = fragment32;
VirtualAgentControlInboundCardMessage.displayName = "VirtualAgentControlInboundCardMessage";

// ../internal/src/components/messages/inbound-message/components/inbound-dynamic-card-message.tsx
import React78 from "react";
import { gql as gql53 } from "@apollo/client";
import { EGDSCard as EGDSCard6 } from "@egds/react-core/cards";
import { EGDSCarousel as EGDSCarousel2 } from "@egds/react-core/carousel";
import { EGDSLayoutFlex as EGDSLayoutFlex26, EGDSLayoutFlexItem as EGDSLayoutFlexItem14 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText19 } from "@egds/react-core/text";

// ../internal/src/providers/dynamic-card/vac-dynamic-card-context.tsx
import React58 from "react";
import { v4 as uuidv45 } from "uuid";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";

// ../internal/src/components/webview/webview.tsx
import React57 from "react";
import { EGDSSheet as EGDSSheet3, EGDSSheetContent as EGDSSheetContent3, EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar5 } from "@egds/react-core/toolbar";
var Webview = props => {
  const {
    isOpen,
    onCloseCallback,
    action,
    embedded,
    DialogComponent
  } = props;
  const handleSend = useOperation("SEND_MESSAGE" /* SEND_MESSAGE */);
  const attachmentStringMap = use_prefetch_localization_content_default(LocalizationContentKeys.DIALOG);
  const {
    uri,
    toolbar: {
      primary
    },
    srcDoc
  } = action;
  const [title, setTitle] = React57.useState(primary);
  const handleMessage = React57.useCallback(event => {
    const {
      data
    } = event;
    if (data.source === "webview") {
      if (data.title) {
        setTitle(data.title);
      }
      if (data.close) {
        onCloseCallback(false);
      }
      if (data.payload) {
        const message = {
          messageType: data.messageType,
          payload: data.payload
        };
        handleSend == null ? void 0 : handleSend(message);
      }
    }
  }, [onCloseCallback, handleSend, setTitle]);
  React57.useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [handleMessage]);
  const renderWebviewChildren = React57.useCallback(() => {
    var _a;
    return /* @__PURE__ */React57.createElement(React57.Fragment, null, /* @__PURE__ */React57.createElement(EGDSToolbar5, {
      navigationContent: {
        onClick: () => {
          onCloseCallback(false);
        },
        navIconLabel: (_a = attachmentStringMap == null ? void 0 : attachmentStringMap.closeWebviewWindow) != null ? _a : "Close webview, Return to chat window"
      },
      toolbarTitle: title
    }), /* @__PURE__ */React57.createElement(EGDSSpacing11, {
      padding: "four"
    }, /* @__PURE__ */React57.createElement(EGDSSheetContent3, {
      padded: false
    }, /* @__PURE__ */React57.createElement("iframe", {
      title: primary,
      style: {
        height: "100%",
        width: "100%",
        border: 0
      },
      src: uri,
      srcDoc
    }))));
  }, [attachmentStringMap == null ? void 0 : attachmentStringMap.closeWebviewWindow, title, primary, uri, srcDoc, onCloseCallback]);
  const sheetProps = embedded ? {
    type: "centered",
    height: 1200
  } : {
    type: "side"
  };
  return /* @__PURE__ */React57.createElement(EGDSSheetTransition3, {
    isVisible: isOpen
  }, /* @__PURE__ */React57.createElement(DialogComponent, null, /* @__PURE__ */React57.createElement(EGDSSheet3, __spreadProps(__spreadValues({}, sheetProps), {
    isVisible: isOpen,
    triggerRef: null
  }), renderWebviewChildren())));
};

// ../internal/src/providers/dynamic-card/vac-dynamic-card-context.tsx
var WebviewDialog = ({
  webview,
  webviewUriAppender,
  dialogId
}) => {
  var _a, _b;
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog7(dialogId);
  const [chatInstanceState] = useChatInstanceState();
  const embedded = (chatInstanceState == null ? void 0 : chatInstanceState.embedded) || false;
  if (!webview || !isDialogOpen) {
    return null;
  }
  const rawUrl = (_a = webview.url) == null ? void 0 : _a.value;
  const finalUrl = rawUrl ? `${rawUrl}${webviewUriAppender != null ? webviewUriAppender : ""}` : void 0;
  const hasWebviewContent = finalUrl || webview.srcDoc;
  if (!hasWebviewContent) {
    return null;
  }
  const action = {
    toolbar: {
      primary: "Webview"
    },
    uri: finalUrl,
    srcDoc: (_b = webview == null ? void 0 : webview.srcDoc) != null ? _b : void 0
  };
  return /* @__PURE__ */React58.createElement(Webview, {
    isOpen: isDialogOpen,
    onCloseCallback: () => {
      dialogActions.closeDialog();
    },
    action,
    DialogComponent: React58.memo(DialogComponent),
    embedded
  });
};
var createVacDynamicCardContext = webviewUriAppender => {
  return {
    useWebview: webview => {
      const dialogId = React58.useMemo(() => `vac-declarative-cards-webview-${uuidv45()}`, []);
      const [, dialogActions] = useDialog7(dialogId);
      const webviewContext = React58.useMemo(() => ({
        WebviewComponent: /* @__PURE__ */React58.createElement(WebviewDialog, {
          webview,
          webviewUriAppender,
          dialogId
        }),
        openWebview: () => {
          dialogActions.openDialog();
        }
      }), [dialogActions, dialogId, webview]);
      return webviewContext;
    }
  };
};

// ../internal/src/components/declarative-cards/dynamic-card.tsx
import React72 from "react";
import { gql as gql47 } from "@apollo/client";
import { EGDSCard as EGDSCard4, EGDSCardContentSection, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex24, EGDSLayoutFlexItem as EGDSLayoutFlexItem12 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { useSignalPublisher as useSignalPublisher6 } from "@shared-ui/core-signal-manager/context";
import { VacDynamicCardSignal as VacDynamicCardSignal4 } from "@shared-ui/retail-signals-virtual-agent";

// ../internal/src/components/declarative-cards/dynamic-card-composition.tsx
import React69 from "react";
import { gql as gql44 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";

// ../internal/src/components/declarative-cards/compositions/virtual-agent-control-more-info-trigger.tsx
import React60 from "react";
import { gql as gql36 } from "@apollo/client";
import { EGDSIconSize as EGDSIconSize5 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex18 } from "@egds/react-core/layout-flex";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { EGDSText as EGDSText15 } from "@egds/react-core/text";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";

// ../internal/src/components/declarative-cards/compositions/bottom-sheet/virtual-agent-control-bottom-sheet.tsx
import React59 from "react";
import { gql as gql35 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex17, EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSSheet as EGDSSheet4, EGDSSheetContent as EGDSSheetContent4, EGDSSheetTransition as EGDSSheetTransition4 } from "@egds/react-core/sheet";
var fragment33 = gql35`
  fragment VirtualAgentControlBottomSheetFragment on VirtualAgentControlBottomSheet {
    close {
      ...EGDSButtonFragment
    }
    text {
      ...DynamicCardTextFragment
    }
  }
  ${VirtualAgentEGDSButton.fragment}
  ${DynamicCardText.fragment}
`;
var VirtualAgentControlBottomSheet = ({
  closeDialog,
  DialogComponent,
  visible,
  triggerRef,
  data
}) => {
  const {
    text,
    close
  } = data;
  return /* @__PURE__ */React59.createElement("div", null, /* @__PURE__ */React59.createElement(EGDSSheetTransition4, {
    isVisible: visible
  }, /* @__PURE__ */React59.createElement(DialogComponent, null, /* @__PURE__ */React59.createElement(EGDSSheet4, {
    type: "bottom",
    isVisible: visible,
    triggerRef,
    autoFocus: true
  }, /* @__PURE__ */React59.createElement(EGDSSheetContent4, null, /* @__PURE__ */React59.createElement(EGDSLayoutFlex17, {
    direction: "column"
  }, text == null ? void 0 : text.map((value, index) => /* @__PURE__ */React59.createElement(DynamicCardText, {
    key: index,
    data: value
  })), /* @__PURE__ */React59.createElement(EGDSLayoutFlexItem10, null, close && /* @__PURE__ */React59.createElement(VirtualAgentEGDSButton, {
    data: close,
    onClick: () => closeDialog(),
    fullWidth: true
  }))))))));
};
VirtualAgentControlBottomSheet.fragment = fragment33;
VirtualAgentControlBottomSheet.displayName = "VirtualAgentControlBottomSheet";

// ../internal/src/components/declarative-cards/compositions/virtual-agent-control-more-info-trigger.tsx
var fragment34 = gql36`
  fragment VirtualAgentControlMoreInfoTriggerFragment on VirtualAgentControlMoreInfoTrigger {
    accessibility
    action {
      ...VirtualAgentControlBottomSheetFragment
    }
    analytics {
      ... on VirtualAgentControlInteractionAnalyticEvent {
        eventName
        eventVersion
        payload
      }
    }
    icon {
      ...IconFragment
    }
    text
  }
  ${VirtualAgentControlBottomSheet.fragment}
  ${Icon.fragment}
`;
var VirtualAgentControlMoreInfoTrigger = ({
  data
}) => {
  const {
    text,
    icon,
    action
  } = data;
  const triggerRef = React60.useRef(null);
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog8("virtual-agent-control-more-info-trigger-dialog");
  const defaultIconId = "icon__info_outline";
  const defaultIcon = __spreadProps(__spreadValues({}, icon), {
    id: defaultIconId
  });
  const openDialog = () => {
    dialogActions.openDialog();
  };
  const closeDialog = () => {
    dialogActions.closeDialog();
  };
  const handleTriggerClick = () => {
    if (!isDialogOpen) {
      openDialog();
    }
  };
  return /* @__PURE__ */React60.createElement(React60.Fragment, null, /* @__PURE__ */React60.createElement(EGDSMoreInfoTrigger, {
    size: EGDSIconSize5.SMALL
  }, /* @__PURE__ */React60.createElement("button", {
    type: "button",
    onClick: handleTriggerClick
  }, /* @__PURE__ */React60.createElement(EGDSLayoutFlex18, {
    alignItems: "center",
    space: "one"
  }, /* @__PURE__ */React60.createElement(EGDSText15, null, text), /* @__PURE__ */React60.createElement(Icon, {
    data: defaultIcon
  })))), isDialogOpen && /* @__PURE__ */React60.createElement(VirtualAgentControlBottomSheet, {
    data: action,
    triggerRef,
    visible: isDialogOpen,
    closeDialog,
    DialogComponent
  }));
};
VirtualAgentControlMoreInfoTrigger.fragment = fragment34;
VirtualAgentControlMoreInfoTrigger.displayName = "VirtualAgentControlMoreInfoTrigger";

// ../internal/src/components/declarative-cards/compositions/virtual-agent-control-progress-bar.tsx
import React61 from "react";
import { gql as gql37 } from "@apollo/client";
import { EGDSProgressBar } from "@egds/react-core/progress-bar";
var fragment35 = gql37`
  fragment VirtualAgentControlProgressBarFragment on VirtualAgentControlProgressBar {
    progressBar {
      ... on EGDSProgressBar {
        accessibilityLabel
        percent
        progressDescription
        title
      }
    }
    theme
  }
`;
var VirtualAgentControlProgressBarThemeMapper = {
  ["MUTED" /* MUTED */]: "muted",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["STANDARD" /* STANDARD */]: "standard"
};
var VirtualAgentControlProgressBar = ({
  data
}) => {
  const {
    progressBar,
    theme
  } = data;
  const {
    percent,
    accessibilityLabel,
    title,
    progressDescription
  } = progressBar;
  return /* @__PURE__ */React61.createElement(EGDSProgressBar, {
    title: title || "",
    progressDescription: progressDescription || "",
    percent,
    accessibilityLabel,
    theme: VirtualAgentControlProgressBarThemeMapper[theme != null ? theme : "STANDARD" /* STANDARD */]
  });
};
VirtualAgentControlProgressBar.fragment = fragment35;
VirtualAgentControlProgressBar.displayName = "VirtualAgentControlProgressBar";

// ../internal/src/components/declarative-cards/compositions/virtual-agent-control-rating.tsx
import React65 from "react";
import { gql as gql40 } from "@apollo/client";
import { EGDSRating } from "@egds/react-core/rating";
import { YelpRating } from "@egds/react-virtual-agent-control";

// ../internal/src/components/common/egds-badge/egds-badge.tsx
import React63 from "react";
import { gql as gql39 } from "@apollo/client";

// ../internal/src/components/common/egds-badge/egds-standard-badge.tsx
import React62 from "react";
import { gql as gql38 } from "@apollo/client";
import { EGDSBadgeSize, EGDSBadgeStandard, EGDSBadgeStandardThemes } from "@egds/react-core/badge";
var __EGDSStandardBadgeFragment = gql38`
  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {
    accessibility
    graphic {
      ...UIGraphicFragment
    }
    text
    size
    theme
  }

  ${UIGraphic.fragment}
`;
var EGDSStandardBadge = ({
  data
}) => {
  const {
    graphic,
    text,
    theme,
    accessibility,
    size
  } = data;
  if (!text) {
    return null;
  }
  return /* @__PURE__ */React62.createElement(EGDSBadgeStandard, {
    a11yText: accessibility != null ? accessibility : void 0,
    text,
    size: size ? EGDSBadgeSize[size.toUpperCase()] : EGDSBadgeSize.LARGE,
    theme: theme ? EGDSBadgeStandardThemes[theme.toUpperCase()] : "positive"
  }, graphic && /* @__PURE__ */React62.createElement(UIGraphic, {
    data: graphic
  }));
};
EGDSStandardBadge.fragment = __EGDSStandardBadgeFragment;
EGDSStandardBadge.displayName = "EGDSStandardBadge";

// ../internal/src/components/common/egds-badge/egds-badge.tsx
var __EGDSBadgeFragment = gql39`
  fragment EGDSBadgeFragment on EGDSBadge {
    ...EGDSStandardBadgeFragment
  }

  ${EGDSStandardBadge.fragment}
`;
var VirtualAgentEGDSBadge = ({
  data
}) => {
  switch (data.__typename) {
    case "EGDSStandardBadge":
      return /* @__PURE__ */React63.createElement(EGDSStandardBadge, {
        data
      });
    default:
      return null;
  }
};
VirtualAgentEGDSBadge.fragment = __EGDSBadgeFragment;
VirtualAgentEGDSBadge.displayName = "VirtualAgentEGDSBadge";

// ../internal/src/components/declarative-cards/compositions/badge-rating/badge-rating.tsx
import React64 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex19 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText16 } from "@egds/react-core/text";
var BadgeRating = props => {
  const {
    badge,
    primary,
    secondary
  } = props;
  return /* @__PURE__ */React64.createElement(EGDSLayoutFlex19, {
    space: "two"
  }, /* @__PURE__ */React64.createElement(EGDSSpacing12, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React64.createElement("div", null, /* @__PURE__ */React64.createElement(VirtualAgentEGDSBadge, {
    data: badge
  }))), (primary || secondary) && /* @__PURE__ */React64.createElement(EGDSLayoutFlex19, {
    direction: "column"
  }, /* @__PURE__ */React64.createElement(EGDSText16, {
    size: 200,
    weight: "bold"
  }, primary), /* @__PURE__ */React64.createElement(EGDSText16, {
    size: 200
  }, secondary)));
};

// ../internal/src/components/declarative-cards/compositions/virtual-agent-control-rating.tsx
var fragment36 = gql40`
  fragment VirtualAgentControlRatingFragment on VirtualAgentControlRating {
    badge {
      ...EGDSBadgeFragment
    }
    icon
    primary
    rating
    secondary
  }
  ${VirtualAgentEGDSBadge.fragment}
`;
var VirtualAgentControlRating = ({
  data
}) => {
  const {
    badge,
    primary,
    rating,
    secondary,
    icon
  } = data;
  if (badge) {
    return /* @__PURE__ */React65.createElement(BadgeRating, {
      badge,
      primary: primary != null ? primary : "",
      secondary: secondary != null ? secondary : ""
    });
  }
  if (icon && rating) {
    return /* @__PURE__ */React65.createElement(YelpRating, {
      rating
    });
  }
  return /* @__PURE__ */React65.createElement(EGDSRating, {
    rating: rating.toPrecision()
  });
};
VirtualAgentControlRating.fragment = fragment36;
VirtualAgentControlRating.displayName = "VirtualAgentControlRating";

// ../internal/src/components/declarative-cards/compositions/virtual-agent-control-star-rating-and-details.tsx
import React66 from "react";
import { gql as gql41 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex20, EGDSLayoutFlexItem as EGDSLayoutFlexItem11 } from "@egds/react-core/layout-flex";
import { EGDSRating as EGDSRating2 } from "@egds/react-core/rating";
import { EGDSText as EGDSText17 } from "@egds/react-core/text";
var fragment37 = gql41`
  fragment VirtualAgentControlStarRatingAndDetailsFragment on VirtualAgentControlStarRatingAndDetails {
    fractionRating
    numberReviews
    rating
    secondLine
  }
`;
var VirtualAgentControlStarRatingAndDetails = ({
  data
}) => {
  const {
    fractionRating,
    numberReviews,
    rating,
    secondLine
  } = data;
  const typeStyle = {
    customTheme: "standard",
    customStyle: "text-small"
  };
  return /* @__PURE__ */React66.createElement(EGDSLayoutFlex20, {
    "data-stid": "star-rating-and-details",
    direction: "column",
    space: "xsmall"
  }, /* @__PURE__ */React66.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */React66.createElement(EGDSLayoutFlex20, {
    space: "xsmall",
    wrap: "wrap"
  }, fractionRating && /* @__PURE__ */React66.createElement(EGDSLayoutFlexItem11, {
    alignSelf: "center"
  }, /* @__PURE__ */React66.createElement(EGDSText17, {
    typeStyle
  }, fractionRating)), rating > 0 && /* @__PURE__ */React66.createElement(EGDSLayoutFlexItem11, {
    alignSelf: "center"
  }, /* @__PURE__ */React66.createElement(EGDSRating2, {
    rating: rating.toPrecision()
  })), /* @__PURE__ */React66.createElement(EGDSLayoutFlexItem11, {
    alignSelf: "center"
  }, /* @__PURE__ */React66.createElement(EGDSText17, {
    typeStyle
  }, numberReviews)))), secondLine && /* @__PURE__ */React66.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */React66.createElement(EGDSText17, {
    overflow: "truncate-2-lines",
    typeStyle
  }, secondLine)));
};
VirtualAgentControlStarRatingAndDetails.fragment = fragment37;
VirtualAgentControlStarRatingAndDetails.displayName = "VirtualAgentControlStarRatingAndDetails";

// ../internal/src/components/declarative-cards/compositions/virtual-agent-control-step-indicator.tsx
import React67 from "react";
import { gql as gql42 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex21 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { StepIndicator } from "@egds/react-core/step-indicator";
import { EGDSText as EGDSText18 } from "@egds/react-core/text";
var fragment38 = gql42`
  fragment VirtualAgentControlStepIndicatorFragment on VirtualAgentControlStepIndicator {
    accessibilityLabel
    activeStep
    steps {
      icon {
        id
      }
      primary
      secondary
    }
  }
`;
var VirtualAgentControlStepIndicator = ({
  data
}) => {
  const fontSize = 200;
  const mappedSteps = data.steps.map(step => {
    var _a;
    const modedContent = /* @__PURE__ */React67.createElement(EGDSText18, {
      size: fontSize
    }, step.secondary);
    return {
      label: step.primary || "",
      content: modedContent || "",
      icon: ((_a = step.icon) == null ? void 0 : _a.id) || ""
    };
  });
  return /* @__PURE__ */React67.createElement(EGDSLayoutFlex21, {
    space: "two"
  }, /* @__PURE__ */React67.createElement(EGDSSpacing13, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React67.createElement("div", null, /* @__PURE__ */React67.createElement(StepIndicator, {
    steps: [...(mappedSteps != null ? mappedSteps : [])],
    activeStep: data.activeStep,
    stepLength: "natural",
    direction: "vertical",
    stepIndicatorSize: "small"
  }))));
};
VirtualAgentControlStepIndicator.fragment = fragment38;
VirtualAgentControlStepIndicator.displayName = "VirtualAgentControlStepIndicator";

// ../internal/src/components/declarative-cards/compositions/virtual-agent-control-title.tsx
import React68 from "react";
import { gql as gql43 } from "@apollo/client";
import { EGDSHeading as EGDSHeading6, EGDSSubheading } from "@egds/react-core/text";
var fragment39 = gql43`
  fragment VirtualAgentControlTitleFragment on VirtualAgentControlTitle {
    heading
    subHeading
  }
`;
var VirtualAgentControlTitle = ({
  data
}) => {
  const {
    heading,
    subHeading
  } = data;
  const Heading = /* @__PURE__ */React68.createElement(EGDSHeading6, {
    typeStyle: {
      customStyle: "headline-medium"
    },
    overflow: "truncate-3-lines",
    tag: "h3"
  }, heading);
  if (!subHeading) {
    return Heading;
  }
  return /* @__PURE__ */React68.createElement(React68.Fragment, null, Heading, /* @__PURE__ */React68.createElement(EGDSSubheading, {
    overflow: "truncate-3-lines"
  }, subHeading));
};
VirtualAgentControlTitle.fragment = fragment39;
VirtualAgentControlTitle.displayName = "VirtualAgentControlTitle";

// ../internal/src/components/declarative-cards/dynamic-card-composition.tsx
var fragment40 = gql44`
  fragment DynamicCardCompositionFragment on DynamicCardComposition {
    progressBar {
      ...VirtualAgentControlProgressBarFragment
    }
    rating {
      ...VirtualAgentControlRatingFragment
    }
    stepIndicator {
      ...VirtualAgentControlStepIndicatorFragment
    }
    moreInfoTrigger {
      ...VirtualAgentControlMoreInfoTriggerFragment
    }
    starRatingAndDetails {
      ...VirtualAgentControlStarRatingAndDetailsFragment
    }
    title {
      ...VirtualAgentControlTitleFragment
    }
    ${VirtualAgentControlProgressBar.fragment}
    ${VirtualAgentControlRating.fragment}
    ${VirtualAgentControlStepIndicator.fragment}
    ${VirtualAgentControlMoreInfoTrigger.fragment}
    ${VirtualAgentControlStarRatingAndDetails.fragment}
    ${VirtualAgentControlTitle.fragment}
  }
`;
var DynamicCardComposition = ({
  data,
  spacing,
  customComponents
}) => {
  const {
    progressBar,
    rating,
    stepIndicator,
    moreInfoTrigger,
    starRatingAndDetails,
    title
  } = data;
  const ProgressBarComponent = (customComponents == null ? void 0 : customComponents.VirtualAgentControlProgressBar) || VirtualAgentControlProgressBar;
  const RatingComponent = (customComponents == null ? void 0 : customComponents.VirtualAgentControlRating) || VirtualAgentControlRating;
  const StepIndicatorComponent = (customComponents == null ? void 0 : customComponents.VirtualAgentControlStepIndicator) || VirtualAgentControlStepIndicator;
  const MoreInfoTriggerComponent = (customComponents == null ? void 0 : customComponents.VirtualAgentControlMoreInfoTrigger) || VirtualAgentControlMoreInfoTrigger;
  const StarRatingAndDetailsComponent = (customComponents == null ? void 0 : customComponents.VirtualAgentControlStarRatingAndDetails) || VirtualAgentControlStarRatingAndDetails;
  const TitleComponent = (customComponents == null ? void 0 : customComponents.VirtualAgentControlTitle) || VirtualAgentControlTitle;
  if (progressBar) {
    return /* @__PURE__ */React69.createElement(EGDSSpacing14, __spreadValues({}, spacing), /* @__PURE__ */React69.createElement("div", null, /* @__PURE__ */React69.createElement(ProgressBarComponent, {
      data: progressBar
    })));
  }
  if (rating) {
    return /* @__PURE__ */React69.createElement(EGDSSpacing14, __spreadValues({}, spacing), /* @__PURE__ */React69.createElement("div", null, /* @__PURE__ */React69.createElement(RatingComponent, {
      data: rating
    })));
  }
  if (stepIndicator) {
    return /* @__PURE__ */React69.createElement(EGDSSpacing14, __spreadValues({}, spacing), /* @__PURE__ */React69.createElement("div", null, /* @__PURE__ */React69.createElement(StepIndicatorComponent, {
      data: stepIndicator
    })));
  }
  if (moreInfoTrigger) {
    return /* @__PURE__ */React69.createElement(EGDSSpacing14, __spreadValues({}, spacing), /* @__PURE__ */React69.createElement("div", null, /* @__PURE__ */React69.createElement(MoreInfoTriggerComponent, {
      data: moreInfoTrigger
    })));
  }
  if (starRatingAndDetails) {
    return /* @__PURE__ */React69.createElement(EGDSSpacing14, __spreadValues({}, spacing), /* @__PURE__ */React69.createElement("div", null, /* @__PURE__ */React69.createElement(StarRatingAndDetailsComponent, {
      data: starRatingAndDetails
    })));
  }
  if (title) {
    return /* @__PURE__ */React69.createElement(EGDSSpacing14, __spreadValues({}, spacing), /* @__PURE__ */React69.createElement("div", null, /* @__PURE__ */React69.createElement(TitleComponent, {
      data: title
    })));
  }
  return null;
};
DynamicCardComposition.fragment = fragment40;
DynamicCardComposition.displayName = "DynamicCardComposition";

// ../internal/src/components/declarative-cards/dynamic-card-content.tsx
import React70 from "react";
import { gql as gql45 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex22 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
var fragment41 = gql45`
  fragment DynamicCardContentFragment on DynamicCardContent {
    text {
      ...DynamicCardTextFragment
    }
    icon {
      ...IconFragment
    }
    badge {
      ...EGDSBadgeFragment
    }
    action {
      ...DynamicCardActionFragment
    }
  }
  ${DynamicCardText.fragment}
  ${Icon.fragment}
  ${VirtualAgentEGDSBadge.fragment}
  ${DynamicCardAction.fragment}
`;
var DynamicCardContent = ({
  data,
  spacing,
  customComponents
}) => {
  const {
    action,
    text,
    icon,
    badge
  } = data;
  const TextComponent = (customComponents == null ? void 0 : customComponents.DynamicCardText) || DynamicCardText;
  const IconComponent = (customComponents == null ? void 0 : customComponents.Icon) || Icon;
  const BadgeComponent = (customComponents == null ? void 0 : customComponents.Badge) || VirtualAgentEGDSBadge;
  const props = __spreadValues({}, spacing);
  if (badge) {
    return /* @__PURE__ */React70.createElement(EGDSSpacing15, __spreadValues({}, props), /* @__PURE__ */React70.createElement("div", null, /* @__PURE__ */React70.createElement(BadgeComponent, {
      data: badge
    })));
  }
  if (action && (text || icon)) {
    return /* @__PURE__ */React70.createElement(EGDSSpacing15, __spreadValues({}, props), /* @__PURE__ */React70.createElement("div", null, /* @__PURE__ */React70.createElement(DynamicCardAction, {
      data: action,
      text,
      icon
    })));
  }
  if (text && icon) {
    return /* @__PURE__ */React70.createElement(EGDSSpacing15, __spreadValues({}, props), /* @__PURE__ */React70.createElement("div", null, /* @__PURE__ */React70.createElement(EGDSLayoutFlex22, {
      alignItems: "start"
    }, /* @__PURE__ */React70.createElement(IconComponent, {
      data: icon
    }), /* @__PURE__ */React70.createElement(EGDSSpacing15, {
      padding: {
        blockstart: "half",
        inlinestart: "one"
      }
    }, /* @__PURE__ */React70.createElement("span", null, /* @__PURE__ */React70.createElement(TextComponent, {
      data: text
    }))))));
  }
  if (text) {
    return /* @__PURE__ */React70.createElement(EGDSSpacing15, __spreadValues({}, props), /* @__PURE__ */React70.createElement("div", null, /* @__PURE__ */React70.createElement(TextComponent, {
      data: text
    })));
  }
  if (icon) {
    return /* @__PURE__ */React70.createElement(EGDSSpacing15, __spreadValues({}, props), /* @__PURE__ */React70.createElement("div", null, /* @__PURE__ */React70.createElement(IconComponent, {
      data: icon
    })));
  }
  return null;
};
DynamicCardContent.fragment = fragment41;
DynamicCardContent.displayName = "DynamicCardContent";

// ../internal/src/components/declarative-cards/dynamic-card-group.tsx
import React71 from "react";
import { gql as gql46 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex23 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing16, EGDSSpacingHr as EGDSSpacingHr3 } from "@egds/react-core/spacing";
var fragment42 = gql46`
  fragment DynamicCardGroupFragment on DynamicCardGroup {
    separator
    inlineContent {
      ...DynamicCardContentFragment
    }
    inlineJustify
    forceWrap
    groupElement {
      ...DynamicCardContentFragment
      ...DynamicCardCompositionFragment
    }
  }
  ${DynamicCardContent.fragment}
  ${DynamicCardComposition.fragment}
`;
var groupComponents = {
  DynamicCardContent,
  DynamicCardComposition
};
var Justify = {
  SPACE: "space-between",
  START: "start",
  END: "end"
};
var DynamicCardGroup = ({
  data,
  spacing,
  customComponents
}) => {
  const {
    separator,
    inlineContent,
    inlineJustify,
    forceWrap,
    groupElement
  } = data;
  if (!(inlineContent == null ? void 0 : inlineContent.length) && !(groupElement == null ? void 0 : groupElement.length)) {
    return null;
  }
  const ContentComponent = (customComponents == null ? void 0 : customComponents.DynamicCardContent) || DynamicCardContent;
  const spacingProps = __spreadValues({}, spacing);
  const getAlignItems = () => {
    if (forceWrap && inlineJustify !== "SPACE" /* SPACE */) {
      return Justify[inlineJustify != null ? inlineJustify : "START" /* START */];
    }
    return "center";
  };
  const layoutProps = {
    justifyContent: Justify[inlineJustify != null ? inlineJustify : "START" /* START */],
    space: "small",
    alignItems: getAlignItems(),
    direction: forceWrap ? "column" : "row"
  };
  const contentSpacingProps = {
    margin: {
      block: "unset",
      // forceWrap should remove all inline spacing as each item is on its own line
      inlineend: !forceWrap && inlineJustify === "START" /* START */ ? "two" : "unset",
      inlinestart: !forceWrap && inlineJustify === "END" /* END */ ? "two" : "unset"
    }
  };
  const groupContent = React71.useMemo(() => {
    return (groupElement == null ? void 0 : groupElement.length) ? /* @__PURE__ */React71.createElement(React71.Fragment, null, groupElement.map((content, i) => React71.createElement(groupComponents[content.__typename], {
      key: `${content.__typename}-${i}`,
      // Prefer stable keys
      data: content,
      customComponents,
      spacing: contentSpacingProps
    }))) : /* @__PURE__ */React71.createElement(React71.Fragment, null, inlineContent == null ? void 0 : inlineContent.map((content, i) => React71.createElement(ContentComponent, {
      key: `${content.__typename}-${i}`,
      // Prefer stable keys
      data: content,
      customComponents,
      spacing: contentSpacingProps
    })));
  }, [groupElement, inlineContent]);
  return /* @__PURE__ */React71.createElement(EGDSSpacing16, __spreadValues({}, spacingProps), /* @__PURE__ */React71.createElement("div", null, /* @__PURE__ */React71.createElement(EGDSLayoutFlex23, __spreadValues({}, layoutProps), groupContent), separator && /* @__PURE__ */React71.createElement(EGDSSpacingHr3, {
    blockMargin: "two"
  })));
};
DynamicCardGroup.fragment = fragment42;
DynamicCardGroup.displayName = "DynamicCardGroup";

// ../internal/src/components/declarative-cards/dynamic-card.tsx
var fragment43 = gql47`
  fragment DynamicCardFragment on DynamicCard {
    elements {
      ...DynamicCardContentFragment
      ...DynamicCardGroupFragment
      ...DynamicCardCompositionFragment
    }
    image {
      ...DynamicCardCoverImageFragment
    }
    imagePosition
    imageOverlays {
      ...DynamicCardOverlayTextFragment
      ...DynamicCardOverlayToggleFragment
    }
    action {
      event {
        eventId
        payload
      }
      link {
        ... on HttpURI {
          value
        }
      }
      properties {
        accessibility
        target
      }
    }
    footer {
      ...DynamicCardContentFragment
    }
    content {
      ...DynamicCardGroupFragment
    }
  }
  ${DynamicCardContent.fragment}
  ${DynamicCardGroup.fragment}
  ${DynamicCardComposition.fragment}
  ${DynamicCardCoverImage.fragment}
  ${DynamicCardOverlayText.fragment}
  ${DynamicCardOverlayToggle.fragment}
`;
var defaultComponents = {
  DynamicCardContent,
  DynamicCardGroup,
  DynamicCardComposition
};
var defaultContentComponents = {
  DynamicCardGroup
};
var defaultFooterComponents = {
  DynamicCardContent
};
var DynamicCard = ({
  data,
  customComponents
}) => {
  const {
    elements,
    image,
    imagePosition,
    imageOverlays,
    action,
    footer,
    content
  } = data;
  const {
    link,
    event,
    properties
  } = action || {};
  const components = __spreadValues(__spreadValues({}, defaultComponents), customComponents);
  const contentComponents = __spreadValues(__spreadValues({}, defaultContentComponents), customComponents);
  const footerComponents = __spreadValues(__spreadValues({}, defaultFooterComponents), customComponents);
  const {
    publish
  } = useSignalPublisher6();
  const handleCardClick = React72.useCallback(() => {
    if (!event || link) {
      return null;
    }
    if (event) {
      const {
        eventId,
        payload: payload2
      } = event;
      publish(new VacDynamicCardSignal4("VAC_DYNAMIC_CARD_EVENT" /* Vac_DynamicCardEvent */, {
        eventId,
        payload: payload2
      }));
    }
  }, [event, link, publish]);
  const cardContent = React72.useMemo(() => {
    var _a, _b;
    if (!(elements == null ? void 0 : elements.length) && !(content == null ? void 0 : content.length)) {
      return null;
    }
    const href = (link == null ? void 0 : link.__typename) === "HttpURI" ? link.value : void 0;
    const target = UILinkTargetMap[(_a = properties == null ? void 0 : properties.target) != null ? _a : "INTERNAL" /* INTERNAL */];
    return /* @__PURE__ */React72.createElement(EGDSCardContentSection, null, href ? /* @__PURE__ */React72.createElement(EGDSCardLink, null, /* @__PURE__ */React72.createElement("a", {
      href,
      target
    }, (_b = properties == null ? void 0 : properties.accessibility) != null ? _b : "")) : null, (content == null ? void 0 : content.length) ? /* @__PURE__ */React72.createElement(React72.Fragment, null, content.map((element, i) => React72.createElement(contentComponents[element.__typename], {
      key: `${element.__typename}-${i}`,
      // Prefer stable keys
      data: element,
      customComponents: contentComponents,
      spacing: {
        margin: {
          blockend: i === content.length - 1 ? "unset" : "two"
        }
      }
    }))) : /* @__PURE__ */React72.createElement(React72.Fragment, null, elements == null ? void 0 : elements.map((element, i) => React72.createElement(components[element.__typename], {
      key: `${element.__typename}-${i}`,
      // Prefer stable keys
      data: element,
      customComponents: components,
      spacing: {
        margin: {
          blockend: i === elements.length - 1 ? "unset" : "two"
        }
      }
    }))));
  }, [elements, content, link, properties]);
  const cardFooter = React72.useMemo(() => {
    if (!(footer == null ? void 0 : footer.length)) {
      return null;
    }
    return /* @__PURE__ */React72.createElement(EGDSCardContentSection, null, footer == null ? void 0 : footer.map((element, i) => React72.createElement(footerComponents[element.__typename], {
      key: i,
      data: element,
      customComponents: footerComponents,
      spacing: {
        margin: {
          blockend: i === footer.length - 1 ? "unset" : "small"
        }
      }
    })));
  }, [footer]);
  if (!(elements == null ? void 0 : elements.length) && !(content == null ? void 0 : content.length) && !(image == null ? void 0 : image.url)) {
    return null;
  }
  const cardProps = {
    onClick: handleCardClick,
    border: true,
    "data-test-id": "dynamic-card"
  };
  if (!(image == null ? void 0 : image.url)) {
    return /* @__PURE__ */React72.createElement(EGDSCard4, __spreadValues({}, cardProps), /* @__PURE__ */React72.createElement(EGDSLayoutFlex24, {
      direction: "column"
    }, /* @__PURE__ */React72.createElement(EGDSLayoutFlexItem12, {
      grow: 1
    }, cardContent), cardFooter && /* @__PURE__ */React72.createElement(EGDSLayoutFlexItem12, null, cardFooter)));
  }
  const coverImageProps = {
    data: image,
    overlays: imageOverlays
  };
  if (!(elements == null ? void 0 : elements.length) && !(content == null ? void 0 : content.length)) {
    return /* @__PURE__ */React72.createElement(EGDSCard4, __spreadValues({}, cardProps), /* @__PURE__ */React72.createElement("div", null, /* @__PURE__ */React72.createElement(DynamicCardCoverImage, __spreadProps(__spreadValues({}, coverImageProps), {
      roundedAll: true
    }))));
  }
  if (imagePosition === "LEFT" /* LEFT */) {
    return /* @__PURE__ */React72.createElement(EGDSCard4, __spreadValues({}, cardProps), /* @__PURE__ */React72.createElement(EGDSLayoutGrid, {
      columns: 3
    }, /* @__PURE__ */React72.createElement(EGDSLayoutGridItem, {
      colSpan: 1
    }, /* @__PURE__ */React72.createElement(DynamicCardCoverImage, __spreadValues({}, coverImageProps))), /* @__PURE__ */React72.createElement(EGDSLayoutGridItem, {
      colSpan: 2
    }, /* @__PURE__ */React72.createElement(EGDSLayoutFlex24, {
      direction: "column"
    }, /* @__PURE__ */React72.createElement(EGDSLayoutFlexItem12, {
      grow: 1
    }, cardContent), cardFooter && /* @__PURE__ */React72.createElement(EGDSLayoutFlexItem12, null, cardFooter)))));
  }
  return /* @__PURE__ */React72.createElement(EGDSCard4, __spreadValues({}, cardProps), /* @__PURE__ */React72.createElement(EGDSLayoutFlex24, {
    direction: "column"
  }, /* @__PURE__ */React72.createElement(EGDSLayoutFlexItem12, {
    grow: 1
  }, /* @__PURE__ */React72.createElement(DynamicCardCoverImage, __spreadValues({}, coverImageProps))), /* @__PURE__ */React72.createElement(EGDSLayoutFlexItem12, {
    grow: 1
  }, cardContent), cardFooter && /* @__PURE__ */React72.createElement(EGDSLayoutFlexItem12, null, cardFooter)));
};
DynamicCard.fragment = fragment43;
DynamicCard.displayName = "DynamicCard";

// ../internal/src/components/declarative-cards/carousel/dynamic-card-carousel.tsx
import React73 from "react";
import { gql as gql48 } from "@apollo/client";
import { EGDSCarousel } from "@egds/react-core/carousel";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
var fragment44 = gql48`
  fragment DynamicCardCarouselFragment on DynamicCardCarousel {
    nextButton {
      ...EGDSButtonFragment
    }
    prevButton {
      ...EGDSButtonFragment
    }
    cards {
      ...DynamicCardCarouselItemFragment
    }
    carouselId
  }
  fragment DynamicCardCarouselItemFragment on DynamicCardCarouselItem {
    id
    cardPayload
  }
`;
var DynamicCardCarousel = ({
  data,
  id,
  ariaLabel
}) => {
  var _a, _b;
  const {
    cards,
    nextButton,
    prevButton
  } = data;
  const carouselProps = {
    itemsVisible: {
      lg: 3,
      md: 2,
      sm: 1
    },
    pagingInset: true,
    navigationIconId: {
      next: `next-button-${id}`,
      prev: `prev-button-${id}`
    },
    buttonText: {
      nextButton: (_a = nextButton == null ? void 0 : nextButton.primary) != null ? _a : "",
      prevButton: (_b = prevButton == null ? void 0 : prevButton.primary) != null ? _b : ""
    },
    peek: true,
    itemsMaxHeight: true
  };
  const dynamicCardItems = cards == null ? void 0 : cards.map((dynamicCardItem, i) => {
    const {
      cardPayload
    } = dynamicCardItem;
    if (cardPayload) {
      return /* @__PURE__ */React73.createElement(DynamicCard, {
        data: parseJson(cardPayload),
        key: `card-${i}`
      });
    }
    return null;
  });
  return /* @__PURE__ */React73.createElement(React73.Fragment, null, dynamicCardItems && (dynamicCardItems == null ? void 0 : dynamicCardItems.length) > 0 && /* @__PURE__ */React73.createElement(EGDSSpacing17, {
    margin: {
      blockstart: "half"
    }
  }, /* @__PURE__ */React73.createElement("div", {
    id,
    "aria-label": ariaLabel
  }, /* @__PURE__ */React73.createElement(EGDSCarousel, __spreadValues({}, carouselProps), dynamicCardItems))));
};
DynamicCardCarousel.fragment = fragment44;
DynamicCardCarousel.displayName = "DynamicCardCarousel";

// ../internal/src/components/dynamic-card/dynamic-card.tsx
import React77 from "react";
import { gql as gql52 } from "@apollo/client";
import { EGDSCard as EGDSCard5, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex25, EGDSLayoutFlexItem as EGDSLayoutFlexItem13 } from "@egds/react-core/layout-flex";

// ../internal/src/components/actionable/virtual-agent-control-actionable.tsx
import React75 from "react";
import { gql as gql50 } from "@apollo/client";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
import { useProvidedState as useProvidedState15 } from "@shared-ui/provided-state-context";

// ../internal/src/components/actionable/virtual-agent-control-actionable-element.tsx
import React74 from "react";
import { gql as gql49 } from "@apollo/client";
var fragment45 = gql49`
  fragment VirtualAgentControlActionableElementFragment on VirtualAgentControlActionableElement {
    link {
      ...EGDSStandardLinkFragment
    }
    button {
      ...EGDSButtonFragment
    }
  }
  ${EGDSStandardLink.fragment}
  ${VirtualAgentEGDSButton.fragment}
`;
var VirtualAgentControlActionableElement = ({
  data,
  target,
  onClick,
  href
}) => {
  const {
    button,
    link
  } = data;
  const handleClick = React74.useCallback(() => {
    onClick == null ? void 0 : onClick();
  }, [onClick]);
  if (button) {
    return /* @__PURE__ */React74.createElement(VirtualAgentEGDSButton, {
      target,
      data: button,
      onClick: handleClick,
      href
    });
  }
  if (link) {
    return /* @__PURE__ */React74.createElement(EGDSStandardLink, {
      target,
      data: link,
      onClick: handleClick
    });
  }
  return null;
};
VirtualAgentControlActionableElement.fragment = fragment45;
VirtualAgentControlActionableElement.displayName = "VirtualAgentControlActionableElement";

// ../internal/src/components/actionable/virtual-agent-control-actionable.tsx
var fragment46 = gql50`
  fragment VirtualAgentControlActionableFragment on VirtualAgentControlActionable {
    element {
      ...VirtualAgentControlActionableElementFragment
    }
    action {
      ...VirtualAgentControlSendMessageActionFragment
      ... on VirtualAgentControlRedirectAction {
        url
        target
      }
      ... on VirtualAgentControlWebviewAction {
        uri
        toolbar {
          primary
        }
      }
      ... on VirtualAgentControlDialogAction {
        srcDoc
        toolbar {
          primary
        }
      }
    }
  }
  fragment VirtualAgentControlSendMessageActionFragment on VirtualAgentControlSendMessageAction {
    message
    payload
  }
  ${VirtualAgentControlActionableElement.fragment}
`;
var VirtualAgentControlActionable = ({
  data
}) => {
  var _a;
  const {
    element,
    action
  } = data;
  const [showWebview, setShowWebview] = React75.useState(false);
  const handleSend = useOperation("SEND_MESSAGE" /* SEND_MESSAGE */);
  const [state] = useProvidedState15();
  const vacId = useVacId();
  const embedded = ((_a = state == null ? void 0 : state.chatInstancesState) == null ? void 0 : _a[vacId].embedded) || false;
  const [, dialogActions, DialogComponent] = useDialog9("va-chat-container-dialog");
  const performAction = React75.useCallback(() => {
    var _a2, _b, _c, _d, _e;
    switch (action.__typename) {
      case "VirtualAgentControlSendMessageAction":
        {
          const elementText = (_d = (_c = (_a2 = element.button) == null ? void 0 : _a2.primary) != null ? _c : (_b = element.link) == null ? void 0 : _b.text) != null ? _d : "";
          const actionWithFallback = __spreadProps(__spreadValues({}, action), {
            message: ((_e = action.message) == null ? void 0 : _e.length) ? action.message : elementText
          });
          handleSend == null ? void 0 : handleSend(actionWithFallback);
          break;
        }
      case "VirtualAgentControlDialogAction":
      case "VirtualAgentControlWebviewAction":
        {
          dialogActions.openDialog();
          setShowWebview(true);
          break;
        }
      default:
        break;
    }
  }, [action, handleSend]);
  if (action.__typename === "VirtualAgentControlRedirectAction") {
    const {
      target
    } = action;
    const targetType = "INTERNAL" /* INTERNAL */ === target ? "_top" /* TOP */ : "_blank" /* BLANK */;
    return /* @__PURE__ */React75.createElement(VirtualAgentControlActionableElement, {
      data: element,
      href: action.url,
      target: targetType
    });
  }
  if (action.__typename === "VirtualAgentControlWebviewAction" || action.__typename === "VirtualAgentControlDialogAction") {
    return /* @__PURE__ */React75.createElement(React75.Fragment, null, showWebview && /* @__PURE__ */React75.createElement(Webview, {
      isOpen: showWebview,
      onCloseCallback: value => {
        setShowWebview(value);
        dialogActions.closeDialog();
      },
      action,
      DialogComponent: React75.memo(DialogComponent),
      embedded
    }), /* @__PURE__ */React75.createElement(VirtualAgentControlActionableElement, {
      data: element,
      onClick: performAction
    }));
  }
  return /* @__PURE__ */React75.createElement(VirtualAgentControlActionableElement, {
    data: element,
    onClick: performAction
  });
};
VirtualAgentControlActionable.fragment = fragment46;
VirtualAgentControlActionable.displayName = "VirtualAgentControlActionable";

// ../internal/src/components/dynamic-card/elements/horizontal-break.tsx
import React76 from "react";
import { gql as gql51 } from "@apollo/client";
import { EGDSSpacingHr as EGDSSpacingHr4 } from "@egds/react-core/spacing";
var fragment47 = gql51`
  fragment VirtualAgentControlHorizontalBreakFragment on VirtualAgentControlHorizontalBreak {
    __typename
    label
  }
`;
var VirtualAgentControlHorizontalBreak = () => {
  return /* @__PURE__ */React76.createElement("span", null, /* @__PURE__ */React76.createElement(EGDSSpacingHr4, {
    blockMargin: "one"
  }));
};
VirtualAgentControlHorizontalBreak.fragment = fragment47;
VirtualAgentControlHorizontalBreak.displayName = "VirtualAgentControlHorizontalBreak";

// ../internal/src/components/dynamic-card/dynamic-card.tsx
var fragment48 = gql52`
  fragment VirtualAgentControlDynamicCardFragment on VirtualAgentControlDynamicCard {
    cover {
      url
      description
    }
    elements {
      ... on VirtualAgentControlActionable {
        ...VirtualAgentControlActionableFragment
      }
      ... on VirtualAgentControlHorizontalBreak {
        ...VirtualAgentControlHorizontalBreakFragment
      }
      ... on EGDSSpannableText {
        ...EGDSSpannableTextFragment
      }
      ... on EGDSStylizedText {
        ...EGDSStylizedTextFragment
      }
    }
  }
  ${VirtualAgentControlActionable.fragment}
  ${VirtualAgentControlHorizontalBreak.fragment}
  ${EGDSSpannableText.fragment}
  ${EGDSStylizedText.fragment}
`;
var registry3 = {
  VirtualAgentControlActionable,
  VirtualAgentControlHorizontalBreak,
  EGDSSpannableText,
  EGDSStylizedText
};
var adapt = elements => {
  const components = elements.reduce((accum, element, index) => {
    const {
      __typename
    } = element;
    const Component = registry3[__typename];
    if (Component) {
      const componentKey = `${element.__typename}-${index}`;
      accum.push(/* @__PURE__ */React77.createElement(EGDSLayoutFlexItem13, {
        key: componentKey
      }, /* @__PURE__ */React77.createElement(Component, {
        data: element
      })));
    }
    return accum;
  }, []);
  return components;
};
var VirtualAgentControlDynamicCard = ({
  data,
  maxWidth = "seventy_two"
}) => {
  const {
    elements,
    cover
  } = data;
  const components = adapt(elements);
  if (!components.length) {
    return null;
  }
  return /* @__PURE__ */React77.createElement(EGDSLayoutFlexItem13, {
    alignSelf: "start",
    maxWidth
  }, /* @__PURE__ */React77.createElement(EGDSCard5, {
    border: true
  }, /* @__PURE__ */React77.createElement(EGDSLayoutFlex25, {
    direction: "column"
  }, cover && /* @__PURE__ */React77.createElement(EGDSFigure2, {
    ratio: EGDSFigureAspectRatioType2.R16_9,
    imageFit: "cover"
  }, /* @__PURE__ */React77.createElement(EGDSImage2, {
    src: cover.url,
    alt: cover.description,
    placeholderImage: true
  })), /* @__PURE__ */React77.createElement(EGDSCardContentSection2, null, /* @__PURE__ */React77.createElement(EGDSLayoutFlex25, {
    direction: "column",
    space: "two"
  }, components)))));
};
VirtualAgentControlDynamicCard.fragment = fragment48;
VirtualAgentControlDynamicCard.displayName = "VirtualAgentControlDynamicCard";

// ../internal/src/components/messages/inbound-message/components/inbound-dynamic-card-message.tsx
var fragment49 = gql53`
  fragment VirtualAgentControlInboundDynamicCardMessageFragment on VirtualAgentControlInboundDynamicCardMessage {
    eyebrow
    webviewUriAppender
    accessibilityLabel
    metadata {
      ... on VirtualAgentControlMessageMetadata {
        timeStamp
        messageId
        messageContextAccessibilityLabel
      }
    }
    stateUpdates {
      chatInput {
        interactionMode
        chatInputStatus
      }
    }
    quickReplies {
      ...VirtualAgentControlQuickReplyItemFragment
    }
    dynamicCard {
      ...VirtualAgentControlDynamicCardFragment
    }
    carousel {
      ...EGDSCarouselFragment
    }
    cardPayload
    cardCarousel {
      ...DynamicCardCarouselFragment
    }
  }

  fragment EGDSCarouselFragment on EGDSCarousel {
    nextButton {
      ...EGDSButtonFragment
    }
    previousButton {
      ...EGDSButtonFragment
    }
    items {
      ...VirtualAgentControlDynamicCardItemFragment
    }
  }

  fragment VirtualAgentControlDynamicCardItemFragment on VirtualAgentControlDynamicCardItem {
    id
    card {
      ...VirtualAgentControlDynamicCardFragment
    }
  }

  fragment DynamicCardCarouselFragment on DynamicCardCarousel {
    nextButton {
      ...EGDSButtonFragment
    }
    prevButton {
      ...EGDSButtonFragment
    }
    cards {
      ...DynamicCardCarouselItemFragment
    }
    carouselId
  }

  fragment DynamicCardCarouselItemFragment on DynamicCardCarouselItem {
    id
    cardPayload
  }

  ${VirtualAgentControlDynamicCard.fragment}
  ${VirtualAgentControlQuickReplyItem.fragment}
`;
var VirtualAgentControlInboundDynamicCardMessage = ({
  data
}) => {
  var _a, _b;
  const {
    dynamicCard,
    carousel,
    cardPayload,
    cardCarousel,
    accessibilityLabel,
    metadata: {
      messageId
    },
    webviewUriAppender
  } = data;
  const messageContent = use_prefetch_localization_content_default(LocalizationContentKeys.MESSAGE);
  const {
    dcfUnavailableLine1,
    dcfUnavailableLine2
  } = messageContent || {};
  const shouldShowDcfUnavailableMessage = !!dcfUnavailableLine1 && !!dcfUnavailableLine2;
  const dynamicCardContextData = createVacDynamicCardContext(webviewUriAppender);
  if (carousel) {
    const {
      items,
      nextButton,
      previousButton
    } = carousel;
    const props = {
      buttonText: {
        nextButton: (_a = nextButton == null ? void 0 : nextButton.primary) != null ? _a : "",
        prevButton: (_b = previousButton == null ? void 0 : previousButton.primary) != null ? _b : ""
      }
    };
    const cards = items.map((cardItem, i) => {
      if (cardItem.__typename === "VirtualAgentControlDynamicCardItem") {
        const {
          card
        } = cardItem;
        return /* @__PURE__ */React78.createElement(VirtualAgentControlDynamicCard, {
          data: card,
          maxWidth: "full_width",
          key: `card-${i}`
        });
      }
      return null;
    });
    return /* @__PURE__ */React78.createElement(EGDSSpacing18, {
      margin: {
        blockstart: "half"
      }
    }, /* @__PURE__ */React78.createElement("div", {
      id: messageId,
      "aria-label": accessibilityLabel != null ? accessibilityLabel : ""
    }, /* @__PURE__ */React78.createElement(EGDSCarousel2, {
      buttonText: props.buttonText,
      itemsVisible: {
        lg: 3,
        md: 2,
        sm: 1
      },
      navigationIconId: {
        next: `next-button-${messageId}`,
        prev: `prev-button-${messageId}`
      },
      pagingInset: true,
      pageBy: 1,
      peek: true,
      itemsMaxHeight: true
    }, cards)));
  }
  if (dynamicCard) {
    return /* @__PURE__ */React78.createElement(EGDSSpacing18, {
      margin: {
        blockstart: "half"
      }
    }, /* @__PURE__ */React78.createElement("div", {
      "aria-label": accessibilityLabel != null ? accessibilityLabel : "",
      id: messageId
    }, /* @__PURE__ */React78.createElement(VirtualAgentControlDynamicCard, {
      data: dynamicCard
    })));
  }
  if (cardPayload) {
    return /* @__PURE__ */React78.createElement(EGDSLayoutFlexItem14, {
      alignSelf: "start",
      maxWidth: "seventy_two",
      "aria-label": accessibilityLabel != null ? accessibilityLabel : "",
      id: messageId
    }, /* @__PURE__ */React78.createElement(EGDSSpacing18, {
      margin: {
        blockstart: "half"
      }
    }, /* @__PURE__ */React78.createElement("div", null, /* @__PURE__ */React78.createElement(DynamicCardContextProvider, {
      value: dynamicCardContextData
    }, /* @__PURE__ */React78.createElement(DynamicCard, {
      data: parseJson(cardPayload)
    })))));
  }
  if (cardCarousel) {
    return /* @__PURE__ */React78.createElement(DynamicCardContextProvider, {
      value: dynamicCardContextData
    }, /* @__PURE__ */React78.createElement(DynamicCardCarousel, {
      data: cardCarousel,
      id: messageId,
      ariaLabel: accessibilityLabel != null ? accessibilityLabel : ""
    }));
  }
  return shouldShowDcfUnavailableMessage ? /* @__PURE__ */React78.createElement(EGDSLayoutFlex26, {
    space: "three",
    wrap: "wrap"
  }, /* @__PURE__ */React78.createElement(EGDSSpacing18, {
    margin: {
      blockstart: "three"
    },
    padding: "six"
  }, /* @__PURE__ */React78.createElement(EGDSCard6, {
    padded: true,
    border: true
  }, /* @__PURE__ */React78.createElement(EGDSText19, {
    inline: "strong"
  }, dcfUnavailableLine1), /* @__PURE__ */React78.createElement(EGDSText19, {
    size: 300,
    spacing: "two"
  }, dcfUnavailableLine2)))) : null;
};
VirtualAgentControlInboundDynamicCardMessage.fragment = fragment49;
VirtualAgentControlInboundDynamicCardMessage.displayName = "VirtualAgentControlInboundDynamicCardMessage";

// ../internal/src/components/messages/inbound-message/components/inbound-file-message.tsx
import React80 from "react";
import { gql as gql55 } from "@apollo/client";
import { v4 as uuidv46 } from "uuid";
import { EGDSLayoutFlex as EGDSLayoutFlex28, EGDSLayoutFlexItem as EGDSLayoutFlexItem16 } from "@egds/react-core/layout-flex";
import { useProvidedState as useProvidedState17 } from "@shared-ui/provided-state-context";

// ../internal/src/components/attachment-card/attachment-card.tsx
import React79 from "react";
import { gql as gql54 } from "@apollo/client";
import { EGDSCard as EGDSCard7, EGDSCardFeaturedHeader } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon8, EGDSIconSize as EGDSIconSize6 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex27, EGDSLayoutFlexItem as EGDSLayoutFlexItem15 } from "@egds/react-core/layout-flex";
import { EGDSLoader } from "@egds/react-core/loader";
import { EGDSSpacing as EGDSSpacing19 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText20 } from "@egds/react-core/text";
import { useProvidedState as useProvidedState16 } from "@shared-ui/provided-state-context";
var fragment50 = gql54`
  fragment VirtualAgentControlAttachmentCardFragment on EGDSStandardLink {
    text
    action {
      resource {
        value
      }
      target
      accessibility
      useRelativePath
    }
    disabled
    size
  }
`;
var VirtualAgentControlAttachmentCard = ({
  data,
  cardType,
  onAttachmentClick,
  uniqueAttachmentId,
  size,
  mediaUrl
}) => {
  const [state] = useProvidedState16();
  const attachmentStringMap = use_prefetch_localization_content_default(LocalizationContentKeys.ATTACHMENT);
  const {
    messagesState: {
      attachmentStatusMap
    }
  } = state;
  const {
    text,
    action: {
      accessibility
    }
  } = data;
  if (!text && !uniqueAttachmentId) {
    return null;
  }
  if (!attachmentStatusMap[uniqueAttachmentId]) {
    return null;
  }
  const {
    loading,
    operationType,
    hasError,
    isSuccess
  } = attachmentStatusMap[uniqueAttachmentId];
  const handleClick = event => {
    onAttachmentClick == null ? void 0 : onAttachmentClick(event);
  };
  const renderIcon = () => {
    if (loading) {
      return /* @__PURE__ */React79.createElement(EGDSLoader, {
        isSmall: true,
        isDarkBackground: cardType === "VirtualAgentControlOutboundFileMessage"
      });
    }
    if (hasError) {
      return /* @__PURE__ */React79.createElement(EGDSIcon8, {
        name: "error",
        theme: "negative",
        size: EGDSIconSize6.SMALL
      });
    }
    if (isSuccess) {
      return /* @__PURE__ */React79.createElement(EGDSIcon8, {
        name: "check_circle",
        theme: "positive",
        size: EGDSIconSize6.SMALL
      });
    }
    return /* @__PURE__ */React79.createElement(EGDSIcon8, {
      name: "download",
      theme: "primary",
      size: EGDSIconSize6.SMALL
    });
  };
  const renderStatusText = () => {
    if (operationType === "upload") {
      if (hasError) {
        const maxFileSize = "25MB";
        if (size && parseInt(size, 10) > maxFileSizeinInteger) {
          return localizeTemplateLiteral(attachmentStringMap.uploadFileSizeError, "maxFileSize", maxFileSize);
        }
        return attachmentStringMap.uploadError;
      }
      if (loading) {
        return attachmentStringMap.uploadProcessing;
      }
      return attachmentStringMap.uploadSuccess;
    }
    if (operationType === "download") {
      if (hasError) {
        return attachmentStringMap.downloadError;
      }
      if (loading) {
        return attachmentStringMap.downloadProcessing;
      }
      if (isSuccess) {
        return attachmentStringMap.downloadSuccess;
      }
      return "";
    }
  };
  const renderAttachmentCardContent = () => {
    return /* @__PURE__ */React79.createElement(EGDSLayoutFlex27, {
      direction: "row",
      "aria-label": accessibility != null ? accessibility : ""
    }, /* @__PURE__ */React79.createElement(EGDSLayoutFlexItem15, {
      alignSelf: "start",
      "aria-hidden": "true"
    }, /* @__PURE__ */React79.createElement(EGDSSpacing19, {
      margin: {
        inlineend: "one"
      }
    }, renderIcon())), /* @__PURE__ */React79.createElement(EGDSLayoutFlexItem15, null, /* @__PURE__ */React79.createElement(EGDSLayoutFlex27, {
      direction: "column"
    }, /* @__PURE__ */React79.createElement(EGDSLayoutFlexItem15, null, /* @__PURE__ */React79.createElement(EGDSStandardLink, {
      target: mediaUrl && "_blank",
      theme: cardType === "VirtualAgentControlOutboundFileMessage" ? "inverse" : "default",
      rel: mediaUrl ? " noopener" : "",
      onClick: handleClick,
      data: {
        __typename: "EGDSStandardLink",
        text: `${text}`,
        action: {
          __typename: "UILinkAction",
          resource: {
            __typename: "SelfReferencedURI",
            value: `${mediaUrl || "#"}`
          }
        },
        disabled: false,
        icon: null,
        iconPosition: null
      }
    })), /* @__PURE__ */React79.createElement(EGDSLayoutFlexItem15, null, /* @__PURE__ */React79.createElement(EGDSSpacing19, {
      margin: {
        blockstart: "one"
      }
    }, /* @__PURE__ */React79.createElement(EGDSText20, {
      size: 200,
      theme: cardType === "VirtualAgentControlOutboundFileMessage" ? "inverse" : "default",
      "data-stid": "attachment-status"
    }, renderStatusText()))))));
  };
  const renderAttachmentCard = () => {
    if (cardType === "VirtualAgentControlInboundFileMessage") {
      return /* @__PURE__ */React79.createElement(EGDSCard7, {
        padded: true,
        className: loading ? "is-disabled" : "",
        backgroundTheme: "secondary"
      }, renderAttachmentCardContent());
    }
    return /* @__PURE__ */React79.createElement(EGDSCard7, {
      padded: true,
      className: loading ? "is-disabled" : ""
    }, /* @__PURE__ */React79.createElement(EGDSCardFeaturedHeader, null, renderAttachmentCardContent()));
  };
  return /* @__PURE__ */React79.createElement(EGDSLayoutFlex27, {
    direction: "column"
  }, /* @__PURE__ */React79.createElement(EGDSLayoutFlexItem15, {
    alignSelf: cardType === "VirtualAgentControlInboundFileMessage" ? "start" : "end",
    maxWidth: "seventy_two"
  }, /* @__PURE__ */React79.createElement(EGDSSpacing19, {
    margin: {
      blockstart: "half"
    }
  }, renderAttachmentCard())));
};
VirtualAgentControlAttachmentCard.fragment = fragment50;
VirtualAgentControlAttachmentCard.displayName = "VirtualAgentControlAttachmentCard";

// ../internal/src/components/messages/inbound-message/components/inbound-file-message.tsx
var fragment51 = gql55`
  fragment VirtualAgentControlInboundFileMessageFragment on VirtualAgentControlInboundFileMessage {
    metadata {
      messageId
      timeStamp
      messageContextAccessibilityLabel
    }
    attachmentLink {
      ...VirtualAgentControlAttachmentCardFragment
    }
    stateUpdates {
      chatInput {
        interactionMode
        chatInputStatus
      }
    }
    attachmentMetadata {
      uniqueAttachmentId
      mediaType
    }
    accessibilityLabel
  }
  ${VirtualAgentControlAttachmentCard.fragment}
`;
var VirtualAgentControlInboundFileMessage = ({
  data
}) => {
  const {
    attachmentLink,
    attachmentMetadata,
    metadata: {
      messageId
    }
  } = data;
  const [uniqueAttachmentId, setUniqueAttachmentId] = React80.useState("");
  const [mediaUrl, setMediaUrl] = React80.useState("");
  const [conversation] = useConversationState();
  const {
    trackEvent
  } = useAnalytics();
  const [state, dispatch] = useProvidedState17();
  const [, downloadFile] = useAttachment();
  if (!attachmentLink) {
    return null;
  }
  const {
    messagesState: {
      attachmentStatusMap
    }
  } = state;
  const {
    action: {
      resource: {
        value
      },
      useRelativePath
    }
  } = attachmentLink;
  const getUniqueAttachmentIdFromResource = url => {
    const urlArrayFilePart = url.split("/files")[1];
    return urlArrayFilePart.split("/")[1];
  };
  const isDirectDownloadUrl = url => {
    if (url == null ? void 0 : url.match(/^blob:|^\/partners|^#vacservice|^#\/vacservice/)) {
      return void 0;
    }
    return url;
  };
  React80.useEffect(() => {
    if (attachmentMetadata == null ? void 0 : attachmentMetadata.uniqueAttachmentId) {
      setUniqueAttachmentId(attachmentMetadata == null ? void 0 : attachmentMetadata.uniqueAttachmentId);
      if (!attachmentStatusMap[attachmentMetadata.uniqueAttachmentId]) {
        dispatch({
          type: "UPDATE_ATTACHMENT_STATUS_MAP" /* UPDATE_ATTACHMENT_STATUS_MAP */,
          payload: {
            uniqueAttachmentId: attachmentMetadata.uniqueAttachmentId,
            attachmentStatus: {
              loading: false,
              hasError: false,
              isSuccess: false,
              operationType: AttachmentOperationTypes.DOWNLOAD
            }
          }
        });
      }
    } else {
      const id = !useRelativePath ? uuidv46() : getUniqueAttachmentIdFromResource(value);
      setUniqueAttachmentId(id);
      dispatch({
        type: "UPDATE_ATTACHMENT_STATUS_MAP" /* UPDATE_ATTACHMENT_STATUS_MAP */,
        payload: {
          uniqueAttachmentId: id,
          attachmentStatus: {
            loading: false,
            hasError: false,
            isSuccess: false,
            operationType: AttachmentOperationTypes.DOWNLOAD
          }
        }
      });
    }
  }, [value, attachmentMetadata == null ? void 0 : attachmentMetadata.uniqueAttachmentId]);
  const isViewableUrl = url => {
    return !!(url == null ? void 0 : url.match(/^blob:/));
  };
  const downloadSubmittedEvent = () => {
    trackEvent(buildClickstreamAdditionalContextPayload("ATTACHMENT_FILE_DOWNLOAD_SUBMITTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, {
      user_interface: {
        component_element_name: attachmentMetadata == null ? void 0 : attachmentMetadata.mediaType
      }
    }));
  };
  const downloadSucessfulEvent = () => {
    trackEvent(buildClickstreamAdditionalContextPayload("ATTACHMENT_FILE_DOWNLOAD_SUCCEEDED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, {
      user_interface: {
        component_element_name: attachmentMetadata == null ? void 0 : attachmentMetadata.mediaType
      }
    }));
  };
  const downloadFailureEvent = error => {
    trackEvent(buildClickstreamAdditionalContextErrorPayload("ATTACHMENT_FILE_DOWNLOAD_FAILED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, {
      user_interface: {
        component_element_name: attachmentMetadata == null ? void 0 : attachmentMetadata.mediaType
      }
    }, {
      error_name: error != null ? error : "network_error"
    }));
  };
  const previewFileEvent = () => {
    trackEvent(buildClickstreamAdditionalContextPayload("ATTACHMENT_FILE_PREVIEW_SELECTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, {
      user_interface: {
        component_element_name: attachmentMetadata == null ? void 0 : attachmentMetadata.mediaType
      }
    }));
  };
  const handleDownload = async event => {
    if (isViewableUrl(mediaUrl)) {
      previewFileEvent();
      return Promise.resolve();
    }
    event.stopPropagation();
    event.preventDefault();
    downloadSubmittedEvent();
    dispatch({
      type: "UPDATE_ATTACHMENT_STATUS_MAP" /* UPDATE_ATTACHMENT_STATUS_MAP */,
      payload: {
        uniqueAttachmentId,
        attachmentStatus: {
          loading: true,
          hasError: false,
          isSuccess: false,
          operationType: AttachmentOperationTypes.DOWNLOAD
        }
      }
    });
    try {
      let trimmedMediaUrl = value;
      if (value.startsWith("#")) {
        trimmedMediaUrl = value.slice(1);
      }
      const response = await downloadFile(trimmedMediaUrl);
      const {
        file_data: {
          bytes,
          file_metadata: {
            content_type
          }
        }
      } = response;
      downloadSucessfulEvent();
      const blobUrl = decodeFileBytes({
        bytes,
        mediaType: content_type
      });
      setMediaUrl(blobUrl);
      dispatch({
        type: "UPDATE_ATTACHMENT_STATUS_MAP" /* UPDATE_ATTACHMENT_STATUS_MAP */,
        payload: {
          uniqueAttachmentId,
          attachmentStatus: {
            loading: false,
            hasError: false,
            isSuccess: true,
            operationType: AttachmentOperationTypes.DOWNLOAD
          }
        }
      });
    } catch (err) {
      downloadFailureEvent(err == null ? void 0 : err.message);
      dispatch({
        type: "UPDATE_ATTACHMENT_STATUS_MAP" /* UPDATE_ATTACHMENT_STATUS_MAP */,
        payload: {
          uniqueAttachmentId,
          attachmentStatus: {
            loading: false,
            hasError: true,
            isSuccess: false,
            operationType: AttachmentOperationTypes.DOWNLOAD
          }
        }
      });
    }
  };
  const getOnAttachmentClickHandler = () => {
    if (!useRelativePath) {
      return () => {};
    }
    return event => handleDownload(event);
  };
  return /* @__PURE__ */React80.createElement(EGDSLayoutFlex28, {
    direction: "column",
    id: messageId
  }, /* @__PURE__ */React80.createElement(EGDSLayoutFlexItem16, {
    alignSelf: "end"
  }, attachmentLink && /* @__PURE__ */React80.createElement(VirtualAgentControlAttachmentCard, {
    data: attachmentLink,
    mediaUrl: isDirectDownloadUrl(value) || mediaUrl,
    uniqueAttachmentId,
    onAttachmentClick: getOnAttachmentClickHandler(),
    cardType: data.__typename
  })));
};
VirtualAgentControlInboundFileMessage.fragment = fragment51;
VirtualAgentControlInboundFileMessage.displayName = "VirtualAgentControlInboundFileMessage";

// ../internal/src/components/messages/inbound-message/components/inbound-text-message.tsx
import React82 from "react";
import Linkify from "react-linkify";
import { gql as gql56 } from "@apollo/client";
import { EGDSCard as EGDSCard8 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex29, EGDSLayoutFlexItem as EGDSLayoutFlexItem17 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing20 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText21 } from "@egds/react-core/text";

// ../internal/src/helpers/linkify-helpers.tsx
import React81 from "react";
import { EGDSLink as EGDSLink5 } from "@egds/react-core/link";
var getLinkComponentDecorator = (href, text, key, theme) => {
  return /* @__PURE__ */React81.createElement(EGDSLink5, {
    inline: true,
    key,
    theme
  }, /* @__PURE__ */React81.createElement("a", {
    href,
    target: "_blank",
    rel: "noopener"
  }, text));
};

// ../internal/src/components/messages/inbound-message/components/inbound-text-message.tsx
var fragment52 = gql56`
  fragment VirtualAgentControlInboundTextMessageFragment on VirtualAgentControlInboundTextMessage {
    eyebrow
    metadata {
      ... on VirtualAgentControlMessageMetadata {
        timeStamp
        messageId
        isActivityIndicatorMessage
        messageAuthor
        messageContextAccessibilityLabel
      }
    }
    stateUpdates {
      chatInput {
        interactionMode
        chatInputStatus
      }
    }
    quickReplies {
      ...VirtualAgentControlQuickReplyItemFragment
    }
    primary
  }
  ${VirtualAgentControlQuickReplyItem.fragment}
`;
var VirtualAgentControlInboundTextMessage = ({
  data
}) => {
  const {
    primary,
    metadata: {
      messageId
    }
  } = data;
  const linkComponentDecorator = (href, text, key) => {
    return getLinkComponentDecorator(href, text, key, "default");
  };
  const transformedMessageText = (messageText, mId) => {
    return messageText.split(/[\n\r]/).map((line, index, array) => {
      const uidString = `${line}+${index}`;
      return /* @__PURE__ */React82.createElement(Linkify, {
        componentDecorator: linkComponentDecorator,
        key: `${mId}-${uidString}`
      }, line, index < array.length - 1 ? /* @__PURE__ */React82.createElement("br", null) : "");
    });
  };
  return /* @__PURE__ */React82.createElement(EGDSLayoutFlex29, {
    direction: "column",
    id: messageId
  }, /* @__PURE__ */React82.createElement(EGDSLayoutFlexItem17, {
    alignSelf: "start",
    maxWidth: "seventy_two"
  }, /* @__PURE__ */React82.createElement(EGDSSpacing20, {
    margin: {
      blockstart: "half"
    }
  }, /* @__PURE__ */React82.createElement(EGDSCard8, {
    padded: true,
    backgroundTheme: "secondary"
  }, /* @__PURE__ */React82.createElement(EGDSText21, {
    size: 300,
    spacing: "half",
    wordBreak: true
  }, transformedMessageText(primary, messageId))))));
};
VirtualAgentControlInboundTextMessage.fragment = fragment52;
VirtualAgentControlInboundTextMessage.displayName = "VirtualAgentControlInboundTextMessage";

// ../internal/src/components/messages/inbound-message/inbound-message.tsx
var fragment53 = gql57`
  fragment VirtualAgentControlInboundMessageFragment on VirtualAgentControlInboundMessage {
    ...VirtualAgentControlInboundTextMessageFragment
    ...VirtualAgentControlInboundCardMessageFragment
    ...VirtualAgentControlInboundDynamicCardMessageFragment
    ...VirtualAgentControlInboundFileMessageFragment
    ...VirtualAgentControlInboundQuickReplyMessageFragment
  }

  fragment VirtualAgentControlInboundQuickReplyMessageFragment on VirtualAgentControlInboundQuickReplyMessage {
    eyebrow
    metadata {
      ... on VirtualAgentControlMessageMetadata {
        timeStamp
        messageId
        messageContextAccessibilityLabel
      }
    }
    stateUpdates {
      chatInput {
        interactionMode
        chatInputStatus
      }
    }
    quickReplies {
      ...VirtualAgentControlQuickReplyItemFragment
    }
  }

  ${VirtualAgentControlInboundTextMessage.fragment}
  ${VirtualAgentControlInboundCardMessage.fragment}
  ${VirtualAgentControlInboundDynamicCardMessage.fragment}
  ${VirtualAgentControlInboundFileMessage.fragment}
  ${VirtualAgentControlQuickReplyItem.fragment}
`;
var VirtualAgentControlInboundMessage = ({
  data
}) => {
  switch (data.__typename) {
    case "VirtualAgentControlInboundTextMessage":
      return /* @__PURE__ */React83.createElement(VirtualAgentControlInboundTextMessage, {
        data
      });
    case "VirtualAgentControlInboundCardMessage":
      return /* @__PURE__ */React83.createElement(VirtualAgentControlInboundCardMessage, {
        data
      });
    case "VirtualAgentControlInboundDynamicCardMessage":
      return /* @__PURE__ */React83.createElement(VirtualAgentControlInboundDynamicCardMessage, {
        data
      });
    case "VirtualAgentControlInboundFileMessage":
      return /* @__PURE__ */React83.createElement(VirtualAgentControlInboundFileMessage, {
        data
      });
    default:
      return null;
  }
};
VirtualAgentControlInboundMessage.fragment = fragment53;
VirtualAgentControlInboundMessage.displayName = "VirtualAgentControlInboundMessage";

// ../internal/src/components/messages/inbound-message-group/inbound-message-group.tsx
var fragment54 = gql58`
  fragment VirtualAgentControlInboundMessageGroupFragment on VirtualAgentControlInboundMessageGroup {
    eyebrow
    messages {
      ...VirtualAgentControlInboundMessageFragment
    }
    timeStamp
  }
  ${VirtualAgentControlInboundMessage.fragment}
`;
var VirtualAgentControlInboundMessageGroup = ({
  data
}) => {
  const {
    eyebrow,
    messages,
    timeStamp
  } = data;
  const chatBubbleTimestamp = useLocaleDateTimestamp(timeStamp || "");
  const {
    timestampAccessibilityLabelTemplate
  } = use_prefetch_localization_content_default(LocalizationContentKeys.MESSAGE) || {};
  const groupId = React84.useMemo(() => uuidv47(), []);
  const timeStampId = React84.useMemo(() => `timeStamp-${uuidv47()}`, []);
  if (!messages.length) {
    return null;
  }
  const visibleMessages = messages.filter(message => message.__typename !== "VirtualAgentControlInboundQuickReplyMessage");
  const messageIds = visibleMessages.map(message => message.metadata.messageId);
  const getParticipantAccessibilityLabel = () => {
    const {
      metadata: {
        messageContextAccessibilityLabel
      }
    } = visibleMessages[0];
    return messageContextAccessibilityLabel;
  };
  return /* @__PURE__ */React84.createElement(EGDSLayoutFlex30, {
    direction: "column",
    role: "group",
    "aria-labelledby": `${[groupId, ...messageIds, timeStampId].join(" ")}`
  }, eyebrow && /* @__PURE__ */React84.createElement(EGDSLayoutFlexItem18, {
    alignSelf: "start"
  }, /* @__PURE__ */React84.createElement(EGDSSpacing21, null, getParticipantAccessibilityLabel() ? /* @__PURE__ */React84.createElement(EGDSText22, {
    size: 200,
    spacing: "half",
    theme: "standard",
    "aria-hidden": "true"
  }, eyebrow) : /* @__PURE__ */React84.createElement(EGDSText22, {
    size: 200,
    spacing: "half",
    theme: "standard"
  }, eyebrow))), getParticipantAccessibilityLabel() ? /* @__PURE__ */React84.createElement("span", {
    id: groupId,
    className: "is-visually-hidden"
  }, getParticipantAccessibilityLabel()) : null, visibleMessages.map((message, index) => /* @__PURE__ */React84.createElement(VirtualAgentControlInboundMessage, {
    data: message,
    key: `message-${index}`
  })), timeStamp && /* @__PURE__ */React84.createElement(EGDSLayoutFlexItem18, {
    alignSelf: "start"
  }, /* @__PURE__ */React84.createElement(EGDSText22, {
    size: 200,
    spacing: "half",
    theme: "standard",
    "aria-hidden": "true"
  }, chatBubbleTimestamp)), /* @__PURE__ */React84.createElement("span", {
    id: timeStampId,
    className: "is-visually-hidden"
  }, timestampAccessibilityLabelTemplate && localizeTemplateLiteral(timestampAccessibilityLabelTemplate, "timeStamp", chatBubbleTimestamp)));
};
VirtualAgentControlInboundMessageGroup.fragment = fragment54;
VirtualAgentControlInboundMessageGroup.displayName = "VirtualAgentControlInboundMessageGroup";

// ../internal/src/components/messages/separator/message-separator.tsx
import React85 from "react";
import { gql as gql59 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex31, EGDSLayoutFlexItem as EGDSLayoutFlexItem19 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing22, EGDSSpacingHr as EGDSSpacingHr5 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7 } from "@egds/react-core/text";
var fragment55 = gql59`
  fragment VirtualAgentControlMessageSeparatorFragment on VirtualAgentControlMessageSeparator {
    primary
    timeStamp: timestamp
    meta {
      participantId
    }
  }
`;
var VirtualAgentControlMessageSeparator = ({
  data
}) => {
  const {
    primary
  } = data;
  const sessionMarkerLabel = useSessionMarkerLabel(primary);
  return /* @__PURE__ */React85.createElement(React85.Fragment, null, primary && /* @__PURE__ */React85.createElement(EGDSLayoutFlex31, {
    direction: "row",
    wrap: "wrap",
    alignItems: "center"
  }, /* @__PURE__ */React85.createElement(EGDSLayoutFlexItem19, {
    grow: 10,
    shrink: 0
  }, /* @__PURE__ */React85.createElement("div", {
    "aria-hidden": "true"
  }, /* @__PURE__ */React85.createElement(EGDSSpacingHr5, {
    blockMargin: "two"
  }))), /* @__PURE__ */React85.createElement(EGDSLayoutFlexItem19, null, /* @__PURE__ */React85.createElement(EGDSSpacing22, {
    padding: {
      inline: "two"
    }
  }, /* @__PURE__ */React85.createElement(EGDSHeading7, {
    tag: "h2",
    size: 8
  }, sessionMarkerLabel))), /* @__PURE__ */React85.createElement(EGDSLayoutFlexItem19, {
    grow: 10,
    shrink: 0
  }, /* @__PURE__ */React85.createElement("div", {
    "aria-hidden": "true"
  }, /* @__PURE__ */React85.createElement(EGDSSpacingHr5, {
    blockMargin: "two"
  })))));
};
VirtualAgentControlMessageSeparator.fragment = fragment55;
VirtualAgentControlMessageSeparator.displayName = "VirtualAgentControlMessageSeparator";

// ../internal/src/components/messages/vac-messages-mapper/vac-messages-mapper.tsx
import React91 from "react";

// ../internal/src/components/messages/message-loader/message-loader.tsx
import React86 from "react";
import { useInView } from "react-intersection-observer";
import { gql as gql60 } from "@apollo/client";
import { EGDSIcon as EGDSIcon9 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex32, EGDSLayoutFlexItem as EGDSLayoutFlexItem20 } from "@egds/react-core/layout-flex";
import { EGDSLoader as EGDSLoader2 } from "@egds/react-core/loader";
import { useProvidedState as useProvidedState18 } from "@shared-ui/provided-state-context";
var fragment56 = gql60`
  fragment VirtualAgentControlMessageLoaderFragment on VirtualAgentControlMessageLoader {
    conversationHistoryAttributes {
      key
      value
    }
    loaderText
    retryIcon {
      token
      size
      theme
    }
    retryText {
      text {
        ...EGDSSpannableTextFragment
      }
    }
  }
  ${EGDSSpannableText.fragment}
`;
var VirtualAgentControlMessageLoader = ({
  data
}) => {
  var _a, _b, _c;
  const {
    retryIcon,
    retryText,
    loaderText,
    conversationHistoryAttributes
  } = data;
  const {
    ref,
    inView
  } = useInView({
    threshold: 0.7
    // Percentage of the user visibility. 1.0 means every pixel is visible in the viewport.
  });
  const [showRetryIcon, setShowRetryIcon] = React86.useState(false);
  const [, conversationDispatch, conversationContext] = useConversationState();
  const [state, dispatch] = useProvidedState18();
  const fetchHistoryMessagesStatus = (_a = state.messagesState.messagesByConversationId[conversationContext.conversationId]) == null ? void 0 : _a.fetchHistoryMessagesStatus;
  React86.useEffect(() => {
    if (conversationHistoryAttributes) {
      conversationDispatch({
        type: "UPDATE_CONVERSATION" /* UPDATE_CONVERSATION */,
        payload: {
          conversationHistoryAttributes
        }
      });
    } else {
      conversationDispatch({
        type: "UPDATE_CONVERSATION" /* UPDATE_CONVERSATION */,
        payload: {
          conversationHistoryAttributes: null
        }
      });
    }
  }, [conversationHistoryAttributes]);
  React86.useEffect(() => {
    if (inView && (conversationHistoryAttributes == null ? void 0 : conversationHistoryAttributes.length)) {
      dispatch({
        type: "UPDATE_MESSAGE_LOADER_VISIBILITY" /* UPDATE_MESSAGE_LOADER_VISIBILITY */,
        payload: {
          conversationId: conversationContext.conversationId,
          isMessageLoaderVisible: true
        }
      });
    } else {
      dispatch({
        type: "UPDATE_MESSAGE_LOADER_VISIBILITY" /* UPDATE_MESSAGE_LOADER_VISIBILITY */,
        payload: {
          conversationId: conversationContext.conversationId,
          isMessageLoaderVisible: false
        }
      });
    }
  }, [inView]);
  React86.useEffect(() => {
    if (fetchHistoryMessagesStatus === "failed") {
      setShowRetryIcon(true);
    }
  }, [fetchHistoryMessagesStatus]);
  const handleRetry = e => {
    e.preventDefault();
    setShowRetryIcon(false);
    dispatch({
      type: "FETCH_HISTORY_MESSAGES_STATUS" /* FETCH_HISTORY_MESSAGES_STATUS */,
      payload: {
        status: null,
        conversationId: conversationContext.conversationId
      }
    });
  };
  if (showRetryIcon && retryIcon && (retryText == null ? void 0 : retryText.text)) {
    return /* @__PURE__ */React86.createElement(EGDSLayoutFlex32, {
      alignItems: "center",
      direction: "column"
    }, /* @__PURE__ */React86.createElement(EGDSLayoutFlexItem20, null, /* @__PURE__ */React86.createElement(EGDSIcon9, {
      name: retryIcon.token,
      theme: (_b = retryIcon.theme) != null ? _b : "default",
      size: iconSizeMapper[(_c = retryIcon.size) != null ? _c : "small"]
    })), /* @__PURE__ */React86.createElement(EGDSLayoutFlexItem20, null, /* @__PURE__ */React86.createElement(EGDSSpannableText, {
      data: retryText.text,
      onClick: handleRetry
    })));
  }
  return /* @__PURE__ */React86.createElement(EGDSLayoutFlex32, {
    alignItems: "center",
    direction: "column",
    domRef: ref
  }, /* @__PURE__ */React86.createElement(EGDSLayoutFlexItem20, null, /* @__PURE__ */React86.createElement(EGDSLoader2, {
    title: loaderText != null ? loaderText : "",
    isSmall: true
  })));
};
VirtualAgentControlMessageLoader.fragment = fragment56;
VirtualAgentControlMessageLoader.displayName = "VirtualAgentControlOutboundMessageElement";

// ../internal/src/components/messages/outbound-message-element-group/outbound-message-element-group.tsx
import React90 from "react";
import { gql as gql64 } from "@apollo/client";
import { v4 as uuidv48 } from "uuid";
import { EGDSLayoutFlex as EGDSLayoutFlex35, EGDSLayoutFlexItem as EGDSLayoutFlexItem23 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText25 } from "@egds/react-core/text";

// ../internal/src/components/messages/outbound-message-element/outbound-message-element.tsx
import React89 from "react";
import { gql as gql63 } from "@apollo/client";

// ../internal/src/components/messages/outbound-message-element/components/outbound-file-message.tsx
import React87 from "react";
import { gql as gql61 } from "@apollo/client";
import Omit2 from "lodash.omit";
import { EGDSLayoutFlex as EGDSLayoutFlex33, EGDSLayoutFlexItem as EGDSLayoutFlexItem21 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink6 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing23 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText23 } from "@egds/react-core/text";
import { useProvidedState as useProvidedState19 } from "@shared-ui/provided-state-context";
var fragment57 = gql61`
  fragment VirtualAgentControlOutboundFileMessageFragment on VirtualAgentControlOutboundFileMessage {
    status
    accessibilityLabel
    metadata {
      messageId
      timeStamp
      messageContextAccessibilityLabel
    }
    attachmentLink {
      ...VirtualAgentControlAttachmentCardFragment
    }
    attachmentMetadata {
      uniqueAttachmentId
      mediaType
      mediaUrl
      name
      size
    }
  }
  ${VirtualAgentControlAttachmentCard.fragment}
`;
var VirtualAgentControlOutboundFileMessage = ({
  data
}) => {
  var _a, _b, _c;
  const {
    status,
    attachmentLink,
    attachmentMetadata,
    metadata: {
      messageId
    }
  } = data;
  const [uniqueAttachmentId, setUniqueAttachmentId] = React87.useState("");
  const [mediaUrl, setMediaUrl] = React87.useState("");
  const [conversation] = useConversationState();
  const {
    trackEvent
  } = useAnalytics();
  const [state, dispatch] = useProvidedState19();
  const [, downloadFile] = useAttachment();
  const messageContent = use_prefetch_localization_content_default(LocalizationContentKeys.MESSAGE);
  const sendMessage = useOperation("SEND_MESSAGE" /* SEND_MESSAGE */);
  if (!attachmentLink) {
    return null;
  }
  const {
    messagesState: {
      attachmentStatusMap
    }
  } = state;
  const {
    action: {
      resource: {
        value
      }
    }
  } = attachmentLink;
  const getUniqueAttachmentIdFromResource = url => {
    const urlArray = url.split("/");
    return urlArray[urlArray.length - 1];
  };
  React87.useEffect(() => {
    if (attachmentMetadata == null ? void 0 : attachmentMetadata.uniqueAttachmentId) {
      setUniqueAttachmentId(attachmentMetadata == null ? void 0 : attachmentMetadata.uniqueAttachmentId);
      if (!attachmentStatusMap[attachmentMetadata.uniqueAttachmentId]) {
        dispatch({
          type: "UPDATE_ATTACHMENT_STATUS_MAP" /* UPDATE_ATTACHMENT_STATUS_MAP */,
          payload: {
            uniqueAttachmentId: attachmentMetadata.uniqueAttachmentId,
            attachmentStatus: {
              loading: false,
              hasError: false,
              isSuccess: false,
              operationType: AttachmentOperationTypes.DOWNLOAD
            }
          }
        });
      } else {
        setMediaUrl(value);
      }
    } else {
      const id = getUniqueAttachmentIdFromResource(value);
      setUniqueAttachmentId(id);
      dispatch({
        type: "UPDATE_ATTACHMENT_STATUS_MAP" /* UPDATE_ATTACHMENT_STATUS_MAP */,
        payload: {
          uniqueAttachmentId: id,
          attachmentStatus: {
            loading: false,
            hasError: false,
            isSuccess: false,
            operationType: AttachmentOperationTypes.DOWNLOAD
          }
        }
      });
    }
  }, [value, attachmentMetadata == null ? void 0 : attachmentMetadata.uniqueAttachmentId]);
  const isViewableUrl = url => {
    return !!(url == null ? void 0 : url.match(/^blob:/));
  };
  const downloadSubmittedEvent = () => {
    trackEvent(buildClickstreamAdditionalContextPayload("ATTACHMENT_FILE_DOWNLOAD_SUBMITTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, {
      user_interface: {
        component_element_name: attachmentMetadata == null ? void 0 : attachmentMetadata.mediaType
      }
    }));
  };
  const downloadSucessfulEvent = () => {
    trackEvent(buildClickstreamAdditionalContextPayload("ATTACHMENT_FILE_DOWNLOAD_SUCCEEDED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, {
      user_interface: {
        component_element_name: attachmentMetadata == null ? void 0 : attachmentMetadata.mediaType
      }
    }));
  };
  const downloadFailureEvent = error => {
    trackEvent(buildClickstreamAdditionalContextErrorPayload("ATTACHMENT_FILE_DOWNLOAD_FAILED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, {
      user_interface: {
        component_element_name: attachmentMetadata == null ? void 0 : attachmentMetadata.mediaType
      }
    }, {
      error_name: error != null ? error : "network_error"
    }));
  };
  const previewFileEvent = () => {
    trackEvent(buildClickstreamAdditionalContextPayload("ATTACHMENT_FILE_PREVIEW_SELECTED", conversation == null ? void 0 : conversation.conversationId, conversation == null ? void 0 : conversation.type, {
      user_interface: {
        component_element_name: attachmentMetadata == null ? void 0 : attachmentMetadata.mediaType
      }
    }));
  };
  const handleDownload = async event => {
    if (isViewableUrl(mediaUrl)) {
      previewFileEvent();
      return Promise.resolve();
    }
    event.stopPropagation();
    event.preventDefault();
    downloadSubmittedEvent();
    dispatch({
      type: "UPDATE_ATTACHMENT_STATUS_MAP" /* UPDATE_ATTACHMENT_STATUS_MAP */,
      payload: {
        uniqueAttachmentId,
        attachmentStatus: {
          loading: true,
          hasError: false,
          isSuccess: false,
          operationType: AttachmentOperationTypes.DOWNLOAD
        }
      }
    });
    try {
      let trimmedMediaUrl = value;
      if (value.startsWith("#")) {
        trimmedMediaUrl = value.slice(1);
      }
      const response = await downloadFile(trimmedMediaUrl);
      const {
        file_data: {
          bytes,
          file_metadata: {
            content_type
          }
        }
      } = response;
      downloadSucessfulEvent();
      const blobUrl = decodeFileBytes({
        bytes,
        mediaType: content_type
      });
      setMediaUrl(blobUrl);
      dispatch({
        type: "UPDATE_ATTACHMENT_STATUS_MAP" /* UPDATE_ATTACHMENT_STATUS_MAP */,
        payload: {
          uniqueAttachmentId,
          attachmentStatus: {
            loading: false,
            hasError: false,
            isSuccess: true,
            operationType: AttachmentOperationTypes.DOWNLOAD
          }
        }
      });
    } catch (err) {
      downloadFailureEvent(err == null ? void 0 : err.message);
      dispatch({
        type: "UPDATE_ATTACHMENT_STATUS_MAP" /* UPDATE_ATTACHMENT_STATUS_MAP */,
        payload: {
          uniqueAttachmentId,
          attachmentStatus: {
            loading: false,
            hasError: true,
            isSuccess: false,
            operationType: AttachmentOperationTypes.DOWNLOAD
          }
        }
      });
    }
  };
  const handleResend = e => {
    e.preventDefault();
    if (!attachmentMetadata || +attachmentMetadata.size > maxFileSizeinInteger) {
      return;
    }
    sendMessage == null ? void 0 : sendMessage({
      messageType: "FILE" /* FILE */,
      attachment: __spreadValues({}, Omit2(attachmentMetadata, ["__typename"])),
      umid: messageId,
      operation: "retry"
    });
  };
  return /* @__PURE__ */React87.createElement(EGDSLayoutFlex33, {
    direction: "column",
    id: messageId
  }, /* @__PURE__ */React87.createElement(EGDSLayoutFlexItem21, {
    alignSelf: "end"
  }, attachmentLink && /* @__PURE__ */React87.createElement(VirtualAgentControlAttachmentCard, {
    data: attachmentLink,
    mediaUrl: attachmentMetadata && ((_a = attachmentStatusMap[attachmentMetadata == null ? void 0 : attachmentMetadata.uniqueAttachmentId]) == null ? void 0 : _a.operationType) === "upload" ? (_c = (_b = attachmentLink == null ? void 0 : attachmentLink.action) == null ? void 0 : _b.resource) == null ? void 0 : _c.value : mediaUrl,
    uniqueAttachmentId,
    onAttachmentClick: event => handleDownload(event),
    cardType: data.__typename,
    size: attachmentMetadata == null ? void 0 : attachmentMetadata.size
  })), status && /* @__PURE__ */React87.createElement(EGDSLayoutFlexItem21, {
    alignSelf: "end"
  }, /* @__PURE__ */React87.createElement(EGDSText23, {
    size: 200,
    spacing: "half",
    theme: "standard"
  }, status, status === (messageContent == null ? void 0 : messageContent.statusNotDelivered) && /* @__PURE__ */React87.createElement(EGDSSpacing23, {
    margin: "one"
  }, /* @__PURE__ */React87.createElement(EGDSLink6, {
    size: "small",
    inline: true,
    onClick: handleResend
  }, /* @__PURE__ */React87.createElement("a", {
    href: "#"
  }, messageContent == null ? void 0 : messageContent.statusRetry))))));
};
VirtualAgentControlOutboundFileMessage.fragment = fragment57;
VirtualAgentControlOutboundFileMessage.displayName = "VirtualAgentControlOutboundFileMessage";

// ../internal/src/components/messages/outbound-message-element/components/outbound-text-message.tsx
import React88 from "react";
import Linkify2 from "react-linkify";
import { gql as gql62 } from "@apollo/client";
import { EGDSCard as EGDSCard9, EGDSCardFeaturedHeader as EGDSCardFeaturedHeader2 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex34, EGDSLayoutFlexItem as EGDSLayoutFlexItem22 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink7 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing24 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText24 } from "@egds/react-core/text";
var fragment58 = gql62`
  fragment VirtualAgentControlOutboundTextMessageFragment on VirtualAgentControlOutboundTextMessage {
    metadata {
      messageId
      timeStamp
      messageContextAccessibilityLabel
    }
    primary
    status
  }
`;
var VirtualAgentControlOutboundTextMessage = ({
  data
}) => {
  const {
    primary,
    status,
    metadata: {
      messageId
    }
  } = data;
  const messageContent = use_prefetch_localization_content_default(LocalizationContentKeys.MESSAGE);
  const sendMessage = useOperation("SEND_MESSAGE" /* SEND_MESSAGE */);
  const linkComponentDecorator = (href, text, key) => {
    return getLinkComponentDecorator(href, text, key, "inverse");
  };
  const transformedMessageText = (messageText, mId) => {
    return messageText.split(/[\n\r]/).map((line, index, array) => {
      const uidString = `${line}+${index}`;
      return /* @__PURE__ */React88.createElement(Linkify2, {
        componentDecorator: linkComponentDecorator,
        key: `${mId}-${uidString}`
      }, line, index < array.length - 1 ? /* @__PURE__ */React88.createElement("br", null) : "");
    });
  };
  const handleResend = e => {
    e.preventDefault();
    sendMessage == null ? void 0 : sendMessage({
      message: primary,
      operation: "retry",
      umid: messageId
    });
  };
  return /* @__PURE__ */React88.createElement(EGDSLayoutFlex34, {
    direction: "column",
    id: messageId
  }, /* @__PURE__ */React88.createElement(EGDSLayoutFlexItem22, {
    alignSelf: "end",
    maxWidth: "seventy_two"
  }, /* @__PURE__ */React88.createElement(EGDSSpacing24, {
    margin: {
      blockstart: "half"
    }
  }, /* @__PURE__ */React88.createElement("article", null, /* @__PURE__ */React88.createElement(EGDSCard9, {
    padded: true
  }, /* @__PURE__ */React88.createElement(EGDSCardFeaturedHeader2, null, /* @__PURE__ */React88.createElement(EGDSText24, {
    size: 300,
    theme: "inverse"
  }, transformedMessageText(primary, messageId))))))), status && /* @__PURE__ */React88.createElement(EGDSLayoutFlexItem22, {
    alignSelf: "end"
  }, /* @__PURE__ */React88.createElement(EGDSText24, {
    size: 200,
    spacing: "half",
    theme: "standard"
  }, status, status === (messageContent == null ? void 0 : messageContent.statusNotDelivered) && /* @__PURE__ */React88.createElement(EGDSSpacing24, {
    margin: "one"
  }, /* @__PURE__ */React88.createElement(EGDSLink7, {
    size: "small",
    inline: true,
    onClick: handleResend
  }, /* @__PURE__ */React88.createElement("a", {
    href: "#"
  }, messageContent == null ? void 0 : messageContent.statusRetry))))));
};
VirtualAgentControlOutboundTextMessage.displayName = "VirtualAgentControlOutboundTextMessage";
VirtualAgentControlOutboundTextMessage.fragment = fragment58;

// ../internal/src/components/messages/outbound-message-element/outbound-message-element.tsx
var fragment59 = gql63`
  fragment VirtualAgentControlOutboundMessageElementFragment on VirtualAgentControlOutboundMessageElement {
    ...VirtualAgentControlOutboundFileMessageFragment
    ...VirtualAgentControlOutboundTextMessageFragment
  }

  ${VirtualAgentControlOutboundFileMessage.fragment}
  ${VirtualAgentControlOutboundTextMessage.fragment}
`;
var VirtualAgentControlOutboundMessageElement = ({
  data
}) => {
  switch (data.__typename) {
    case "VirtualAgentControlOutboundFileMessage":
      return /* @__PURE__ */React89.createElement(VirtualAgentControlOutboundFileMessage, {
        data
      });
    case "VirtualAgentControlOutboundTextMessage":
      return /* @__PURE__ */React89.createElement(VirtualAgentControlOutboundTextMessage, {
        data
      });
    default:
      return null;
  }
};
VirtualAgentControlOutboundMessageElement.fragment = fragment59;
VirtualAgentControlOutboundMessageElement.displayName = "VirtualAgentControlOutboundMessageElement";

// ../internal/src/components/messages/outbound-message-element-group/outbound-message-element-group.tsx
var fragment60 = gql64`
  fragment VirtualAgentControlOutboundMessageElementGroupFragment on VirtualAgentControlOutboundMessageElementGroup {
    messages {
      ...VirtualAgentControlOutboundMessageElementFragment
    }
    status
  }
  ${VirtualAgentControlOutboundMessageElement.fragment}
`;
var VirtualAgentControlOutboundMessageElementGroup = ({
  data
}) => {
  const {
    messages,
    status
  } = data;
  const {
    outboundMessageContextAccessibilityLabel
  } = use_prefetch_localization_content_default(LocalizationContentKeys.PARTICIPANT) || {};
  const groupId = React90.useMemo(() => uuidv48(), []);
  if (!messages.length) {
    return null;
  }
  const messageIds = messages.map(message => message.metadata.messageId);
  const getParticipantAccessibilityLabel = () => {
    const {
      metadata
    } = messages[0];
    return metadata == null ? void 0 : metadata.messageContextAccessibilityLabel;
  };
  return /* @__PURE__ */React90.createElement(EGDSLayoutFlex35, {
    direction: "column",
    role: "group",
    "aria-labelledby": `${[groupId, ...messageIds].join(" ")}`
  }, /* @__PURE__ */React90.createElement("span", {
    id: groupId,
    className: "is-visually-hidden"
  }, getParticipantAccessibilityLabel() || outboundMessageContextAccessibilityLabel, ","), messages.map((message, index) => /* @__PURE__ */React90.createElement(VirtualAgentControlOutboundMessageElement, {
    data: __spreadProps(__spreadValues({}, message), {
      status: status ? null : message.status
    }),
    key: `message-${index}`
  })), status && /* @__PURE__ */React90.createElement(EGDSLayoutFlexItem23, {
    alignSelf: "end"
  }, /* @__PURE__ */React90.createElement(EGDSText25, {
    size: 200,
    spacing: "half",
    theme: "standard"
  }, status)));
};
VirtualAgentControlOutboundMessageElementGroup.fragment = fragment60;
VirtualAgentControlOutboundMessageElementGroup.displayName = "VirtualAgentControlOutboundMessageElementGroup";

// ../internal/src/components/messages/vac-messages-mapper/vac-messages-mapper.tsx
var VirtualAgentControlMessagesMapper = ({
  data
}) => {
  switch (data == null ? void 0 : data.__typename) {
    case "VirtualAgentControlInboundDynamicCardMessage":
    case "VirtualAgentControlInboundTextMessage":
    case "VirtualAgentControlInboundFileMessage":
      return /* @__PURE__ */React91.createElement(VirtualAgentControlInboundMessage, {
        data
      });
    case "VirtualAgentControlInboundMessageGroup":
      return /* @__PURE__ */React91.createElement(VirtualAgentControlInboundMessageGroup, {
        data
      });
    case "VirtualAgentControlMessageSeparator":
      return /* @__PURE__ */React91.createElement(VirtualAgentControlMessageSeparator, {
        data
      });
    case "VirtualAgentControlOutboundMessageElementGroup":
      return /* @__PURE__ */React91.createElement(VirtualAgentControlOutboundMessageElementGroup, {
        data
      });
    case "VirtualAgentControlMessageLoader":
      return /* @__PURE__ */React91.createElement(VirtualAgentControlMessageLoader, {
        data
      });
    default:
      return null;
  }
};

// src/service/chat/chat.tsx
var __ChatQuery = gql65`
  query ChatQuery(
    $authenticationConfig: AuthenticationConfigInput
    $context: ContextInput!
    $conversationContext: ConversationContextInput
    $embedded: Boolean = false
  ) {
    virtualAgentControl(
      authenticationConfig: $authenticationConfig
      context: $context
      conversationContext: $conversationContext
      embedded: $embedded
    ) {
      trigger @skip(if: $embedded) {
        ...VirtualAgentControlTriggerFragment
      }
      chat {
        analytics {
          ... on VirtualAgentControlImpressionAnalyticEvent {
            eventName
            eventVersion
            payload
          }
          ... on VirtualAgentControlInteractionAnalyticEvent {
            eventName
            eventVersion
            payload
          }
          ... on VirtualAgentControlOutcomeAnalyticEvent {
            eventName
            eventVersion
            payload
          }
          ... on VirtualAgentControlPageViewAnalyticEvent {
            eventName
            eventVersion
            payload
          }
        }
        header {
          ... on VirtualAgentControlChatHeader {
            ...VirtualAgentControlChatHeaderFragment
          }
          ... on VirtualAgentControlToolbar {
            ...VirtualAgentControlToolbarFragment
          }
        }
        conversationIntro {
          primary
          secondary
          bottomBorder {
            ...VirtualAgentControlMessageSeparatorFragment
          }
        }
        footer {
          ...VirtualAgentControlChatFooterFragment
        }
        landmarkChatContentAccessibilityLabel
        skipToMostRecentMessageAccessibilityLabel
      }
      chatConfig {
        channelOrigin {
          partnerGuid
          channelOriginId
        }
        chatCapabilities {
          enableHistory
          notificationConfig {
            enableSound
            audioUrl
          }
          presenceConfig {
            heartbeatIntervalInMillis
            mode
          }
          participantTypesForEventMarkers
          showParticipantEventMarker
        }
      }
      settingsMenu {
        ... on VirtualAgentControlMenuPopoverView {
          ...VirtualAgentControlMenuPopoverViewFragment
        }
        ... on VirtualAgentControlMenuBottomSheetView {
          ...VirtualAgentControlMenuBottomSheetViewFragment
        }
      }
    }
  }

  ${VirtualAgentControlTrigger.fragment}
  ${VirtualAgentControlChatHeader.fragment}
  ${VirtualAgentControlToolbar.fragment}
  ${VirtualAgentControlChatFooter.fragment}
  ${VirtualAgentControlMessageSeparator.fragment}
  ${VirtualAgentControlMenuPopoverView.fragment}
  ${VirtualAgentControlMenuBottomSheetView.fragment}
`;

// src/service/chat/chat-trigger.tsx
import { gql as gql66 } from "@apollo/client";
var __ChatTriggerQuery = gql66`
  query ChatTriggerQuery($authenticationConfig: AuthenticationConfigInput, $context: ContextInput!) {
    virtualAgentControl(authenticationConfig: $authenticationConfig, context: $context) {
      trigger {
        ...VirtualAgentControlTriggerFragment
      }
    }
  }
  ${VirtualAgentControlTrigger.fragment}
`;

// src/service/chat/chat-window.tsx
import { gql as gql67 } from "@apollo/client";
var __ChatWindowQuery = gql67`
  query ChatWindowQuery($authenticationConfig: AuthenticationConfigInput, $context: ContextInput!) {
    virtualAgentControl(authenticationConfig: $authenticationConfig, context: $context) {
      chat {
        header {
          ... on VirtualAgentControlChatHeader {
            ...VirtualAgentControlChatHeaderFragment
          }
          ... on VirtualAgentControlToolbar {
            ...VirtualAgentControlToolbarFragment
          }
        }
        conversationIntro {
          primary
          secondary
          bottomBorder {
            ...VirtualAgentControlMessageSeparatorFragment
          }
        }
        footer {
          ...VirtualAgentControlChatFooterFragment
        }
      }
    }
  }
  ${VirtualAgentControlChatHeader.fragment}
  ${VirtualAgentControlToolbar.fragment}
  ${VirtualAgentControlMessageSeparator.fragment}
  ${VirtualAgentControlChatFooter.fragment}
`;

// src/hooks/use-chat.tsx
var useChatQuery = (skipSsr, embedded, conversationContext, channelOriginId, handlers = {}) => useVacQuery(__ChatQuery, {
  variables: {
    embedded,
    conversationContext
  },
  ssr: !skipSsr,
  authenticationConfig: {
    channelOriginId
  },
  handlers
});
var useChatTriggerQuery = (skipSsr, authenticationConfig, handlers = {}) => useVacQuery(__ChatTriggerQuery, {
  variables: {},
  ssr: !skipSsr,
  authenticationConfig,
  handlers
});
var useChatWindowQuery = (skipSsr, authenticationConfig, handlers = {}) => useVacQuery(__ChatWindowQuery, {
  variables: {},
  ssr: !skipSsr,
  authenticationConfig,
  handlers
});
function useVacQuery(query, {
  variables,
  ssr,
  authenticationConfig,
  handlers
}) {
  const {
    context
  } = useBexApi5();
  const {
    onCompleted,
    onError
  } = handlers;
  const {
    data,
    error,
    loading
  } = useQuery(query, {
    variables: __spreadProps(__spreadValues({
      context
    }, variables), {
      authenticationConfig
    }),
    ssr,
    onError,
    onCompleted
  });
  return {
    query: {
      data,
      error,
      loading
    }
  };
}

// src/hooks/use-conversation-read-event.tsx
import { useEffect as useEffect8, useRef as useRef2 } from "react";
import { useSignalSubscriber as useSignalSubscriber4 } from "@shared-ui/core-signal-manager/context";
import { VacConversationReadSignal } from "@shared-ui/retail-signals-virtual-agent";
function useConversationReadEvent(isChatVisible, embedded) {
  const [conversation] = useConversationState();
  const [, conversationMessages] = useMessagesState();
  const sendEvent = useOperation("TYPING_EVENT" /* TYPING_EVENT */);
  const isThrottling = useRef2(false);
  useEffect8(() => {
    if (isChatVisible && (conversationMessages == null ? void 0 : conversationMessages.unreadMessageCount) > 0 && conversation.conversationId) {
      handleConversationReadEvent(conversation.conversationId);
    }
  }, [isChatVisible]);
  const handleConversationReadEvent = eventConversationId => {
    if (eventConversationId !== conversation.conversationId) {
      return;
    }
    if (isThrottling.current) {
      return;
    }
    if (!isChatVisible && !embedded) {
      return;
    }
    sendEvent == null ? void 0 : sendEvent({
      eventType: "CONVERSATION_READ" /* CONVERSATION_READ */
    });
    isThrottling.current = true;
    setTimeout(() => {
      isThrottling.current = false;
    }, 500);
  };
  useSignalSubscriber4("VAC_CONVERSATION_READ" /* VAC_ConversationRead */, VacConversationReadSignal, {
    onSuccess: ({
      payload: payload2
    }) => {
      handleConversationReadEvent(payload2.conversationId);
    }
  });
}

// src/hooks/use-create-conversation.tsx
import { useMutation as useMutation2 } from "@apollo/client";
import { useSignalPublisher as useSignalPublisher7 } from "@shared-ui/core-signal-manager/context";
import { useProvidedState as useProvidedState20 } from "@shared-ui/provided-state-context";
import { VacConversationCreatedSignal, VacConversationCreateFailedSignal } from "@shared-ui/retail-signals-virtual-agent";

// src/service/create-conversation/create-conversation.tsx
import { gql as gql68 } from "@apollo/client";
var ConversationIdentifiersFragment = gql68`
  fragment ConversationIdentifiersFragment on ConversationIdentifiers {
    conversationId
    participantId
  }
`;
var CreateConversationErrorBannerFragment = gql68`
  fragment CreateConversationErrorBannerFragment on VirtualAgentControlErrorBanner {
    header
    retryText
    text
  }
`;
var CreateConversationErrorFullPageViewFragment = gql68`
  fragment CreateConversationErrorFullPageViewFragment on VirtualAgentControlErrorFullPageView {
    text
    header
    retryText
    icon {
      description
      id
      title
    }
  }
`;
var __CreateConversationMutation = gql68`
  mutation VirtualAgentControlCreateConversationMutation(
    $authenticationConfig: AuthenticationConfigInput
    $context: ContextInput!
    $conversationInitializationConfigs: ConversationInitializationConfigsInput!
  ) {
    virtualAgentControlCreateConversation(
      authenticationConfig: $authenticationConfig
      context: $context
      conversationInitializationConfigs: $conversationInitializationConfigs
    ) {
      ... on CreateConversationSuccess {
        identifiers {
          ...ConversationIdentifiersFragment
        }
      }
      ... on CreateConversationError {
        banner {
          ...CreateConversationErrorBannerFragment
        }
        fullPage {
          ...CreateConversationErrorFullPageViewFragment
        }
      }
    }
  }
  ${ConversationIdentifiersFragment}
  ${CreateConversationErrorBannerFragment}
  ${CreateConversationErrorFullPageViewFragment}
`;

// src/hooks/use-create-conversation.tsx
function getSuccessHandler(dispatch, publishSignal, startTimer, vacId, activeConversationId) {
  return (results, clientOptions) => {
    var _a;
    startTimer(constants_exports.CREATE_CONVERSATION);
    if (results.virtualAgentControlCreateConversation.identifiers) {
      const {
        conversationId,
        participantId
      } = results.virtualAgentControlCreateConversation.identifiers;
      dispatch({
        type: "RELOCATE_MESSAGES_TO_NEW_CONV" /* RELOCATE_MESSAGES_TO_NEW_CONV */,
        payload: {
          conversationId,
          activeConversationId
        }
      });
      dispatch({
        type: "UPDATE_CONVERSATION" /* UPDATE_CONVERSATION */,
        payload: {
          conversationId,
          participantId,
          type: clientOptions.variables.conversationInitializationConfigs.conversationType || "MAIN" /* MAIN */
        }
      });
      dispatch({
        type: "SET_ACTIVE_CONVERSATION_ID" /* SET_ACTIVE_CONVERSATION_ID */,
        payload: {
          vacId,
          activeConversationId: conversationId
        }
      });
      publishSignal(new VacConversationCreatedSignal("VAC_CONVERSATION_CREATED" /* VAC_ConversationCreated */, {
        conversationId,
        participantId
      }));
    } else if ((_a = results.virtualAgentControlCreateConversation) == null ? void 0 : _a.banner) {
      const {
        header,
        text,
        retryText
      } = results.virtualAgentControlCreateConversation.banner;
      dispatch({
        type: "SET_ERROR_BANNER" /* SET_ERROR_BANNER */,
        payload: {
          source: vacId,
          errorBanner: {
            header,
            text,
            retryText
          }
        }
      });
      const event = {
        type: "VAC_CONVERSATION_CREATED_FAIL" /* VAC_ConversationCreateFailed */,
        payload: {
          header,
          text,
          retryText
        }
      };
      publishSignal(event);
    }
  };
}
function getErrorHandler(dispatch, publishSignal, startTimer, vacId, errorString) {
  return results => {
    var _a;
    startTimer(constants_exports.CREATE_CONVERSATION);
    const errorBanner = ((_a = results.virtualAgentControlCreateConversation) == null ? void 0 : _a.banner) || __spreadProps(__spreadValues({}, defaultErrorBanner), {
      header: errorString == null ? void 0 : errorString.somethingWentWrong,
      text: errorString == null ? void 0 : errorString.refreshOrTryLater
    });
    const {
      header,
      text,
      retryText
    } = errorBanner;
    dispatch({
      type: "SET_ERROR_BANNER" /* SET_ERROR_BANNER */,
      payload: {
        source: vacId,
        errorBanner: {
          header,
          text,
          retryText
        }
      }
    });
    publishSignal(new VacConversationCreateFailedSignal("VAC_CONVERSATION_CREATED_FAIL" /* VAC_ConversationCreateFailed */, {
      header,
      text,
      retryText
    }));
  };
}
function useCreateConversation() {
  const {
    startTimer
  } = useTimers();
  const vacId = useVacId();
  const [, dispatch] = useProvidedState20();
  const [chatInstance] = useChatInstanceState();
  const {
    publish
  } = useSignalPublisher7();
  const errorString = use_prefetch_localization_content_default(LocalizationContentKeys.ERROR);
  const [createConversation] = useMutation2(__CreateConversationMutation, {
    onCompleted: getSuccessHandler(dispatch, publish, startTimer, vacId, chatInstance == null ? void 0 : chatInstance.activeConversationId),
    onError: getErrorHandler(dispatch, publish, startTimer, vacId, errorString),
    fetchPolicy: "no-cache"
  });
  return [createConversation];
}

// src/hooks/use-send-conversation-event.tsx
import React92 from "react";
import { useMutation as useMutation3 } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";

// src/service/send-conversation-event/send-conversation-event.tsx
import { gql as gql69 } from "@apollo/client";
var __SendConversationEventMutation = gql69`
  mutation SendVirtualAgentControlConversationEvent(
    $authenticationConfig: AuthenticationConfigInput
    $context: ContextInput!
    $conversationContext: ConversationContextInput!
    $event: VirtualAgentControlConversationEventInput!
  ) {
    sendConversationEvent(authenticationConfig: $authenticationConfig, context: $context, conversationContext: $conversationContext, event: $event) {
      retryText
    }
  }
`;

// src/hooks/use-send-conversation-event.tsx
function doSendEvent(sendEventMutation, sendEventData, dispatch) {
  sendEventMutation(sendEventData).then(() => {
    const {
      event: {
        eventType
      }
    } = sendEventData.variables;
    if (eventType === "CONVERSATION_READ" /* CONVERSATION_READ */) {
      dispatch({
        type: "CLEAR_UNREAD_MESSAGE_COUNT" /* CLEAR_UNREAD_MESSAGE_COUNT */
      });
    }
  });
}
function useSendConversationEvent() {
  const [sendEvent] = useMutation3(__SendConversationEventMutation);
  const {
    context
  } = useBexApi6();
  const [,, conversationContext] = useConversationState();
  const [,, messagesDispatch] = useMessagesState();
  const [authenticationConfig] = useAuthenticationConfig();
  const handleSendEvent = React92.useCallback(event => {
    const sendEventData = {
      variables: __spreadProps(__spreadValues({}, (authenticationConfig == null ? void 0 : authenticationConfig.channelOriginId) && {
        authenticationConfig
      }), {
        context,
        conversationContext,
        event
      })
    };
    doSendEvent(sendEvent, sendEventData, messagesDispatch);
  }, [authenticationConfig, context, messagesDispatch, sendEvent, conversationContext]);
  return [handleSendEvent];
}

// src/components/chat/__private/active-conversation.tsx
import React93 from "react";
import { gql as gql71, useLazyQuery, useQuery as useQuery2 } from "@apollo/client";
import Omit3 from "lodash.omit";
import { EGDSLayoutFlex as EGDSLayoutFlex36 } from "@egds/react-core/layout-flex";
import { EGDSLoader as EGDSLoader3 } from "@egds/react-core/loader";
import { EGDSHeading as EGDSHeading8, EGDSText as EGDSText26 } from "@egds/react-core/text";
import { ScrollChatContentToBottomEvent } from "@egds/react-virtual-agent-control";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
import { useSignalPublisher as useSignalPublisher8, useSignalSubscriber as useSignalSubscriber5 } from "@shared-ui/core-signal-manager/context";
import { useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
import { useProvidedState as useProvidedState21 } from "@shared-ui/provided-state-context";
import { VacConnectedSignal, VacFetchHistoryMessagesFailedSignal } from "@shared-ui/retail-signals-virtual-agent";

// src/service/active-conversation/active-conversation.tsx
import { gql as gql70 } from "@apollo/client";
var __Query = gql70`
  query ActiveConversationQuery(
    $context: ContextInput!
    $conversationContext: ConversationContextInput!
    $authenticationConfig: AuthenticationConfigInput!
    $clientContext: ClientContextInput
  ) {
    virtualAgentControlMessages(
      authenticationConfig: $authenticationConfig
      context: $context
      conversationContext: $conversationContext
      clientContext: $clientContext
    ) {
      meta {
        participants {
          ...ConversationParticipantFragment
        }
      }
      messages {
        ...VirtualAgentControlInboundMessageGroupFragment
        ...VirtualAgentControlMessageSeparatorFragment
        ...VirtualAgentControlOutboundMessageElementGroupFragment
      }
    }
  }
  fragment ConversationParticipantFragment on ConversationParticipant {
    id
    participantType
    participantState
    cpUserId
    user {
      avatarUrl
      firstName
      lastName
      preferredName
    }
  }
  ${VirtualAgentControlInboundMessageGroup.fragment}
  ${VirtualAgentControlMessageSeparator.fragment}
  ${VirtualAgentControlOutboundMessageElementGroup.fragment}
`;

// src/components/chat/__private/active-conversation.tsx
var __Query2 = gql71`
  query VacChatContentQuery(
    $context: ContextInput!
    $conversationContext: ConversationContextInput!
    $authenticationConfig: AuthenticationConfigInput!
    $clientContext: ClientContextInput
  ) {
    vacChatContent(
      authenticationConfig: $authenticationConfig
      context: $context
      conversationContext: $conversationContext
      clientContext: $clientContext
    ) {
      meta {
        participants {
          ...ConversationParticipantFragment
        }
      }
      messages {
        ...VirtualAgentControlInboundMessageGroupFragment
        ...VirtualAgentControlMessageSeparatorFragment
        ...VirtualAgentControlOutboundMessageElementGroupFragment
        ...VirtualAgentControlMessageLoaderFragment
      }
    }
  }
  fragment ConversationParticipantFragment on ConversationParticipant {
    id
    participantType
    participantState
    cpUserId
    user {
      avatarUrl
      firstName
      lastName
      preferredName
    }
  }
  ${VirtualAgentControlInboundMessageGroup.fragment}
  ${VirtualAgentControlMessageSeparator.fragment}
  ${VirtualAgentControlOutboundMessageElementGroup.fragment}
  ${VirtualAgentControlMessageLoader.fragment}
`;
function getSuccessHandler2(dispatch, vacId) {
  return result => {
    if (result == null ? void 0 : result.vacChatContent) {
      dispatch({
        type: "CLEAR_ERRORS" /* CLEAR_ERRORS */,
        payload: {
          source: vacId
        }
      });
    }
  };
}
function getErrorHandler2(dispatch, vacId, state, conversationId) {
  const conversationsById = state.conversationsState.conversationsById[conversationId];
  if (conversationsById == null ? void 0 : conversationsById.conversationHistoryAttributes) {
    return () => {
      dispatch({
        type: "SET_HISTORY_MESSAGES_FETCHING_ERROR" /* SET_HISTORY_MESSAGES_FETCHING_ERROR */,
        payload: {
          source: vacId
        }
      });
    };
  }
  const errorStrings = state.errorsState.orchestrator.offlineLocalizedErrorStrings || {};
  return result => {
    dispatch({
      type: "SET_FULL_PAGE_VIEW" /* SET_FULL_PAGE_VIEW */,
      payload: {
        source: vacId,
        fullPageView: {
          header: errorStrings == null ? void 0 : errorStrings.somethingWentWrong,
          text: errorStrings == null ? void 0 : errorStrings.refreshOrTryLater
        }
      }
    });
  };
}
var ActiveConversation = ({
  skipSsr,
  conversationIntro,
  autoScroll = false
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const [isFirstLog, setIsFirstLog] = React93.useState(true);
  const logging = useLoggerEvents2(EVENTS2);
  const {
    getTime
  } = useTimers();
  const {
    context
  } = useBexApi7();
  const [state, dispatch] = useProvidedState21();
  const vacId = useVacId();
  const [chatInstance] = useChatInstanceState();
  const [conversation, conversationDispatch, conversationContext] = useConversationState();
  const [, conversationMessages, messagesDispatch] = useMessagesState();
  const [, activityIndicators] = useParticipantState();
  const embedded = Boolean(chatInstance == null ? void 0 : chatInstance.embedded);
  const [authenticationConfig] = useAuthenticationConfig();
  const lastWebSocketDisconnectRef = React93.useRef(null);
  const lastScrollHeight = React93.useRef(0);
  const prevMessageIdSetLength = React93.useRef(0);
  const hasHistoryQueryFired = React93.useRef(false);
  const conversationMessagesFetched = React93.useRef(false);
  const {
    publish
  } = useSignalPublisher8();
  const fetchHistoryMessagesStatus = (_a = state.messagesState.messagesByConversationId[conversationContext.conversationId]) == null ? void 0 : _a.fetchHistoryMessagesStatus;
  const messageContent = use_prefetch_localization_content_default(LocalizationContentKeys.MESSAGE);
  const getDurationExcludingIdleTime = React93.useCallback(() => {
    const {
      INIT: INIT2,
      CHAT_MOUNTED: CHAT_MOUNTED2,
      TRIGGER_CLICKED: TRIGGER_CLICKED2
    } = constants_exports;
    if (embedded) {
      return getTime(INIT2);
    }
    return embedded ? getTime(INIT2) : getTime(INIT2) - getTime(CHAT_MOUNTED2) + getTime(TRIGGER_CLICKED2);
  }, [getTime, embedded]);
  const variables = {
    context,
    conversationContext,
    authenticationConfig,
    clientContext: getClientContext()
  };
  const toMessage = (message, index) => /* @__PURE__ */React93.createElement(VirtualAgentControlMessagesMapper, {
    data: message,
    key: `message_${index}`
  });
  const getLoader = () => {
    return /* @__PURE__ */React93.createElement(EGDSLayoutFlex36, {
      space: "one",
      direction: "column",
      alignItems: "center",
      justifyContent: "center",
      blockSize: "full_size"
    }, /* @__PURE__ */React93.createElement(EGDSLoader3, {
      "data-stid": "active-conversation-loader"
    }));
  };
  const getConversationIntro = data2 => {
    if (!data2) {
      return null;
    }
    const {
      primary,
      secondary,
      bottomBorder
    } = data2;
    return /* @__PURE__ */React93.createElement(EGDSLayoutFlex36, {
      direction: "column",
      space: "four"
    }, primary && /* @__PURE__ */React93.createElement(EGDSHeading8, {
      size: 3,
      tag: "h4"
    }, primary), secondary && /* @__PURE__ */React93.createElement(EGDSText26, {
      size: 400
    }, secondary), bottomBorder && /* @__PURE__ */React93.createElement(VirtualAgentControlMessageSeparator, {
      data: bottomBorder
    }));
  };
  const {
    data,
    loading,
    refetch
  } = useQuery2(__Query2, {
    variables,
    ssr: !skipSsr,
    fetchPolicy: "no-cache",
    onError: getErrorHandler2(dispatch, vacId, state, conversationContext.conversationId),
    onCompleted: result => {
      conversationMessagesFetched.current = true;
      getSuccessHandler2(dispatch, vacId)(result);
    }
  });
  const [getPastMessages, pastMessagesResult] = useLazyQuery(__Query);
  React93.useEffect(() => {
    lastWebSocketDisconnectRef.current = state.orchestratorState.lastWebsocketDisconnectTime;
  }, [state.orchestratorState.lastWebsocketDisconnectTime]);
  React93.useEffect(() => {
    const {
      data: pastMessagesData
    } = pastMessagesResult;
    if (pastMessagesData) {
      saveMissedMessages(pastMessagesData);
    }
  }, [pastMessagesResult]);
  React93.useEffect(() => {
    var _a2, _b2;
    if (data) {
      const messages = ((_a2 = data == null ? void 0 : data.vacChatContent) == null ? void 0 : _a2.messages) || [];
      const stateMessages2 = (_b2 = conversationMessages == null ? void 0 : conversationMessages.messages) != null ? _b2 : [];
      if (messages && !stateMessages2.length) {
        messages.forEach(message => {
          if (message.__typename === "VirtualAgentControlMessageLoader") {
            setTimeout(() => {
              messagesDispatch({
                type: "ADD_LOADER_MESSAGE" /* ADD_LOADER_MESSAGE */,
                payload: {
                  conversationId: conversationContext.conversationId,
                  message
                }
              });
            }, 1e3);
          } else if (message.__typename === "VirtualAgentControlMessageSeparator") {
            const timeStamp = message.timeStamp ? new Date(message.timeStamp).toISOString() : null;
            messagesDispatch({
              type: "ADD_SEPERATOR_MESSAGE" /* ADD_SEPERATOR_MESSAGE */,
              payload: {
                conversationId: conversationContext.conversationId,
                primary: message.primary,
                timeStamp
              }
            });
          } else if (message.__typename !== "VirtualAgentControlOutboundMessageGroup") {
            messagesDispatch({
              type: "ADD_MESSAGE" /* ADD_MESSAGE */,
              payload: {
                conversationId: conversationContext.conversationId,
                message,
                messageContent
              }
            });
          }
        });
      }
    }
  }, [data, messagesDispatch, (_b = data == null ? void 0 : data.vacChatContent) == null ? void 0 : _b.messages]);
  function dispatchQuickMessage(lastMessage) {
    if (lastMessage.__typename === "VirtualAgentControlInboundTextMessage" || lastMessage.__typename === "VirtualAgentControlInboundDynamicCardMessage" || lastMessage.__typename === "VirtualAgentControlInboundQuickReplyMessage") {
      if (lastMessage == null ? void 0 : lastMessage.quickReplies) {
        messagesDispatch({
          type: "SET_QUICK_REPLIES" /* SET_QUICK_REPLIES */,
          payload: {
            message: lastMessage == null ? void 0 : lastMessage.quickReplies
          }
        });
      }
    }
  }
  React93.useEffect(() => {
    var _a2, _b2;
    if (data) {
      const activeConversationMessages = ((_a2 = data == null ? void 0 : data.vacChatContent) == null ? void 0 : _a2.messages) || [];
      const lastReceivedMessageTimeStamp = conversationMessages == null ? void 0 : conversationMessages.lastReceivedMessageTimeStamp;
      if (!lastReceivedMessageTimeStamp && activeConversationMessages.length) {
        const filtered = activeConversationMessages.filter(message => message.__typename !== "VirtualAgentControlOutboundMessageGroup");
        const lastMessageGroup = filtered[filtered.length - 1];
        if (lastMessageGroup.__typename !== "VirtualAgentControlMessageSeparator") {
          const {
            messages
          } = lastMessageGroup;
          if (messages.length) {
            const lastMessage = messages[messages.length - 1];
            const timeStamp = (_b2 = lastMessage == null ? void 0 : lastMessage.metadata) == null ? void 0 : _b2.timeStamp;
            messagesDispatch({
              type: "SET_LAST_MESSAGE_TIMESTAMP" /* SET_LAST_MESSAGE_TIMESTAMP */,
              payload: {
                timeStamp
              }
            });
            dispatchQuickMessage(lastMessage);
          }
        } else {
          const {
            primary
          } = lastMessageGroup;
          messagesDispatch({
            type: "SET_LAST_MESSAGE_TIMESTAMP" /* SET_LAST_MESSAGE_TIMESTAMP */,
            payload: {
              timeStamp: primary
            }
          });
        }
      }
    }
  }, [data, messagesDispatch, (_c = data == null ? void 0 : data.vacChatContent) == null ? void 0 : _c.messages, conversationMessages == null ? void 0 : conversationMessages.lastReceivedMessageTimeStamp]);
  const stateMessages = (_d = conversationMessages == null ? void 0 : conversationMessages.messages) != null ? _d : [];
  const stateMessagesLength = stateMessages == null ? void 0 : stateMessages.length;
  const lastGroupMessageCount = stateMessagesLength > 0 ? (_f = (_e = stateMessages[stateMessagesLength - 1]) == null ? void 0 : _e.messages) == null ? void 0 : _f.length : 0;
  const chatContainer = document.getElementById("chat-container-content");
  const messageIdSetLength = (_g = conversationMessages == null ? void 0 : conversationMessages.messageIdSet) == null ? void 0 : _g.size;
  React93.useEffect(() => {
    setTimeout(() => {
      if (chatContainer && lastScrollHeight.current && chatContainer.scrollHeight > lastScrollHeight.current) {
        chatContainer.scrollTop = chatContainer.scrollHeight - lastScrollHeight.current;
      }
    }, 50);
    if (autoScroll && (!lastScrollHeight.current || prevMessageIdSetLength.current < messageIdSetLength || activityIndicators.length)) {
      prevMessageIdSetLength.current = messageIdSetLength;
      lastScrollHeight.current = 0;
      setTimeout(() => {
        document == null ? void 0 : document.dispatchEvent(ScrollChatContentToBottomEvent);
      }, 50);
    }
  }, [autoScroll, (_h = data == null ? void 0 : data.vacChatContent) == null ? void 0 : _h.messages, stateMessagesLength, lastGroupMessageCount, activityIndicators.length]);
  React93.useEffect(() => {
    var _a2;
    if (!isFirstLog) {
      return;
    }
    if ((conversationMessages == null ? void 0 : conversationMessages.messages) || ((_a2 = data == null ? void 0 : data.vacChatContent) == null ? void 0 : _a2.messages)) {
      setIsFirstLog(false);
      logging.INITIALIZATION_MESSAGE.log(payload({
        duration: Math.max(getTime(constants_exports.CREATE_CONVERSATION), 0),
        ssrEnabled: !skipSsr,
        isEmbedded: Boolean(chatInstance == null ? void 0 : chatInstance.embedded)
      }));
      logging.INITIALIZATION_OVERALL.log(payload({
        duration: getDurationExcludingIdleTime(),
        ssrEnabled: !skipSsr,
        isEmbedded: Boolean(chatInstance == null ? void 0 : chatInstance.embedded)
      }));
    }
  }, [conversationMessages == null ? void 0 : conversationMessages.messages, (_i = data == null ? void 0 : data.vacChatContent) == null ? void 0 : _i.messages, isFirstLog, setIsFirstLog, getDurationExcludingIdleTime, logging, skipSsr, getTime, chatInstance == null ? void 0 : chatInstance.embedded]);
  React93.useEffect(() => {
    var _a2, _b2;
    const messages = ((_a2 = data == null ? void 0 : data.vacChatContent) == null ? void 0 : _a2.messages) || [];
    const lastMessageGroup = messages.length > 0 ? messages[messages.length - 1] : null;
    if ((lastMessageGroup == null ? void 0 : lastMessageGroup.__typename) === "VirtualAgentControlInboundMessageGroup") {
      const lastInboundMessageList = lastMessageGroup.messages || [];
      const lastInboundMessage = lastInboundMessageList[lastInboundMessageList.length - 1];
      if ((_b2 = lastInboundMessage == null ? void 0 : lastInboundMessage.stateUpdates) == null ? void 0 : _b2.chatInput) {
        conversationDispatch({
          type: "SET_FOOTER_STATE" /* SET_FOOTER_STATE */,
          payload: {
            chatFooterState: lastInboundMessage.stateUpdates.chatInput
          }
        });
      }
    }
  }, [data, conversationDispatch]);
  React93.useEffect(() => {
    var _a2, _b2, _c2;
    const participants = (_c2 = (_b2 = (_a2 = data == null ? void 0 : data.vacChatContent) == null ? void 0 : _a2.meta) == null ? void 0 : _b2.participants) != null ? _c2 : [];
    if (participants == null ? void 0 : participants.length) {
      dispatch({
        type: "SET_PARTICIPANTS" /* SET_PARTICIPANTS */,
        payload: {
          participants,
          conversationId: conversationContext == null ? void 0 : conversationContext.conversationId
        }
      });
    }
  }, [(_k = (_j = data == null ? void 0 : data.vacChatContent) == null ? void 0 : _j.meta) == null ? void 0 : _k.participants, dispatch, conversationContext == null ? void 0 : conversationContext.conversationId]);
  const saveMissedMessages = React93.useCallback(refetchedData => {
    var _a2;
    const refetchedMessages = ((_a2 = refetchedData == null ? void 0 : refetchedData.virtualAgentControlMessages) == null ? void 0 : _a2.messages) || [];
    if (refetchedMessages.length) {
      refetchedMessages.forEach(message => {
        if (message.__typename === "VirtualAgentControlMessageSeparator") {
          const timeStamp = message.timeStamp ? new Date(message.timeStamp).toISOString() : null;
          messagesDispatch({
            type: "ADD_SEPERATOR_MESSAGE" /* ADD_SEPERATOR_MESSAGE */,
            payload: {
              primary: message.primary,
              timeStamp
            }
          });
        } else {
          messagesDispatch({
            type: "ADD_MESSAGE" /* ADD_MESSAGE */,
            payload: {
              conversationId: conversationContext.conversationId,
              message,
              messageContent
            }
          });
          dispatchQuickMessage(message);
        }
      });
    }
  }, []);
  const saveHistoryMessages = React93.useCallback(historyMessages => {
    dispatch({
      type: "ADD_HISTORY_MESSAGES" /* ADD_HISTORY_MESSAGES */,
      payload: {
        conversationId: conversationContext.conversationId,
        messages: historyMessages
      }
    });
  }, []);
  React93.useEffect(() => {
    if (fetchHistoryMessagesStatus === "failed") {
      dispatch({
        type: "SET_HISTORY_MESSAGES_FETCHING_ERROR" /* SET_HISTORY_MESSAGES_FETCHING_ERROR */,
        payload: {
          source: vacId,
          chatHistoryFetchingError: true
        }
      });
    } else {
      dispatch({
        type: "CLEAR_ERRORS" /* CLEAR_ERRORS */,
        payload: {
          source: vacId
        }
      });
    }
  }, [fetchHistoryMessagesStatus]);
  const fetchHistoryMessages = React93.useCallback(async conversationHistoryAttributes => {
    var _a2;
    const updatedVariables = {
      context,
      conversationContext: __spreadProps(__spreadValues({}, conversationContext), {
        conversationHistoryAttributes
      }),
      authenticationConfig,
      clientContext: getClientContext()
    };
    try {
      const {
        data: fetchedHistoryData,
        loading: historyLoading
      } = await refetch(__spreadValues({}, updatedVariables));
      if (fetchedHistoryData && !historyLoading) {
        hasHistoryQueryFired.current = false;
        saveHistoryMessages((_a2 = fetchedHistoryData == null ? void 0 : fetchedHistoryData.vacChatContent) == null ? void 0 : _a2.messages);
        dispatch({
          type: "FETCH_HISTORY_MESSAGES_STATUS" /* FETCH_HISTORY_MESSAGES_STATUS */,
          payload: {
            status: "success",
            conversationId: conversationContext.conversationId
          }
        });
      }
    } catch (e) {
      publish(new VacFetchHistoryMessagesFailedSignal("VAC_FETCH_HISTORY_MESSAGES_FAILED" /* VAC_FetchHistoryMessagesFailed */, null));
      hasHistoryQueryFired.current = false;
      dispatch({
        type: "FETCH_HISTORY_MESSAGES_STATUS" /* FETCH_HISTORY_MESSAGES_STATUS */,
        payload: {
          status: "failed",
          conversationId: conversationContext.conversationId
        }
      });
    }
  }, []);
  useSignalSubscriber5("VAC_CONNECTED" /* VAC_Connected */, VacConnectedSignal, {
    onSuccess: () => {
      if (!lastWebSocketDisconnectRef.current) {
        return;
      }
      const historyPaddingMillis = 3e5;
      const lastWebSocketDisconnectTime = lastWebSocketDisconnectRef.current;
      const sentAfter = (/* @__PURE__ */new Date()).getTime() - lastWebSocketDisconnectTime + historyPaddingMillis;
      const updatedVariables = {
        context,
        conversationContext: __spreadProps(__spreadValues({}, conversationContext), {
          sentAfterOffset: sentAfter
        }),
        authenticationConfig,
        clientContext: getClientContext()
      };
      getPastMessages({
        variables: updatedVariables,
        ssr: !skipSsr,
        fetchPolicy: "no-cache",
        onError: getErrorHandler2(dispatch, vacId, state, updatedVariables),
        onCompleted: getSuccessHandler2(dispatch, vacId)
      });
    }
  });
  React93.useEffect(() => {
    var _a2;
    const conversationHistoryAttributes = (_a2 = conversation == null ? void 0 : conversation.conversationHistoryAttributes) == null ? void 0 : _a2.map(attr => Omit3(attr, "__typename"));
    if (!hasHistoryQueryFired.current && chatContainer && (conversationMessages == null ? void 0 : conversationMessages.isMessageLoaderVisible)) {
      hasHistoryQueryFired.current = true;
      lastScrollHeight.current = chatContainer.scrollHeight;
      fetchHistoryMessages(conversationHistoryAttributes);
    }
  }, [conversationMessages == null ? void 0 : conversationMessages.isMessageLoaderVisible]);
  if (loading && !conversationMessagesFetched.current) {
    return /* @__PURE__ */React93.createElement(React93.Fragment, null, conversationIntro ? /* @__PURE__ */React93.createElement(React93.Fragment, null, getConversationIntro(conversationIntro)) : getLoader());
  }
  return /* @__PURE__ */React93.createElement("div", null, getConversationIntro(conversationIntro), /* @__PURE__ */React93.createElement(EGDSLayoutFlex36, {
    direction: "column",
    space: "four"
  }, (_l = conversationMessages == null ? void 0 : conversationMessages.messages) == null ? void 0 : _l.map(toMessage)));
};
ActiveConversation.displayName = "ActiveConversation";

// src/components/chat/chat.tsx
function getLoaderComponent(isVisible, embedded) {
  return /* @__PURE__ */React94.createElement(ChatContainer, {
    visible: isVisible,
    embedded,
    padded: true
  }, /* @__PURE__ */React94.createElement(ChatContainerContent, null, /* @__PURE__ */React94.createElement(EGDSLayoutFlex37, {
    space: "one",
    direction: "column",
    alignItems: "center",
    justifyContent: "center",
    blockSize: "full_size"
  }, /* @__PURE__ */React94.createElement(EGDSLoader4, null))));
}
function getSuccessHandler3(dispatch, vacId, modeOptions) {
  return result => {
    var _a, _b, _c, _d, _e, _f;
    if ((_a = result == null ? void 0 : result.virtualAgentControl) == null ? void 0 : _a.chatConfig) {
      const {
        chatConfig
      } = result.virtualAgentControl;
      const setChatConfigData = {
        vacId,
        chatConfig: {
          partnerGuid: chatConfig.channelOrigin.partnerGuid,
          channelOriginId: chatConfig.channelOrigin.channelOriginId,
          enableHistory: ((_b = chatConfig.chatCapabilities) == null ? void 0 : _b.enableHistory) || false,
          notificationConfig: ((_c = chatConfig.chatCapabilities) == null ? void 0 : _c.notificationConfig) || {},
          presenceConfig: ((_d = chatConfig.chatCapabilities) == null ? void 0 : _d.presenceConfig) || {},
          participantTypesForEventMarkers: ((_e = chatConfig.chatCapabilities) == null ? void 0 : _e.participantTypesForEventMarkers) || {},
          showParticipantEventMarker: ((_f = chatConfig.chatCapabilities) == null ? void 0 : _f.showParticipantEventMarker) || {},
          modeOptions
        }
      };
      dispatch({
        type: "SET_CHAT_CONFIG" /* SET_CHAT_CONFIG */,
        payload: setChatConfigData
      });
    }
    dispatch({
      type: "SET_INITIALIZATION_LOADING" /* SET_INITIALIZATION_LOADING */,
      payload: {
        vacId,
        initializationLoading: false
      }
    });
  };
}
function getErrorHandler3(dispatch, vacId, state) {
  var _a;
  const errorStrings = ((_a = state.errorsState.orchestrator) == null ? void 0 : _a.offlineLocalizedErrorStrings) || {};
  return result => {
    dispatch({
      type: "SET_INITIALIZATION_LOADING" /* SET_INITIALIZATION_LOADING */,
      payload: {
        vacId,
        initializationLoading: false
      }
    });
    dispatch({
      type: "SET_FULL_PAGE_VIEW" /* SET_FULL_PAGE_VIEW */,
      payload: {
        source: vacId,
        fullPageView: {
          header: errorStrings == null ? void 0 : errorStrings.somethingWentWrong,
          text: errorStrings == null ? void 0 : errorStrings.refreshOrTryLater
        }
      }
    });
  };
}
function getVirtualAgentOpenedAnalytic(chatAnalytics) {
  if (chatAnalytics == null ? void 0 : chatAnalytics.length) {
    const virtualAgentOpenedAnalytic = chatAnalytics.find(analytics => analytics.eventName === "virtual_agent.opened");
    if (virtualAgentOpenedAnalytic) {
      return getEventPayloadAnalytics(virtualAgentOpenedAnalytic.payload, virtualAgentOpenedAnalytic.eventName, virtualAgentOpenedAnalytic.eventVersion);
    }
  }
  return null;
}
var Chat = ({
  skipSsr,
  embedded = false,
  autoScroll = false,
  channelOriginId,
  modeOptions
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const [isFirstLog, setIsFirstLog] = React94.useState(true);
  const logging = useLoggerEvents3(EVENTS2);
  const {
    publish
  } = useSignalPublisher9();
  const {
    startTimer,
    getTime
  } = useTimers();
  const chatDialogRoot = React94.useRef();
  const dialogProviderConfig = getDialogProviderConfig(chatDialogRoot);
  React94.useEffect(() => {
    startTimer(constants_exports.CHAT_MOUNTED);
  }, []);
  useSignalSubscriber6("VAC_CONNECTED" /* VAC_Connected */, VacConnectedSignal2, {
    onSuccess: (/* istanbul ignore next */
    () => {
      logging.INITIALIZATION_CONNECTED.log(payload({
        duration: getTime(constants_exports.INIT),
        ssrEnabled: !skipSsr,
        isEmbedded: embedded
      }));
    })
  });
  useSignalSubscriber6("VAC_CHAT_MESSAGE_SENT" /* VAC_ChatMsgSent */, VacChatMessageSentSignal2, {
    onSuccess: (/* istanbul ignore next */
    signal => {
      const {
        isRetry
      } = signal.payload;
      if (isRetry) {
        document.dispatchEvent(ScrollChatContentToBottomEvent2);
      }
    })
  });
  const {
    context
  } = useBexApi8();
  const vacId = useVacId();
  const [state, dispatch] = useProvidedState22();
  const [isSettingsVisible, setIsSettingsVisible] = useState5(false);
  const [toastText, setToastText] = useState5("");
  const [conversation, conversationDispatch, conversationContext] = useConversationState();
  const [chatInstance] = useChatInstanceState();
  const [authenticationConfig] = useAuthenticationConfig(channelOriginId);
  useHeartbeat();
  useParticipantEventMarkers();
  const handlers = {
    onCompleted: getSuccessHandler3(dispatch, vacId, modeOptions == null ? void 0 : modeOptions.context),
    onError: getErrorHandler3(dispatch, vacId, state)
  };
  const {
    query: {
      data,
      error,
      loading
    }
  } = useChatQuery(skipSsr, embedded, modeOptions == null ? void 0 : modeOptions.context, channelOriginId, handlers);
  const [isVisible, setIsVisible] = React94.useState(false);
  const [handleSend] = useSendMessage();
  const [handleSendEvent] = useSendConversationEvent();
  const [createConversation] = useCreateConversation();
  const {
    conversationId: activeConversationId,
    attributes
  } = conversationContext || {};
  const activeParticipantId = conversationContext.participantId;
  const wasCreateConversationCalled = React94.useRef(false);
  const [lastSignalPayload, setLastSignalPayload] = React94.useState(null);
  const subscriptionId = (_c = (_b = (_a = state == null ? void 0 : state.orchestratorState) == null ? void 0 : _a.vacConfig) == null ? void 0 : _b.websocket) == null ? void 0 : _c.subscriptionId;
  useConversationReadEvent(isVisible, embedded);
  const handleCreateConversation = async customInitConfig => {
    var _a2;
    const baseConfig = {
      forceNewConversation: false,
      mode: "CREATE_CONVERSATION" /* CREATE_CONVERSATION */,
      conversationAttributes: Object.entries(attributes || {}).map(([key, value]) => ({
        key,
        value
      })),
      participant: {
        subscriptionId
      },
      conversationType: (_a2 = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _a2.conversationType
    };
    const finalConfig = __spreadValues(__spreadValues({}, baseConfig), customInitConfig);
    await (createConversation == null ? void 0 : createConversation({
      variables: __spreadProps(__spreadValues({}, (authenticationConfig == null ? void 0 : authenticationConfig.channelOriginId) && {
        authenticationConfig
      }), {
        context,
        conversationInitializationConfigs: finalConfig
      })
    }));
  };
  useOperationsRegistry({
    ["SEND_MESSAGE" /* SEND_MESSAGE */]: messageData => handleSend(messageData),
    ["TYPING_EVENT" /* TYPING_EVENT */]: event => handleSendEvent(event),
    ["SHOW_TOAST" /* SHOW_TOAST */]: text => setToastText(text),
    ["CREATE_CONVERSATION" /* CREATE_CONVERSATION */]: (/* istanbul ignore next */
    () => handleCreateConversation())
  });
  const handleMenuOpenSettings = () => {
    setIsSettingsVisible(true);
  };
  const handleMenuCloseSettings = () => {
    setIsSettingsVisible(false);
  };
  const handleSkipLink = e => {
    e.preventDefault();
    document == null ? void 0 : document.dispatchEvent(ScrollChatContentToBottomEvent2);
  };
  use_notification_sound_default(vacId);
  const sendEvent = useOperation("TYPING_EVENT" /* TYPING_EVENT */);
  React94.useEffect(() => {
    if (embedded && subscriptionId) {
      publish(new VacChatWindowVisibleSignal("VAC_CHAT_WINDOW_VISIBLE" /* VAC_ChatWindowVisible */, null));
    }
  }, [embedded, subscriptionId]);
  React94.useEffect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2;
    if ((modeOptions == null ? void 0 : modeOptions.mode) === "RESUME_CONVERSATION" /* RESUME_CONVERSATION */) {
      dispatch({
        type: "CLEAR_MESSAGES" /* CLEAR_MESSAGES */,
        payload: {
          conversationId: (_a2 = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _a2.conversationId
        }
      });
      dispatch({
        type: "UPDATE_CONVERSATION" /* UPDATE_CONVERSATION */,
        payload: {
          conversationId: (_b2 = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _b2.conversationId,
          participantId: (_c2 = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _c2.participantId,
          type: (_d2 = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _d2.conversationType
        }
      });
      if (((_e2 = state == null ? void 0 : state.orchestratorState) == null ? void 0 : _e2.initializationStatus) === "DONE" /* DONE */) {
        dispatch({
          type: "SET_ACTIVE_CONVERSATION_ID" /* SET_ACTIVE_CONVERSATION_ID */,
          payload: {
            vacId,
            activeConversationId: (_f2 = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _f2.conversationId
          }
        });
      }
    }
  }, [(_d = state == null ? void 0 : state.orchestratorState) == null ? void 0 : _d.initializationStatus, (_e = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _e.conversationId, (_f = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _f.participantId, modeOptions == null ? void 0 : modeOptions.mode, dispatch, vacId]);
  useSignalSubscriber6("VAC_IBM_CREATE_CONVERSATION" /* VAC_IBM_Create_Conversation */, VacCreateConversationSignal, {
    onSuccess: (/* istanbul ignore next */
    async signal => {
      var _a2, _b2, _c2;
      const {
        conversationAttributes,
        intentData,
        silent = false
      } = signal.payload;
      const {
        messageType
      } = intentData;
      if ((authenticationConfig == null ? void 0 : authenticationConfig.authToken) && (
      // provided by orchestrator
      authenticationConfig == null ? void 0 : authenticationConfig.channelOriginId)) {
        if (messageType === VirtualAgentControlMessageType.POSTBACK) {
          if (!activeConversationId && data && (modeOptions == null ? void 0 : modeOptions.mode) === "CREATE_CONVERSATION" /* CREATE_CONVERSATION */ && !wasCreateConversationCalled.current) {
            await handleCreateConversation({
              forceNewConversation: false,
              mode: "CREATE_CONVERSATION" /* CREATE_CONVERSATION */,
              conversationType: (_a2 = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _a2.conversationType,
              conversationAttributes: [...conversationAttributes, {
                key: "traceId",
                value: uuidv49()
              }]
            });
            wasCreateConversationCalled.current = true;
            setLastSignalPayload(intentData);
          } else if (activeConversationId && activeParticipantId && data && wasCreateConversationCalled.current) {
            const messageData = __spreadProps(__spreadValues({}, intentData), {
              message: intentData.text,
              messageTriggerLocation: "EXTERNAL" /* EXTERNAL */
            });
            handleSend == null ? void 0 : handleSend(messageData);
          }
        } else if (!activeConversationId && data && (modeOptions == null ? void 0 : modeOptions.mode) === "CREATE_CONVERSATION" /* CREATE_CONVERSATION */ && !wasCreateConversationCalled.current) {
          handleCreateConversation({
            forceNewConversation: false,
            mode: "CREATE_CONVERSATION" /* CREATE_CONVERSATION */,
            conversationType: (_b2 = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _b2.conversationType,
            conversationAttributes: [...conversationAttributes, {
              key: "traceId",
              value: uuidv49()
            }],
            intentData: __spreadProps(__spreadValues({}, intentData), {
              umid: uuidv49()
            })
          });
          wasCreateConversationCalled.current = true;
        } else {
          handleCreateConversation({
            forceNewConversation: false,
            mode: "RESUME_CONVERSATION" /* RESUME_CONVERSATION */,
            conversation: {
              conversationId: activeConversationId
            },
            participant: {
              participantId: activeParticipantId,
              subscriptionId
            },
            conversationType: (_c2 = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _c2.conversationType,
            conversationAttributes: [...conversationAttributes, {
              key: "traceId",
              value: uuidv49()
            }],
            intentData: __spreadProps(__spreadValues({}, intentData), {
              umid: uuidv49()
            })
          });
        }
      }
      if (!isVisible) {
        publish(new VacChatWindowVisibleSignal("VAC_CHAT_WINDOW_VISIBLE" /* VAC_ChatWindowVisible */, null));
        if (!silent) {
          setIsVisible(true);
        }
      }
    })
  });
  useSignalSubscriber6("VAC_CONVERSATION_CREATED" /* VAC_ConversationCreated */, VacConversationCreatedSignal2, {
    onSuccess: (/* istanbul ignore next */
    async () => {
      if (activeConversationId && (lastSignalPayload == null ? void 0 : lastSignalPayload.messageType) === VirtualAgentControlMessageType.POSTBACK) {
        const messageData = __spreadProps(__spreadValues({}, lastSignalPayload.intentData), {
          message: lastSignalPayload.text,
          messageTriggerLocation: "EXTERNAL" /* EXTERNAL */
        });
        if (!Object.keys(state.messagesState.messagesByConversationId).length) {
          const timeStamp = startOfDayUTC(/* @__PURE__ */new Date()).toISOString();
          dispatch({
            type: "ADD_SEPERATOR_MESSAGE" /* ADD_SEPERATOR_MESSAGE */,
            payload: {
              primary: new Date(Date.now()).toUTCString(),
              conversationId: activeConversationId,
              timeStamp
            }
          });
        }
        handleSend == null ? void 0 : handleSend(messageData);
        setLastSignalPayload(null);
      }
    })
  });
  React94.useEffect(() => {
    var _a2;
    if (!activeConversationId && data && (isVisible || embedded) && (authenticationConfig == null ? void 0 : authenticationConfig.authToken) && (
    // provided by orchestrator
    authenticationConfig == null ? void 0 : authenticationConfig.channelOriginId) &&
    // provided by virtualAgentControl query
    ((_a2 = state == null ? void 0 : state.orchestratorState) == null ? void 0 : _a2.initializationStatus) === "DONE" /* DONE */ && (modeOptions == null ? void 0 : modeOptions.mode) === "CREATE_CONVERSATION" /* CREATE_CONVERSATION */ && !wasCreateConversationCalled.current) {
      handleCreateConversation();
      wasCreateConversationCalled.current = true;
    }
  }, [data, isVisible, conversationContext, context, attributes, activeConversationId, authenticationConfig, subscriptionId, embedded, (_g = state == null ? void 0 : state.orchestratorState) == null ? void 0 : _g.initializationStatus, modeOptions == null ? void 0 : modeOptions.mode, (_h = modeOptions == null ? void 0 : modeOptions.context) == null ? void 0 : _h.conversationType, lastSignalPayload]);
  React94.useEffect(() => {
    dispatch({
      type: "SET_EMBEDDED" /* SET_EMBEDDED */,
      payload: {
        vacId,
        embedded
      }
    });
  }, [embedded]);
  React94.useEffect(() => {
    if (!isFirstLog) {
      return;
    }
    const {
      INITIALIZATION_CHAT,
      INITIALIZATION_TRIGGER
    } = logging;
    if (embedded) {
      INITIALIZATION_CHAT.log(payload({
        duration: getTime(constants_exports.INIT),
        ssrEnabled: !skipSsr,
        isEmbedded: embedded
      }));
    } else {
      INITIALIZATION_TRIGGER.log(payload({
        duration: getTime(constants_exports.INIT),
        ssrEnabled: !skipSsr,
        isEmbedded: embedded
      }));
    }
    setIsFirstLog(false);
  }, [embedded, isFirstLog, setIsFirstLog, logging]);
  const getHeader = (header2, isEmbedded2) => {
    if (header2.__typename === "VirtualAgentControlToolbar") {
      return isEmbedded2 ? null : /* @__PURE__ */React94.createElement(VirtualAgentControlToolbar, {
        data: header2,
        onClose: () => setIsVisible(false)
      });
    }
    return /* @__PURE__ */React94.createElement(VirtualAgentControlChatHeader, {
      data: header2,
      onMinimize: () => setIsVisible(false),
      embedded: isEmbedded2,
      onOpenSettings: handleMenuOpenSettings
    });
  };
  if ((chatInstance == null ? void 0 : chatInstance.initializationLoading) || !authenticationConfig.channelOriginId) {
    return getLoaderComponent(isVisible, embedded);
  }
  if (((_j = (_i = state == null ? void 0 : state.errorsState) == null ? void 0 : _i[ORCHESTRATOR]) == null ? void 0 : _j.active) && ((_k = state == null ? void 0 : state.orchestratorState) == null ? void 0 : _k.initializationStatus) === "FAILED" /* FAILED */ || !(data == null ? void 0 : data.virtualAgentControl)) {
    return /* @__PURE__ */React94.createElement(ChatContainer, {
      visible: isVisible,
      embedded,
      padded: true
    }, /* @__PURE__ */React94.createElement(ChatContainerContent, null, /* @__PURE__ */React94.createElement(VirtualAgentControlFullPageErrorView, null)));
  }
  const {
    virtualAgentControl
  } = data;
  const {
    trigger,
    chat: {
      header,
      conversationIntro,
      footer,
      analytics,
      landmarkChatContentAccessibilityLabel,
      skipToMostRecentMessageAccessibilityLabel
    },
    settingsMenu
  } = virtualAgentControl;
  const isEmbedded = embedded || !trigger;
  const impressionAnalytics = getVirtualAgentOpenedAnalytic(analytics);
  const {
    visuallyHiddenHeaderAccessibilityLabel,
    landmarkHeaderAccessibilityLabel
  } = header || {};
  const {
    landmarkFooterAccessibilityLabel
  } = footer;
  return /* @__PURE__ */React94.createElement(React94.Fragment, null, !isVisible && !isEmbedded && trigger && /* @__PURE__ */React94.createElement(VirtualAgentControlTrigger, {
    data: trigger,
    onClick: () => {
      setIsVisible(true);
      startTimer(constants_exports.TRIGGER_CLICKED);
      publish(new VacChatWindowVisibleSignal("VAC_CHAT_WINDOW_VISIBLE" /* VAC_ChatWindowVisible */, null));
    }
  }), /* @__PURE__ */React94.createElement(EGDSHeading9, {
    tag: "h1",
    className: "is-visually-hidden"
  }, visuallyHiddenHeaderAccessibilityLabel), /* @__PURE__ */React94.createElement(ChatContainer, {
    visible: isVisible,
    embedded: isEmbedded,
    padded: true
  }, header && /* @__PURE__ */React94.createElement(ChatContainerHeader, {
    ariaLabel: landmarkHeaderAccessibilityLabel
  }, getHeader(header, isEmbedded), /* @__PURE__ */React94.createElement(VirtualAgentControlErrorBanner, null), embedded && /* @__PURE__ */React94.createElement(VirtualAgentControlMenuSettings, {
    settingsMenu,
    handleMenuCloseSettings,
    isSettingsVisible
  })), /* @__PURE__ */React94.createElement(ChatContainerContent, {
    ariaLabel: landmarkChatContentAccessibilityLabel
  }, /* @__PURE__ */React94.createElement(DialogProvider, {
    value: dialogProviderConfig
  }, /* @__PURE__ */React94.createElement(EGDSSkipLink, {
    items: [{
      attributes: {
        tabindex: 0
      },
      className: "uitk-list-item",
      onClick: handleSkipLink,
      label: skipToMostRecentMessageAccessibilityLabel,
      typeAnchor: true
    }]
  }), activeConversationId && /* @__PURE__ */React94.createElement(EgClickstreamImpressionTracker2, {
    eventData: buildClickstreamAdditionalContextPayload("VIRTUAL_AGENT_OPENED", conversation.conversationId, conversation.type, impressionAnalytics == null ? void 0 : impressionAnalytics.additionalContext)
  }, /* @__PURE__ */React94.createElement(ActiveConversation, {
    inputs: {},
    conversationIntro,
    autoScroll
  })), /* @__PURE__ */React94.createElement(VirtualAgentControlTypingIndicator, null), /* @__PURE__ */React94.createElement(VirtualAgentControlFullPageErrorView, {
    embedded,
    onClose: () => setIsVisible(false)
  }), !embedded && /* @__PURE__ */React94.createElement(VirtualAgentControlMenuSettings, {
    settingsMenu,
    handleMenuCloseSettings,
    isSettingsVisible
  }))), /* @__PURE__ */React94.createElement(ChatContainerFooter, {
    ariaLabel: landmarkFooterAccessibilityLabel
  }, /* @__PURE__ */React94.createElement("div", {
    id: "chat-dialog",
    ref: chatDialogRoot
  }), /* @__PURE__ */React94.createElement(DialogProvider, {
    value: dialogProviderConfig
  }, /* @__PURE__ */React94.createElement(EGDSSpacing25, {
    padding: "two"
  }, /* @__PURE__ */React94.createElement("div", null, /* @__PURE__ */React94.createElement(VirtualAgentControlQuickReplies, null), /* @__PURE__ */React94.createElement(VirtualAgentControlChatFooter, {
    data: footer
  }))), /* @__PURE__ */React94.createElement(EGDSToast, {
    show: toastText.length > 0,
    onDismiss: () => setToastText(""),
    verticalOffset: 50
  }, toastText)))), activeConversationId && /* @__PURE__ */React94.createElement(VacSignalSubscriber, null));
};
Chat.displayName = "sharedui-Chat";

// src/components/chat/chat-trigger.tsx
import React95 from "react";
var ChatTrigger = ({
  skipSsr,
  onClick,
  inputs
}) => {
  var _a, _b;
  const {
    authenticationConfig: authenticationConfigInput
  } = inputs || {};
  const channelOriginId = (_a = authenticationConfigInput == null ? void 0 : authenticationConfigInput.channelOriginId) != null ? _a : void 0;
  const [authenticationConfig] = useAuthenticationConfig(channelOriginId);
  const {
    query: {
      data,
      error,
      loading
    }
  } = useChatTriggerQuery(skipSsr, authenticationConfig);
  if (loading || error || !((_b = data == null ? void 0 : data.virtualAgentControl) == null ? void 0 : _b.trigger)) {
    return null;
  }
  const {
    virtualAgentControl: {
      trigger
    }
  } = data;
  return /* @__PURE__ */React95.createElement(VirtualAgentControlTrigger, {
    data: trigger,
    onClick
  });
};
ChatTrigger.displayName = "sharedui-ChatTrigger";

// src/components/chat/chat-window.tsx
import React96 from "react";
import { EGDSSpacing as EGDSSpacing26 } from "@egds/react-core/spacing";
import { ChatContainer as ChatContainer2, ChatContainerContent as ChatContainerContent2, ChatContainerFooter as ChatContainerFooter2, ChatContainerHeader as ChatContainerHeader2 } from "@egds/react-virtual-agent-control";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
import { useProvidedState as useProvidedState23 } from "@shared-ui/provided-state-context";
var ChatWindow = ({
  skipSsr,
  onClose,
  channelOriginId
}) => {
  var _a, _b, _c;
  const {
    context
  } = useBexApi9();
  const [authenticationConfig] = useAuthenticationConfig(channelOriginId);
  const {
    query: {
      data,
      error,
      loading
    }
  } = useChatWindowQuery(skipSsr, authenticationConfig);
  const [state] = useProvidedState23();
  const [,, conversationContext] = useConversationState();
  const [handleSend] = useSendMessage();
  const [handleSendEvent] = useSendConversationEvent();
  const [createConversation] = useCreateConversation();
  const {
    conversationId: activeConversationId,
    attributes
  } = conversationContext || {};
  const subscriptionId = (_c = (_b = (_a = state == null ? void 0 : state.orchestratorState) == null ? void 0 : _a.vacConfig) == null ? void 0 : _b.websocket) == null ? void 0 : _c.subscriptionId;
  useOperationsRegistry({
    ["SEND_MESSAGE" /* SEND_MESSAGE */]: messageData => handleSend(messageData),
    ["TYPING_EVENT" /* TYPING_EVENT */]: event => handleSendEvent(event)
  });
  React96.useEffect(() => {
    if (!activeConversationId && data) {
      createConversation == null ? void 0 : createConversation({
        variables: __spreadProps(__spreadValues({}, (authenticationConfig == null ? void 0 : authenticationConfig.channelOriginId) && {
          authenticationConfig
        }), {
          context,
          conversationInitializationConfigs: {
            forceNewConversation: false,
            mode: "CREATE_CONVERSATION" /* CREATE_CONVERSATION */,
            participant: {
              subscriptionId
            }
          }
        })
      });
    }
  }, [data, conversationContext, createConversation, context, attributes, activeConversationId, authenticationConfig, subscriptionId]);
  const handleClose = () => onClose == null ? void 0 : onClose();
  const getHeader = header2 => {
    if (header2.__typename === "VirtualAgentControlToolbar") {
      return /* @__PURE__ */React96.createElement(VirtualAgentControlToolbar, {
        data: header2,
        onClose: handleClose
      });
    }
    return /* @__PURE__ */React96.createElement(VirtualAgentControlChatHeader, {
      data: header2,
      embedded: true,
      onMinimize: handleClose
    });
  };
  if (loading || error || !(data == null ? void 0 : data.virtualAgentControl)) {
    return null;
  }
  const {
    virtualAgentControl
  } = data;
  const {
    chat: {
      header,
      conversationIntro,
      footer
    }
  } = virtualAgentControl;
  return /* @__PURE__ */React96.createElement(React96.Fragment, null, /* @__PURE__ */React96.createElement(ChatContainer2, {
    visible: true,
    embedded: true,
    padded: true
  }, header && /* @__PURE__ */React96.createElement(ChatContainerHeader2, null, getHeader(header), /* @__PURE__ */React96.createElement(VirtualAgentControlErrorBanner, null)), /* @__PURE__ */React96.createElement(ChatContainerContent2, null, activeConversationId && /* @__PURE__ */React96.createElement(ActiveConversation, {
    inputs: {},
    conversationIntro
  }), /* @__PURE__ */React96.createElement(VirtualAgentControlTypingIndicator, null), /* @__PURE__ */React96.createElement(VirtualAgentControlFullPageErrorView, null)), /* @__PURE__ */React96.createElement(ChatContainerFooter2, null, /* @__PURE__ */React96.createElement(EGDSSpacing26, {
    padding: "two"
  }, /* @__PURE__ */React96.createElement("div", null, /* @__PURE__ */React96.createElement(VirtualAgentControlQuickReplies, null), /* @__PURE__ */React96.createElement(VirtualAgentControlChatFooter, {
    data: footer
  }))))), activeConversationId && /* @__PURE__ */React96.createElement(VacSignalSubscriber, null));
};
ChatWindow.displayName = "sharedui-ChatWindow";

// src/components/index.ts
var Chat2 = withRegisteredOperations(withVacId(withAttachment(Chat)));
var ChatTrigger2 = withRegisteredOperations(withVacId(ChatTrigger));
var ChatWindow2 = withRegisteredOperations(withVacId(ChatWindow));
export { Chat2 as Chat, ChatTrigger2 as ChatTrigger, ChatWindow2 as ChatWindow };
/* istanbul ignore file -- @preserve */
// istanbul ignore next -- @preserve
/* istanbul ignore next -- @preserve */
//# sourceMappingURL=index.js.map